// import React, { useState, useEffect } from "react";

// import {
//   Box,
//   Typography,
//   Button,
//   TextField,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Chip,
//   IconButton,
//   Paper,
//   Grid,
//   Card,
//   CardContent,
//   CardHeader,
//   Tabs,
//   Tab,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Stepper,
//   Step,
//   StepLabel,
//   Alert,
//   CircularProgress,
//   Divider,
//   Switch,
//   FormControlLabel,
//   AppBar,
//   Toolbar,
//   Avatar,
//   List,
//   ListItem,
//   ListItemText,
//   ListItemIcon,
//   useTheme,
//   useMediaQuery,
//   Container,
//   Fab,
//   Breadcrumbs,
//   Link,
//   Stack,
// } from "@mui/material";
// import {
//   ArrowBack as ArrowBackIcon,
//   Edit as EditIcon,
//   Save as SaveIcon,
//   Cancel as CancelIcon,
//   Pets as PetsIcon,
//   CheckCircle as CheckCircleIcon,
//   NavigateNext as NavigateNextIcon,
//   Scale as ScaleIcon,
//   Favorite as FavoriteIcon,
//   LocationOn as LocationIcon,
//   AttachMoney as MoneyIcon,
//   Notes as NotesIcon,
//   CalendarToday as CalendarIcon,
//   Female as FemaleIcon,
//   Male as MaleIcon,
//   LocalHospital as HealthIcon,
//   Agriculture as AgricultureIcon,
//   Science as ScienceIcon,
//   AutoAwesome as AutoAwesomeIcon,
// } from "@mui/icons-material";
// import { useParams, useNavigate } from "react-router-dom";
// import swal from "sweetalert";

// const AnimalDetailPage = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('md'));
//   const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
//   const isNew = !id || id === 'new';

//   const [animal, setAnimal] = useState(null);
//   const [form, setForm] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [saving, setSaving] = useState(false);
//   const [autoSaving, setAutoSaving] = useState(false);
//   const [editing, setEditing] = useState(isNew);
//   const [activeTab, setActiveTab] = useState(0);
//   const [saveModalOpen, setSaveModalOpen] = useState(false);
//   const [lastSaved, setLastSaved] = useState(null);
//   const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

//   const [options, setOptions] = useState({
//     species: [],
//     breeds: {},
//     sexes: [],
//     animal_classes: {},
//     lifecycle_states: [],
//     reproductive_statuses: [],
//     pregnancy_statuses: [],
//     milking_statuses: [],
//     semen_statuses: [],
//     health_statuses: []
//   });

//   const API_URL = "http://127.0.0.1:5055/api/animals/";

//   // Form steps for completion tracking
//   const formSteps = [
//     { key: 'basic', label: 'Basic Info', completed: false, icon: <PetsIcon /> },
//     { key: 'physical', label: 'Physical Data', completed: false, icon: <ScaleIcon /> },
//     { key: 'health', label: 'Health & Reproductive', completed: false, icon: <HealthIcon /> },
//     { key: 'location', label: 'Location & Management', completed: false, icon: <LocationIcon /> },
//     { key: 'economic', label: 'Economic & Genetic', completed: false, icon: <MoneyIcon /> },
//     { key: 'notes', label: 'Additional Info', completed: false, icon: <NotesIcon /> },
//   ];

//   const [completion, setCompletion] = useState(formSteps.map(() => false));

//   // Initial empty form
//   const initialForm = {
//     // Basic identification
//     tag_number: "",
//     name: "",
//     species: "Cattle",
//     breed: "",
//     dob: "",
    
//     // Gender and animal class
//     sex: "Female",
//     animal_class: "",
    
//     // Genetic information
//     sire_id: "",
//     dam_id: "",
//     registration_number: "",
//     genetic_score: "",
//     breed_composition: "",
    
//     // Physical characteristics
//     color: "",
//     birth_weight: "",
//     current_weight: "",
//     height: "",
//     weaning_weight: "",
//     yearling_weight: "",
    
//     // Reproductive status
//     reproductive_status: "",
//     last_calving_date: "",
//     number_of_calves: "",
//     pregnancy_status: "",
//     lactation_number: "",
//     days_bred: "",
    
//     // Male specific
//     semen_status: "",
//     breeding_capacity: "",
    
//     // Milking data
//     milking_status: "",
//     is_milking_cow: false,
//     last_milking_date: "",
//     days_in_milk: "",
//     average_milk_yield: "",
//     total_lifetime_milk: "",
    
//     // Health and management
//     health_status: "Healthy",
//     vaccination_status: "",
//     last_vet_visit: "",
//     next_vet_visit: "",
    
//     // Location and management
//     location: "",
//     pen_group: "",
//     herd_id: "",
    
//     // Lifecycle management
//     lifecycle_state: "Draft",
//     entry_date: "",
//     exit_date: "",
//     exit_reason: "",
    
//     // Economic data
//     purchase_price: "",
//     sale_price: "",
//     estimated_value: "",
    
//     // Purchase specific
//     origin: "",
//     purchase_conditions: "",
    
//     // Additional metadata
//     notes: "",
    
//     // Animal type
//     animal_type: "born"
//   };

//   // Custom styles
//   const styles = {
//     primaryColor: '#024a59',
//     secondaryColor: '#ffa916',
//     lightBackground: '#f8f9fa',
//     cardShadow: '0 4px 12px rgba(2, 74, 89, 0.1)',
//     sectionSpacing: { xs: 2, md: 3 },
//     compactCard: {
//       height: '100%',
//       boxShadow: '0 2px 8px rgba(2, 74, 89, 0.08)',
//       transition: 'all 0.3s ease',
//       '&:hover': {
//         boxShadow: '0 4px 16px rgba(2, 74, 89, 0.15)',
//         transform: 'translateY(-2px)'
//       }
//     }
//   };

//   // Auto-save functionality
//   useEffect(() => {
//     if (!editing || !hasUnsavedChanges) return;

//     const autoSaveTimer = setTimeout(() => {
//       if (hasUnsavedChanges) {
//         handleAutoSave();
//       }
//     }, 10000); // Auto-save after 10 seconds of inactivity

//     return () => clearTimeout(autoSaveTimer);
//   }, [form, hasUnsavedChanges, editing]);

//   // Fetch animal data
//   const fetchAnimal = async () => {
//     if (isNew) {
//       setForm(initialForm);
//       setAnimal({ ...initialForm, id: 'new' });
//       return;
//     }

//     setLoading(true);
//     try {
//       const res = await fetch(`${API_URL}${id}`);
//       const data = await res.json();
      
//       if (res.ok) {
//         setAnimal(data.animal || data);
//         // Convert null values to empty strings for form
//         const formData = {};
//         Object.keys(initialForm).forEach(key => {
//           let value = data.animal?.[key] || data[key];
//           if (value === null || value === undefined) value = "";
//           if (value && typeof value === 'string' && value.includes('T')) {
//             value = value.split('T')[0];
//           }
//           formData[key] = value;
//         });
//         setForm(formData);
//       } else {
//         swal("Error", "Failed to fetch animal data", "error");
//         navigate('/animals');
//       }
//     } catch (err) {
//       console.error('Error fetching animal:', err);
//       swal("Error", "Failed to fetch animal data", "error");
//       navigate('/animals');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Fetch options
//   const fetchOptions = async () => {
//     try {
//       const res = await fetch(`${API_URL}options`);
//       const data = await res.json();
//       if (res.ok) {
//         setOptions(data);
//       }
//     } catch (err) {
//       console.error('Error fetching options:', err);
//     }
//   };

//   useEffect(() => {
//     fetchOptions();
//     fetchAnimal();
//   }, [id]);

//   // Check form completion
//   useEffect(() => {
//     if (!form) return;

//     const newCompletion = formSteps.map((step, index) => {
//       switch (step.key) {
//         case 'basic':
//           return !!(form.tag_number && form.breed && form.dob && form.sex);
//         case 'physical':
//           return !!(form.current_weight || form.height || form.color);
//         case 'health':
//           return !!(form.health_status || form.reproductive_status || form.vaccination_status);
//         case 'location':
//           return !!(form.location || form.herd_id);
//         case 'economic':
//           return !!(form.purchase_price || form.estimated_value || form.sire_id || form.dam_id);
//         case 'notes':
//           return !!(form.notes);
//         default:
//           return false;
//       }
//     });

//     setCompletion(newCompletion);
//   }, [form]);

//   // Form handler
//   const handleFormChange = (e) => {
//     const { name, value, type, checked } = e.target;
    
//     let processedValue = value;
//     if (type === 'number' && value !== '') {
//       processedValue = Number(value);
//     } else if (type === 'checkbox') {
//       processedValue = checked;
//     } else if (value === '') {
//       processedValue = '';
//     }

//     setForm(prev => ({
//       ...prev,
//       [name]: processedValue
//     }));

//     setHasUnsavedChanges(true);

//     // Update animal class when species or sex changes
//     if ((name === 'species' || name === 'sex') && options.animal_classes) {
//       const speciesClasses = options.animal_classes[form.species] || {};
//       const classes = speciesClasses[form.sex] || [];
//       if (classes.length > 0 && !classes.includes(form.animal_class)) {
//         setForm(prev => ({ ...prev, animal_class: classes[0] }));
//       }
//     }
//   };

//   // Auto-save function
//   const handleAutoSave = async () => {
//     if (!hasUnsavedChanges || saving) return;

//     setAutoSaving(true);
//     try {
//       await saveFormData(false); // Silent save without notifications
//       setLastSaved(new Date());
//       setHasUnsavedChanges(false);
//     } catch (error) {
//       console.error('Auto-save failed:', error);
//     } finally {
//       setAutoSaving(false);
//     }
//   };

//   // Save form data (used by both manual and auto-save)
//   const saveFormData = async (showNotifications = true) => {
//     const submitData = { ...form };
    
//     // Convert empty strings to null
//     Object.keys(submitData).forEach(key => {
//       if (submitData[key] === '') {
//         submitData[key] = null;
//       }
//     });

//     // Convert numeric fields
//     const numericFields = [
//       'birth_weight', 'current_weight', 'height', 'weaning_weight', 'yearling_weight',
//       'purchase_price', 'sale_price', 'estimated_value', 'genetic_score',
//       'number_of_calves', 'lactation_number', 'days_bred', 'days_in_milk',
//       'average_milk_yield', 'total_lifetime_milk', 'sire_id', 'dam_id'
//     ];
    
//     numericFields.forEach(field => {
//       if (submitData[field] !== null && submitData[field] !== '') {
//         submitData[field] = Number(submitData[field]);
//       }
//     });

//     submitData.is_milking_cow = Boolean(submitData.is_milking_cow);

//     const method = isNew ? "POST" : "PUT";
//     const url = isNew ? API_URL : `${API_URL}${id}`;

//     const res = await fetch(url, {
//       method,
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(submitData),
//     });

//     const data = await res.json();
//     if (res.ok) {
//       if (isNew) {
//         navigate(`/animals/${data.animal?.id || id}`);
//         setEditing(false);
//       }
//       setAnimal(data.animal || data);
//       if (showNotifications) {
//         swal("Success", data.message || "Changes saved successfully", "success");
//       }
//       return true;
//     } else {
//       if (showNotifications) {
//         swal("Error", data.error || "Something went wrong", "error");
//       }
//       return false;
//     }
//   };

//   // Manual save section
//   const saveSection = async () => {
//     setSaving(true);
//     try {
//       const success = await saveFormData(true);
//       if (success) {
//         setSaveModalOpen(false);
//         setHasUnsavedChanges(false);
//         setLastSaved(new Date());
//       }
//     } catch (err) {
//       console.error('Save error:', err);
//       swal("Error", "Failed to save changes", "error");
//     } finally {
//       setSaving(false);
//     }
//   };

//   // Save and go to next tab
//   const saveAndNext = async () => {
//     setSaving(true);
//     try {
//       const success = await saveFormData(true);
//       if (success) {
//         setHasUnsavedChanges(false);
//         setLastSaved(new Date());
//         if (activeTab < tabComponents.length - 1) {
//           setActiveTab(activeTab + 1);
//         }
//       }
//     } catch (err) {
//       console.error('Save error:', err);
//       swal("Error", "Failed to save changes", "error");
//     } finally {
//       setSaving(false);
//     }
//   };

//   // Submit for approval
//   const handleSubmitForApproval = async () => {
//     const confirm = await swal({
//       title: "Submit for Approval?",
//       text: "This will change the animal status to Active and make it visible to all users",
//       icon: "warning",
//       buttons: true,
//       dangerMode: true,
//     });

//     if (confirm) {
//       setSaving(true);
//       try {
//         const res = await fetch(`${API_URL}${id}/status`, {
//           method: "PUT",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ lifecycle_state: "Active" }),
//         });

//         const data = await res.json();
//         if (res.ok) {
//           setAnimal(prev => ({ ...prev, lifecycle_state: "Active" }));
//           setForm(prev => ({ ...prev, lifecycle_state: "Active" }));
//           swal("Success", "Animal submitted and activated!", "success");
//         } else {
//           swal("Error", data.error, "error");
//         }
//       } catch (err) {
//         swal("Error", "Something went wrong", "error");
//       } finally {
//         setSaving(false);
//         setSaveModalOpen(false);
//       }
//     }
//   };

//   // Format date for display
//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     return new Date(dateString).toLocaleDateString('en-US', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric'
//     });
//   };

//   // Calculate age from DOB
//   const calculateAge = (dob) => {
//     if (!dob) return 'N/A';
//     const birthDate = new Date(dob);
//     const today = new Date();
//     let years = today.getFullYear() - birthDate.getFullYear();
//     let months = today.getMonth() - birthDate.getMonth();
    
//     if (months < 0) {
//       years--;
//       months += 12;
//     }
    
//     if (years === 0) {
//       return `${months} month${months !== 1 ? 's' : ''}`;
//     }
//     return `${years} year${years !== 1 ? 's' : ''} ${months} month${months !== 1 ? 's' : ''}`;
//   };

//   // Tab components for EDIT mode
//   const BasicInfoTab = () => (
//     <Box>
//       <Grid container spacing={2}>
//         <Grid item xs={12} md={6}>
//           <FormControl fullWidth>
//             <InputLabel>Animal Type</InputLabel>
//             <Select
//               name="animal_type"
//               value={form.animal_type || ""}
//               onChange={handleFormChange}
//               label="Animal Type"
//             >
//               <MenuItem value="born">Born on Farm</MenuItem>
//               <MenuItem value="purchased">Purchased</MenuItem>
//             </Select>
//           </FormControl>
//         </Grid>
        
//         <Grid item xs={12} md={6}>
//           <TextField
//             fullWidth
//             label="Tag Number *"
//             name="tag_number"
//             value={form.tag_number || ""}
//             onChange={handleFormChange}
//             required
//           />
//         </Grid>

//         <Grid item xs={12} md={6}>
//           <TextField
//             fullWidth
//             label="Name"
//             name="name"
//             value={form.name || ""}
//             onChange={handleFormChange}
//           />
//         </Grid>
        
//         <Grid item xs={12} md={6}>
//           <FormControl fullWidth>
//             <InputLabel>Species</InputLabel>
//             <Select
//               name="species"
//               value={form.species || ""}
//               onChange={handleFormChange}
//               label="Species"
//             >
//               {options.species.map(species => (
//                 <MenuItem key={species} value={species}>{species}</MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Grid>

//         <Grid item xs={12} md={6}>
//           <FormControl fullWidth>
//             <InputLabel>Breed *</InputLabel>
//             <Select
//               name="breed"
//               value={form.breed || ""}
//               onChange={handleFormChange}
//               label="Breed *"
//               required
//             >
//               <MenuItem value="">Select Breed</MenuItem>
//               {options.breeds[form.species]?.map(breed => (
//                 <MenuItem key={breed} value={breed}>{breed}</MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Grid>
        
//         <Grid item xs={12} md={6}>
//           <TextField
//             fullWidth
//             label="Date of Birth *"
//             name="dob"
//             type="date"
//             value={form.dob || ""}
//             onChange={handleFormChange}
//             InputLabelProps={{ shrink: true }}
//             required
//           />
//         </Grid>

//         <Grid item xs={12} md={6}>
//           <FormControl fullWidth>
//             <InputLabel>Gender *</InputLabel>
//             <Select
//               name="sex"
//               value={form.sex || ""}
//               onChange={handleFormChange}
//               label="Gender *"
//               required
//             >
//               {options.sexes.map(sex => (
//                 <MenuItem key={sex} value={sex}>{sex}</MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Grid>
        
//         <Grid item xs={12} md={6}>
//           <FormControl fullWidth>
//             <InputLabel>Animal Class</InputLabel>
//             <Select
//               name="animal_class"
//               value={form.animal_class || ""}
//               onChange={handleFormChange}
//               label="Animal Class"
//             >
//               <MenuItem value="">Select Class</MenuItem>
//               {options.animal_classes[form.species]?.[form.sex]?.map(cls => (
//                 <MenuItem key={cls} value={cls}>{cls}</MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Grid>

//         <Grid item xs={12} md={6}>
//           <TextField
//             fullWidth
//             label="Color"
//             name="color"
//             value={form.color || ""}
//             onChange={handleFormChange}
//           />
//         </Grid>

//         <Grid item xs={12} md={6}>
//           <FormControl fullWidth>
//             <InputLabel>Lifecycle State</InputLabel>
//             <Select
//               name="lifecycle_state"
//               value={form.lifecycle_state || ""}
//               onChange={handleFormChange}
//               label="Lifecycle State"
//             >
//               {options.lifecycle_states.map(state => (
//                 <MenuItem key={state} value={state}>{state}</MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Grid>
//       </Grid>
      
//       {/* Save Button for this tab */}
//       <Box sx={{ mt: 3, pt: 2, borderTop: 1, borderColor: 'divider' }}>
//         <Stack direction="row" spacing={2} justifyContent="flex-end">
//           {autoSaving && (
//             <Box sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
//               <CircularProgress size={20} sx={{ mr: 1 }} />
//               <Typography variant="body2" color="text.secondary">
//                 Auto-saving...
//               </Typography>
//             </Box>
//           )}
//           <Button
//             variant="outlined"
//             onClick={saveSection}
//             disabled={saving}
//           >
//             {saving ? 'Saving...' : 'Save This Section'}
//           </Button>
//           <Button
//             variant="contained"
//             onClick={saveAndNext}
//             disabled={saving}
//             sx={{ 
//               backgroundColor: styles.primaryColor,
//               '&:hover': { backgroundColor: '#012e39' }
//             }}
//           >
//             {saving ? 'Saving...' : 'Save & Next'}
//           </Button>
//         </Stack>
//       </Box>
//     </Box>
//   );

//   const PhysicalTab = () => (
//     <Box>
//       <Grid container spacing={2}>
//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Birth Weight (kg)"
//             name="birth_weight"
//             type="number"
//             value={form.birth_weight || ""}
//             onChange={handleFormChange}
//             InputProps={{ inputProps: { min: 0, step: 0.1 } }}
//           />
//         </Grid>
        
//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Current Weight (kg)"
//             name="current_weight"
//             type="number"
//             value={form.current_weight || ""}
//             onChange={handleFormChange}
//             InputProps={{ inputProps: { min: 0, step: 0.1 } }}
//           />
//         </Grid>

//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Height (cm)"
//             name="height"
//             type="number"
//             value={form.height || ""}
//             onChange={handleFormChange}
//             InputProps={{ inputProps: { min: 0, step: 0.1 } }}
//           />
//         </Grid>
        
//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Weaning Weight (kg)"
//             name="weaning_weight"
//             type="number"
//             value={form.weaning_weight || ""}
//             onChange={handleFormChange}
//             InputProps={{ inputProps: { min: 0, step: 0.1 } }}
//           />
//         </Grid>

//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Yearling Weight (kg)"
//             name="yearling_weight"
//             type="number"
//             value={form.yearling_weight || ""}
//             onChange={handleFormChange}
//             InputProps={{ inputProps: { min: 0, step: 0.1 } }}
//           />
//         </Grid>
//       </Grid>
      
//       {/* Save Button for this tab */}
//       <Box sx={{ mt: 3, pt: 2, borderTop: 1, borderColor: 'divider' }}>
//         <Stack direction="row" spacing={2} justifyContent="flex-end">
//           {autoSaving && (
//             <Box sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
//               <CircularProgress size={20} sx={{ mr: 1 }} />
//               <Typography variant="body2" color="text.secondary">
//                 Auto-saving...
//               </Typography>
//             </Box>
//           )}
//           <Button
//             variant="outlined"
//             onClick={saveSection}
//             disabled={saving}
//           >
//             {saving ? 'Saving...' : 'Save This Section'}
//           </Button>
//           <Button
//             variant="contained"
//             onClick={saveAndNext}
//             disabled={saving}
//             sx={{ 
//               backgroundColor: styles.primaryColor,
//               '&:hover': { backgroundColor: '#012e39' }
//             }}
//           >
//             {saving ? 'Saving...' : 'Save & Next'}
//           </Button>
//         </Stack>
//       </Box>
//     </Box>
//   );

//   const HealthReproductiveTab = () => (
//     <Box>
//       <Grid container spacing={2}>
//         <Grid item xs={12} sm={6} md={4}>
//           <FormControl fullWidth>
//             <InputLabel>Health Status</InputLabel>
//             <Select
//               name="health_status"
//               value={form.health_status || ""}
//               onChange={handleFormChange}
//               label="Health Status"
//             >
//               {options.health_statuses.map(status => (
//                 <MenuItem key={status} value={status}>{status}</MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Grid>
        
//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Vaccination Status"
//             name="vaccination_status"
//             value={form.vaccination_status || ""}
//             onChange={handleFormChange}
//           />
//         </Grid>

//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Last Vet Visit"
//             name="last_vet_visit"
//             type="date"
//             value={form.last_vet_visit || ""}
//             onChange={handleFormChange}
//             InputLabelProps={{ shrink: true }}
//           />
//         </Grid>
        
//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Next Vet Visit"
//             name="next_vet_visit"
//             type="date"
//             value={form.next_vet_visit || ""}
//             onChange={handleFormChange}
//             InputLabelProps={{ shrink: true }}
//           />
//         </Grid>

//         {form.sex === 'Female' && (
//           <>
//             <Grid item xs={12} sm={6} md={4}>
//               <FormControl fullWidth>
//                 <InputLabel>Reproductive Status</InputLabel>
//                 <Select
//                   name="reproductive_status"
//                   value={form.reproductive_status || ""}
//                   onChange={handleFormChange}
//                   label="Reproductive Status"
//                 >
//                   <MenuItem value="">Select Status</MenuItem>
//                   {options.reproductive_statuses.map(status => (
//                     <MenuItem key={status} value={status}>{status}</MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>
            
//             <Grid item xs={12} sm={6} md={4}>
//               <FormControl fullWidth>
//                 <InputLabel>Pregnancy Status</InputLabel>
//                 <Select
//                   name="pregnancy_status"
//                   value={form.pregnancy_status || ""}
//                   onChange={handleFormChange}
//                   label="Pregnancy Status"
//                 >
//                   <MenuItem value="">Select Status</MenuItem>
//                   {options.pregnancy_statuses.map(status => (
//                     <MenuItem key={status} value={status}>{status}</MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>

//             <Grid item xs={12} sm={6} md={4}>
//               <TextField
//                 fullWidth
//                 label="Last Calving Date"
//                 name="last_calving_date"
//                 type="date"
//                 value={form.last_calving_date || ""}
//                 onChange={handleFormChange}
//                 InputLabelProps={{ shrink: true }}
//               />
//             </Grid>
            
//             <Grid item xs={12} sm={6} md={4}>
//               <TextField
//                 fullWidth
//                 label="Number of Calves"
//                 name="number_of_calves"
//                 type="number"
//                 value={form.number_of_calves || ""}
//                 onChange={handleFormChange}
//                 InputProps={{ inputProps: { min: 0 } }}
//               />
//             </Grid>

//             <Grid item xs={12} sm={6} md={4}>
//               <TextField
//                 fullWidth
//                 label="Lactation Number"
//                 name="lactation_number"
//                 type="number"
//                 value={form.lactation_number || ""}
//                 onChange={handleFormChange}
//                 InputProps={{ inputProps: { min: 0 } }}
//               />
//             </Grid>
            
//             <Grid item xs={12} sm={6} md={4}>
//               <TextField
//                 fullWidth
//                 label="Days Bred"
//                 name="days_bred"
//                 type="number"
//                 value={form.days_bred || ""}
//                 onChange={handleFormChange}
//                 InputProps={{ inputProps: { min: 0 } }}
//               />
//             </Grid>

//             <Grid item xs={12} sm={6} md={4}>
//               <FormControl fullWidth>
//                 <InputLabel>Milking Status</InputLabel>
//                 <Select
//                   name="milking_status"
//                   value={form.milking_status || ""}
//                   onChange={handleFormChange}
//                   label="Milking Status"
//                 >
//                   <MenuItem value="">Select Status</MenuItem>
//                   {options.milking_statuses.map(status => (
//                     <MenuItem key={status} value={status}>{status}</MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>
            
//             <Grid item xs={12} sm={6} md={4}>
//               <FormControlLabel
//                 control={
//                   <Switch
//                     name="is_milking_cow"
//                     checked={form.is_milking_cow || false}
//                     onChange={handleFormChange}
//                   />
//                 }
//                 label="Is Milking Cow"
//               />
//             </Grid>

//             <Grid item xs={12} sm={6} md={4}>
//               <TextField
//                 fullWidth
//                 label="Last Milking Date"
//                 name="last_milking_date"
//                 type="date"
//                 value={form.last_milking_date || ""}
//                 onChange={handleFormChange}
//                 InputLabelProps={{ shrink: true }}
//               />
//             </Grid>
            
//             <Grid item xs={12} sm={6} md={4}>
//               <TextField
//                 fullWidth
//                 label="Days in Milk"
//                 name="days_in_milk"
//                 type="number"
//                 value={form.days_in_milk || ""}
//                 onChange={handleFormChange}
//                 InputProps={{ inputProps: { min: 0 } }}
//               />
//             </Grid>

//             <Grid item xs={12} sm={6} md={4}>
//               <TextField
//                 fullWidth
//                 label="Avg Milk Yield (L/day)"
//                 name="average_milk_yield"
//                 type="number"
//                 value={form.average_milk_yield || ""}
//                 onChange={handleFormChange}
//                 InputProps={{ inputProps: { min: 0, step: 0.1 } }}
//               />
//             </Grid>
            
//             <Grid item xs={12} sm={6} md={4}>
//               <TextField
//                 fullWidth
//                 label="Total Lifetime Milk (L)"
//                 name="total_lifetime_milk"
//                 type="number"
//                 value={form.total_lifetime_milk || ""}
//                 onChange={handleFormChange}
//                 InputProps={{ inputProps: { min: 0, step: 0.1 } }}
//               />
//             </Grid>
//           </>
//         )}

//         {form.sex === 'Male' && (
//           <>
//             <Grid item xs={12} sm={6} md={4}>
//               <FormControl fullWidth>
//                 <InputLabel>Semen Status</InputLabel>
//                 <Select
//                   name="semen_status"
//                   value={form.semen_status || ""}
//                   onChange={handleFormChange}
//                   label="Semen Status"
//                 >
//                   <MenuItem value="">Select Status</MenuItem>
//                   {options.semen_statuses.map(status => (
//                     <MenuItem key={status} value={status}>{status}</MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>
            
//             <Grid item xs={12} sm={6} md={4}>
//               <TextField
//                 fullWidth
//                 label="Breeding Capacity"
//                 name="breeding_capacity"
//                 value={form.breeding_capacity || ""}
//                 onChange={handleFormChange}
//               />
//             </Grid>
//           </>
//         )}
//       </Grid>
      
//       {/* Save Button for this tab */}
//       <Box sx={{ mt: 3, pt: 2, borderTop: 1, borderColor: 'divider' }}>
//         <Stack direction="row" spacing={2} justifyContent="flex-end">
//           {autoSaving && (
//             <Box sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
//               <CircularProgress size={20} sx={{ mr: 1 }} />
//               <Typography variant="body2" color="text.secondary">
//                 Auto-saving...
//               </Typography>
//             </Box>
//           )}
//           <Button
//             variant="outlined"
//             onClick={saveSection}
//             disabled={saving}
//           >
//             {saving ? 'Saving...' : 'Save This Section'}
//           </Button>
//           <Button
//             variant="contained"
//             onClick={saveAndNext}
//             disabled={saving}
//             sx={{ 
//               backgroundColor: styles.primaryColor,
//               '&:hover': { backgroundColor: '#012e39' }
//             }}
//           >
//             {saving ? 'Saving...' : 'Save & Next'}
//           </Button>
//         </Stack>
//       </Box>
//     </Box>
//   );

//   const LocationManagementTab = () => (
//     <Box>
//       <Grid container spacing={2}>
//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Location"
//             name="location"
//             value={form.location || ""}
//             onChange={handleFormChange}
//           />
//         </Grid>
        
//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Pen/Group"
//             name="pen_group"
//             value={form.pen_group || ""}
//             onChange={handleFormChange}
//           />
//         </Grid>

//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Herd ID"
//             name="herd_id"
//             value={form.herd_id || ""}
//             onChange={handleFormChange}
//           />
//         </Grid>

//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Entry Date"
//             name="entry_date"
//             type="date"
//             value={form.entry_date || ""}
//             onChange={handleFormChange}
//             InputLabelProps={{ shrink: true }}
//           />
//         </Grid>
        
//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Exit Date"
//             name="exit_date"
//             type="date"
//             value={form.exit_date || ""}
//             onChange={handleFormChange}
//             InputLabelProps={{ shrink: true }}
//           />
//         </Grid>

//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Exit Reason"
//             name="exit_reason"
//             value={form.exit_reason || ""}
//             onChange={handleFormChange}
//           />
//         </Grid>
//       </Grid>
      
//       {/* Save Button for this tab */}
//       <Box sx={{ mt: 3, pt: 2, borderTop: 1, borderColor: 'divider' }}>
//         <Stack direction="row" spacing={2} justifyContent="flex-end">
//           {autoSaving && (
//             <Box sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
//               <CircularProgress size={20} sx={{ mr: 1 }} />
//               <Typography variant="body2" color="text.secondary">
//                 Auto-saving...
//               </Typography>
//             </Box>
//           )}
//           <Button
//             variant="outlined"
//             onClick={saveSection}
//             disabled={saving}
//           >
//             {saving ? 'Saving...' : 'Save This Section'}
//           </Button>
//           <Button
//             variant="contained"
//             onClick={saveAndNext}
//             disabled={saving}
//             sx={{ 
//               backgroundColor: styles.primaryColor,
//               '&:hover': { backgroundColor: '#012e39' }
//             }}
//           >
//             {saving ? 'Saving...' : 'Save & Next'}
//           </Button>
//         </Stack>
//       </Box>
//     </Box>
//   );

//   const EconomicGeneticTab = () => (
//     <Box>
//       <Grid container spacing={2}>
//         {form.animal_type === 'purchased' && (
//           <>
//             <Grid item xs={12} sm={6} md={4}>
//               <TextField
//                 fullWidth
//                 label="Purchase Price ($)"
//                 name="purchase_price"
//                 type="number"
//                 value={form.purchase_price || ""}
//                 onChange={handleFormChange}
//                 InputProps={{ inputProps: { min: 0, step: 0.01 } }}
//               />
//             </Grid>
            
//             <Grid item xs={12} sm={6} md={4}>
//               <TextField
//                 fullWidth
//                 label="Sale Price ($)"
//                 name="sale_price"
//                 type="number"
//                 value={form.sale_price || ""}
//                 onChange={handleFormChange}
//                 InputProps={{ inputProps: { min: 0, step: 0.01 } }}
//               />
//             </Grid>

//             <Grid item xs={12} sm={6} md={4}>
//               <TextField
//                 fullWidth
//                 label="Estimated Value ($)"
//                 name="estimated_value"
//                 type="number"
//                 value={form.estimated_value || ""}
//                 onChange={handleFormChange}
//                 InputProps={{ inputProps: { min: 0, step: 0.01 } }}
//               />
//             </Grid>
            
//             <Grid item xs={12} sm={6} md={4}>
//               <TextField
//                 fullWidth
//                 label="Origin"
//                 name="origin"
//                 value={form.origin || ""}
//                 onChange={handleFormChange}
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <TextField
//                 fullWidth
//                 label="Purchase Conditions"
//                 name="purchase_conditions"
//                 multiline
//                 rows={3}
//                 value={form.purchase_conditions || ""}
//                 onChange={handleFormChange}
//               />
//             </Grid>
//             <Grid item xs={12}><Divider sx={{ my: 2 }} /></Grid>
//           </>
//         )}

//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Sire ID"
//             name="sire_id"
//             type="number"
//             value={form.sire_id || ""}
//             onChange={handleFormChange}
//             InputProps={{ inputProps: { min: 0 } }}
//           />
//         </Grid>
        
//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Dam ID"
//             name="dam_id"
//             type="number"
//             value={form.dam_id || ""}
//             onChange={handleFormChange}
//             InputProps={{ inputProps: { min: 0 } }}
//           />
//         </Grid>

//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Registration Number"
//             name="registration_number"
//             value={form.registration_number || ""}
//             onChange={handleFormChange}
//           />
//         </Grid>
        
//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Genetic Score"
//             name="genetic_score"
//             type="number"
//             value={form.genetic_score || ""}
//             onChange={handleFormChange}
//             InputProps={{ inputProps: { min: 0, step: 0.1 } }}
//           />
//         </Grid>

//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Breed Composition"
//             name="breed_composition"
//             value={form.breed_composition || ""}
//             onChange={handleFormChange}
//           />
//         </Grid>
//       </Grid>
      
//       {/* Save Button for this tab */}
//       <Box sx={{ mt: 3, pt: 2, borderTop: 1, borderColor: 'divider' }}>
//         <Stack direction="row" spacing={2} justifyContent="flex-end">
//           {autoSaving && (
//             <Box sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
//               <CircularProgress size={20} sx={{ mr: 1 }} />
//               <Typography variant="body2" color="text.secondary">
//                 Auto-saving...
//               </Typography>
//             </Box>
//           )}
//           <Button
//             variant="outlined"
//             onClick={saveSection}
//             disabled={saving}
//           >
//             {saving ? 'Saving...' : 'Save This Section'}
//           </Button>
//           <Button
//             variant="contained"
//             onClick={saveAndNext}
//             disabled={saving}
//             sx={{ 
//               backgroundColor: styles.primaryColor,
//               '&:hover': { backgroundColor: '#012e39' }
//             }}
//           >
//             {saving ? 'Saving...' : 'Save & Next'}
//           </Button>
//         </Stack>
//       </Box>
//     </Box>
//   );

//   const NotesTab = () => (
//     <Box>
//       <Grid container spacing={2}>
//         <Grid item xs={12}>
//           <TextField
//             fullWidth
//             label="Notes"
//             name="notes"
//             multiline
//             rows={6}
//             value={form.notes || ""}
//             onChange={handleFormChange}
//             placeholder="Additional notes about the animal..."
//           />
//         </Grid>
//       </Grid>
      
//       {/* Save Button for this tab */}
//       <Box sx={{ mt: 3, pt: 2, borderTop: 1, borderColor: 'divider' }}>
//         <Stack direction="row" spacing={2} justifyContent="flex-end">
//           {autoSaving && (
//             <Box sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
//               <CircularProgress size={20} sx={{ mr: 1 }} />
//               <Typography variant="body2" color="text.secondary">
//                 Auto-saving...
//               </Typography>
//             </Box>
//           )}
//           <Button
//             variant="outlined"
//             onClick={saveSection}
//             disabled={saving}
//           >
//             {saving ? 'Saving...' : 'Save This Section'}
//           </Button>
//           <Button
//             variant="contained"
//             onClick={saveSection}
//             disabled={saving}
//             sx={{ 
//               backgroundColor: styles.primaryColor,
//               '&:hover': { backgroundColor: '#012e39' }
//             }}
//           >
//             {saving ? 'Saving...' : 'Save All Changes'}
//           </Button>
//         </Stack>
//       </Box>
//     </Box>
//   );

//   // COMPACT VIEW MODE COMPONENTS - Horizontal layout for better space utilization
//   const CompactInfoCard = ({ title, icon, items }) => (
//     <Card sx={styles.compactCard}>
//       <CardHeader
//         title={title}
//         avatar={React.cloneElement(icon, { sx: { color: styles.primaryColor } })}
//         sx={{ 
//           backgroundColor: styles.lightBackground,
//           pb: 1,
//           '& .MuiCardHeader-title': { fontSize: '1rem', fontWeight: 'bold' }
//         }}
//       />
//       <CardContent sx={{ pt: 1, '&:last-child': { pb: 2 } }}>
//         <List dense disablePadding>
//           {items.map((item, index) => (
//             <ListItem key={index} disablePadding sx={{ py: 0.5 }}>
//               <ListItemText 
//                 primary={item.primary}
//                 secondary={item.secondary}
//                 primaryTypographyProps={{ variant: 'body2', fontWeight: 'medium' }}
//                 secondaryTypographyProps={{ variant: 'body2', color: 'text.primary' }}
//               />
//             </ListItem>
//           ))}
//         </List>
//       </CardContent>
//     </Card>
//   );

//   const BasicInfoView = () => (
//     <Grid container spacing={2}>
//       <Grid item xs={12} sm={6} md={3}>
//         <CompactInfoCard
//           title="Identification"
//           icon={<PetsIcon />}
//           items={[
//             { primary: "Tag Number", secondary: animal?.tag_number || 'N/A' },
//             { primary: "Name", secondary: animal?.name || 'N/A' },
//             { primary: "Species", secondary: animal?.species || 'N/A' },
//             { primary: "Breed", secondary: animal?.breed || 'N/A' },
//           ]}
//         />
//       </Grid>

//       <Grid item xs={12} sm={6} md={3}>
//         <CompactInfoCard
//           title="Demographics"
//           icon={<CalendarIcon />}
//           items={[
//             { primary: "Date of Birth", secondary: formatDate(animal?.dob) },
//             { primary: "Age", secondary: calculateAge(animal?.dob) },
//             { primary: "Gender", secondary: animal?.sex || 'N/A' },
//             { primary: "Animal Class", secondary: animal?.animal_class || 'N/A' },
//           ]}
//         />
//       </Grid>

//       <Grid item xs={12} sm={6} md={3}>
//         <CompactInfoCard
//           title="Status & Appearance"
//           icon={<PetsIcon />}
//           items={[
//             { primary: "Color", secondary: animal?.color || 'N/A' },
//             { primary: "Animal Type", secondary: animal?.purchase_price ? "PURCHASED" : "BORN" },
//             { primary: "Lifecycle State", secondary: animal?.lifecycle_state || 'N/A' },
//           ]}
//         />
//       </Grid>

//       <Grid item xs={12} sm={6} md={3}>
//         <CompactInfoCard
//           title="Physical Data"
//           icon={<ScaleIcon />}
//           items={[
//             { primary: "Current Weight", secondary: animal?.current_weight ? `${animal.current_weight} kg` : 'N/A' },
//             { primary: "Height", secondary: animal?.height ? `${animal.height} cm` : 'N/A' },
//             { primary: "Birth Weight", secondary: animal?.birth_weight ? `${animal.birth_weight} kg` : 'N/A' },
//           ]}
//         />
//       </Grid>
//     </Grid>
//   );

//   const HealthReproductiveView = () => (
//     <Grid container spacing={2}>
//       <Grid item xs={12} sm={6} md={4}>
//         <CompactInfoCard
//           title="Health Status"
//           icon={<HealthIcon />}
//           items={[
//             { primary: "Health Status", secondary: animal?.health_status || 'N/A' },
//             { primary: "Vaccination Status", secondary: animal?.vaccination_status || 'N/A' },
//             { primary: "Last Vet Visit", secondary: formatDate(animal?.last_vet_visit) },
//             { primary: "Next Vet Visit", secondary: formatDate(animal?.next_vet_visit) },
//           ]}
//         />
//       </Grid>

//       {animal?.sex === 'Female' && (
//         <Grid item xs={12} sm={6} md={4}>
//           <CompactInfoCard
//             title="Reproductive Health"
//             icon={<FavoriteIcon />}
//             items={[
//               { primary: "Reproductive Status", secondary: animal?.reproductive_status || 'N/A' },
//               { primary: "Pregnancy Status", secondary: animal?.pregnancy_status || 'N/A' },
//               { primary: "Last Calving Date", secondary: formatDate(animal?.last_calving_date) },
//               { primary: "Number of Calves", secondary: animal?.number_of_calves || 'N/A' },
//               ...(animal?.is_milking_cow ? [
//                 { primary: "Milking Status", secondary: animal?.milking_status || 'N/A' },
//                 { primary: "Avg Milk Yield", secondary: animal?.average_milk_yield ? `${animal.average_milk_yield} L/day` : 'N/A' },
//               ] : [])
//             ]}
//           />
//         </Grid>
//       )}

//       {animal?.sex === 'Male' && (
//         <Grid item xs={12} sm={6} md={4}>
//           <CompactInfoCard
//             title="Breeding Information"
//             icon={<MaleIcon />}
//             items={[
//               { primary: "Semen Status", secondary: animal?.semen_status || 'N/A' },
//               { primary: "Breeding Capacity", secondary: animal?.breeding_capacity || 'N/A' },
//             ]}
//           />
//         </Grid>
//       )}

//       {/* Fill remaining space if needed */}
//       {((animal?.sex === 'Female' && window.innerWidth >= 960) || 
//         (animal?.sex === 'Male' && window.innerWidth >= 960)) && (
//         <Grid item xs={12} sm={6} md={4}>
//           <Card sx={{ ...styles.compactCard, height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//             <CardContent>
//               <Box textAlign="center">
//                 <HealthIcon sx={{ fontSize: 48, color: styles.primaryColor, opacity: 0.3, mb: 1 }} />
//                 <Typography variant="body2" color="text.secondary">
//                   Additional health metrics and reproductive data will appear here as they are recorded.
//                 </Typography>
//               </Box>
//             </CardContent>
//           </Card>
//         </Grid>
//       )}
//     </Grid>
//   );

//   const LocationManagementView = () => (
//     <Grid container spacing={2}>
//       <Grid item xs={12} sm={6} md={4}>
//         <CompactInfoCard
//           title="Location Details"
//           icon={<LocationIcon />}
//           items={[
//             { primary: "Location", secondary: animal?.location || 'N/A' },
//             { primary: "Pen/Group", secondary: animal?.pen_group || 'N/A' },
//             { primary: "Herd ID", secondary: animal?.herd_id || 'N/A' },
//           ]}
//         />
//       </Grid>

//       <Grid item xs={12} sm={6} md={4}>
//         <CompactInfoCard
//           title="Lifecycle Management"
//           icon={<CalendarIcon />}
//           items={[
//             { primary: "Entry Date", secondary: formatDate(animal?.entry_date) },
//             { primary: "Exit Date", secondary: formatDate(animal?.exit_date) },
//             { primary: "Exit Reason", secondary: animal?.exit_reason || 'N/A' },
//           ]}
//         />
//       </Grid>

//       <Grid item xs={12} sm={6} md={4}>
//         <CompactInfoCard
//           title="Quick Actions"
//           icon={<AutoAwesomeIcon />}
//           items={[
//             { primary: "Status", secondary: animal?.lifecycle_state || 'N/A' },
//             { primary: "Last Updated", secondary: lastSaved ? formatDate(lastSaved) : 'N/A' },
//             { primary: "Record Complete", secondary: completion.filter(Boolean).length + '/' + completion.length },
//           ]}
//         />
//       </Grid>
//     </Grid>
//   );

//   const EconomicGeneticView = () => (
//     <Grid container spacing={2}>
//       {animal?.purchase_price && (
//         <Grid item xs={12} sm={6} md={4}>
//           <CompactInfoCard
//             title="Financial Information"
//             icon={<MoneyIcon />}
//             items={[
//               { primary: "Purchase Price", secondary: animal?.purchase_price ? `$${animal.purchase_price}` : 'N/A' },
//               { primary: "Sale Price", secondary: animal?.sale_price ? `$${animal.sale_price}` : 'N/A' },
//               { primary: "Estimated Value", secondary: animal?.estimated_value ? `$${animal.estimated_value}` : 'N/A' },
//               { primary: "Origin", secondary: animal?.origin || 'N/A' },
//             ]}
//           />
//         </Grid>
//       )}

//       <Grid item xs={12} sm={6} md={4}>
//         <CompactInfoCard
//           title="Genetic Information"
//           icon={<ScienceIcon />}
//           items={[
//             { primary: "Sire ID", secondary: animal?.sire_id || 'N/A' },
//             { primary: "Dam ID", secondary: animal?.dam_id || 'N/A' },
//             { primary: "Registration Number", secondary: animal?.registration_number || 'N/A' },
//             { primary: "Genetic Score", secondary: animal?.genetic_score || 'N/A' },
//             { primary: "Breed Composition", secondary: animal?.breed_composition || 'N/A' },
//           ]}
//         />
//       </Grid>

//       {/* Fill space if no purchase price */}
//       {!animal?.purchase_price && (
//         <Grid item xs={12} sm={6} md={4}>
//           <Card sx={{ ...styles.compactCard, height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//             <CardContent>
//               <Box textAlign="center">
//                 <MoneyIcon sx={{ fontSize: 48, color: styles.primaryColor, opacity: 0.3, mb: 1 }} />
//                 <Typography variant="body2" color="text.secondary">
//                   Financial information will appear here for purchased animals.
//                 </Typography>
//               </Box>
//             </CardContent>
//           </Card>
//         </Grid>
//       )}

//       <Grid item xs={12} sm={6} md={4}>
//         <CompactInfoCard
//           title="Performance Metrics"
//           icon={<ScaleIcon />}
//           items={[
//             { primary: "Weaning Weight", secondary: animal?.weaning_weight ? `${animal.weaning_weight} kg` : 'N/A' },
//             { primary: "Yearling Weight", secondary: animal?.yearling_weight ? `${animal.yearling_weight} kg` : 'N/A' },
//             { primary: "Lactation Number", secondary: animal?.lactation_number || 'N/A' },
//             { primary: "Total Milk Production", secondary: animal?.total_lifetime_milk ? `${animal.total_lifetime_milk} L` : 'N/A' },
//           ]}
//         />
//       </Grid>
//     </Grid>
//   );

//   const NotesView = () => (
//     <Grid container spacing={2}>
//       <Grid item xs={12}>
//         <Card sx={styles.compactCard}>
//           <CardHeader
//             title="Additional Notes"
//             avatar={<NotesIcon sx={{ color: styles.primaryColor }} />}
//             sx={{ 
//               backgroundColor: styles.lightBackground,
//               '& .MuiCardHeader-title': { fontSize: '1rem', fontWeight: 'bold' }
//             }}
//           />
//           <CardContent>
//             <Typography 
//               variant="body2" 
//               sx={{ 
//                 minHeight: 60,
//                 p: 2,
//                 backgroundColor: styles.lightBackground,
//                 borderRadius: 1,
//                 lineHeight: 1.6
//               }}
//             >
//               {animal?.notes || 'No additional notes available.'}
//             </Typography>
//           </CardContent>
//         </Card>
//       </Grid>
//     </Grid>
//   );

//   const tabComponents = [
//     { label: 'Basic Info', component: editing ? <BasicInfoTab /> : <BasicInfoView /> },
//     { label: 'Physical Data', component: editing ? <PhysicalTab /> : <HealthReproductiveView /> },
//     { label: 'Health & Reproductive', component: editing ? <HealthReproductiveTab /> : <LocationManagementView /> },
//     { label: 'Location & Management', component: editing ? <LocationManagementTab /> : <EconomicGeneticView /> },
//     { label: 'Economic & Genetic', component: editing ? <EconomicGeneticTab /> : <NotesView /> },
//     { label: 'Additional Info', component: editing ? <NotesTab /> : <NotesView /> },
//   ];

//   const viewComponents = [
//     { label: 'Basic Info', component: <BasicInfoView /> },
//     { label: 'Health & Reproductive', component: <HealthReproductiveView /> },
//     { label: 'Location & Management', component: <LocationManagementView /> },
//     { label: 'Economic & Genetic', component: <EconomicGeneticView /> },
//     { label: 'Additional Info', component: <NotesView /> },
//   ];

//   if (loading) {
//     return (
//       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
//         <CircularProgress size={60} sx={{ color: styles.primaryColor }} />
//       </Box>
//     );
//   }

//   const completedCount = completion.filter(Boolean).length;
//   const totalSteps = formSteps.length;
//   const allCompleted = completedCount === totalSteps;

//   // Animal avatar based on species and gender
//   const getAnimalAvatar = () => {
//     const species = animal?.species?.toLowerCase() || 'cattle';
//     const isFemale = animal?.sex === 'Female';
    
//     if (species.includes('cattle')) {
//       return isFemale ? '🐄' : '🐂';
//     } else if (species.includes('goat')) {
//       return isFemale ? '🐐' : '🐐';
//     } else if (species.includes('sheep')) {
//       return '🐑';
//     } else if (species.includes('pig')) {
//       return '🐖';
//     } else {
//       return '🐾';
//     }
//   };

//   return (
//     <Box sx={{ 
//       flexGrow: 1, 
//       minHeight: '100vh',
//       backgroundColor: styles.lightBackground
//     }}>
//       {/* Header */}
//       <AppBar 
//         position="static" 
//         sx={{ 
//           backgroundColor: styles.primaryColor,
//           background: `linear-gradient(135deg, ${styles.primaryColor} 0%, #012e39 100%)`
//         }}
//       >
//         <Toolbar>
//           <IconButton
//             edge="start"
//             color="inherit"
//             onClick={() => navigate('/animals')}
//             sx={{ mr: 2 }}
//           >
//             <ArrowBackIcon />
//           </IconButton>
          
//           <Avatar
//             sx={{
//               mr: 2,
//               bgcolor: styles.secondaryColor,
//               width: 40,
//               height: 40
//             }}
//           >
//             {getAnimalAvatar()}
//           </Avatar>
          
//           <Box sx={{ flexGrow: 1 }}>
//             <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold', fontSize: { xs: '1.5rem', md: '2rem' } }}>
//               {isNew ? 'New Animal' : animal?.name || `Animal ${animal?.tag_number}`}
//             </Typography>
//             <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} sx={{ color: 'white', mt: 0.5 }}>
//               <Link color="inherit" onClick={() => navigate('/animals')} sx={{ cursor: 'pointer' }}>
//                 Animals
//               </Link>
//               <Typography color="inherit">
//                 {isNew ? 'New Animal' : animal?.tag_number}
//               </Typography>
//             </Breadcrumbs>
//           </Box>
          
//           {/* Auto-save indicator */}
//           {editing && hasUnsavedChanges && (
//             <Chip 
//               icon={<AutoAwesomeIcon />}
//               label="Unsaved Changes"
//               sx={{ 
//                 backgroundColor: '#ffeb3b',
//                 color: '#333',
//                 fontWeight: 'bold',
//                 mr: 2
//               }}
//             />
//           )}
          
//           {!isNew && animal?.lifecycle_state === 'Draft' && (
//             <Chip 
//               label="DRAFT" 
//               sx={{ 
//                 backgroundColor: styles.secondaryColor,
//                 color: styles.primaryColor,
//                 fontWeight: 'bold',
//                 mr: 2
//               }}
//             />
//           )}
          
//           {!isNew && !editing && (
//             <Button
//               variant="contained"
//               startIcon={<EditIcon />}
//               onClick={() => setEditing(true)}
//               sx={{ 
//                 backgroundColor: styles.secondaryColor,
//                 color: styles.primaryColor,
//                 fontWeight: 'bold',
//                 '&:hover': {
//                   backgroundColor: '#ffb74d',
//                 }
//               }}
//             >
//               {isMobile ? 'Edit' : 'Edit Animal'}
//             </Button>
//           )}
          
//           {editing && (
//             <>
//               <Button
//                 variant="outlined"
//                 startIcon={<CancelIcon />}
//                 onClick={() => {
//                   if (isNew) {
//                     navigate('/animals');
//                   } else {
//                     setEditing(false);
//                     setForm(animal);
//                     setHasUnsavedChanges(false);
//                   }
//                 }}
//                 sx={{ 
//                   borderColor: 'white',
//                   color: 'white',
//                   mr: 1,
//                   '&:hover': {
//                     borderColor: 'white',
//                     backgroundColor: 'rgba(255,255,255,0.1)'
//                   }
//                 }}
//               >
//                 {isMobile ? 'Cancel' : 'Cancel'}
//               </Button>
//               <Button
//                 variant="contained"
//                 startIcon={<SaveIcon />}
//                 onClick={() => setSaveModalOpen(true)}
//                 disabled={saving}
//                 sx={{ 
//                   backgroundColor: styles.secondaryColor,
//                   color: styles.primaryColor,
//                   fontWeight: 'bold',
//                   '&:hover': {
//                     backgroundColor: '#ffb74d',
//                   }
//                 }}
//               >
//                 {saving ? 'Saving...' : (isMobile ? 'Save' : 'Save All')}
//               </Button>
//             </>
//           )}
//         </Toolbar>
//       </AppBar>

//       <Container maxWidth="xl" sx={{ py: 3 }}>
//         {/* Progress Stepper - Only show in edit mode */}
//         {editing && (
//           <Paper sx={{ p: 3, mb: 3, boxShadow: styles.cardShadow }}>
//             <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
//               <Typography variant="h5" sx={{ color: styles.primaryColor, fontWeight: 'bold' }}>
//                 Completion Progress
//               </Typography>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//                 {autoSaving && (
//                   <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                     <CircularProgress size={16} sx={{ mr: 1 }} />
//                     <Typography variant="body2" color="text.secondary">
//                       Auto-saving...
//                     </Typography>
//                   </Box>
//                 )}
//                 <Chip 
//                   label={`${completedCount}/${totalSteps} completed`}
//                   color={allCompleted ? "success" : "default"}
//                   icon={allCompleted ? <CheckCircleIcon /> : undefined}
//                   sx={{ fontWeight: 'bold' }}
//                 />
//               </Box>
//             </Box>
//             <Stepper activeStep={-1} alternativeLabel>
//               {formSteps.map((step, index) => (
//                 <Step key={step.key} completed={completion[index]}>
//                   <StepLabel 
//                     StepIconComponent={() => (
//                       <Avatar
//                         sx={{
//                           bgcolor: completion[index] ? styles.secondaryColor : 'grey.300',
//                           color: completion[index] ? styles.primaryColor : 'grey.600',
//                           width: 32,
//                           height: 32
//                         }}
//                       >
//                         {step.icon}
//                       </Avatar>
//                     )}
//                   >
//                     {step.label}
//                   </StepLabel>
//                 </Step>
//               ))}
//             </Stepper>
//           </Paper>
//         )}

//         {/* Main Content */}
//         <Paper sx={{ boxShadow: styles.cardShadow }}>
//           {editing ? (
//             <>
//               <Tabs
//                 value={activeTab}
//                 onChange={(e, newValue) => setActiveTab(newValue)}
//                 indicatorColor="primary"
//                 textColor="primary"
//                 variant={isMobile ? "scrollable" : "standard"}
//                 scrollButtons={isMobile ? "auto" : false}
//                 sx={{ 
//                   borderBottom: 1, 
//                   borderColor: 'divider',
//                   '& .MuiTab-root': {
//                     fontWeight: 'bold',
//                     minWidth: { xs: 120, md: 160 }
//                   }
//                 }}
//               >
//                 {tabComponents.map((tab, index) => (
//                   <Tab 
//                     key={index}
//                     label={
//                       <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                         {tab.label}
//                         {completion[index] && (
//                           <CheckCircleIcon sx={{ fontSize: 16, ml: 1, color: 'success.main' }} />
//                         )}
//                       </Box>
//                     }
//                   />
//                 ))}
//               </Tabs>

//               <Box sx={{ p: { xs: 2, md: 3 } }}>
//                 {tabComponents[activeTab].component}
//               </Box>
//             </>
//           ) : (
//             <Box sx={{ p: { xs: 2, md: 3 } }}>
//               {viewComponents.map((section, index) => (
//                 <Box key={index} sx={{ mb: 4 }}>
//                   <Typography 
//                     variant="h5" 
//                     sx={{ 
//                       color: styles.primaryColor,
//                       fontWeight: 'bold',
//                       mb: 2,
//                       pb: 1,
//                       borderBottom: `2px solid ${styles.secondaryColor}`
//                     }}
//                   >
//                     {section.label}
//                   </Typography>
//                   {section.component}
//                 </Box>
//               ))}
//             </Box>
//           )}
//         </Paper>
//       </Container>

//       {/* Floating Action Button for Mobile */}
//       {!editing && !isNew && (
//         <Fab
//           color="primary"
//           aria-label="edit"
//           sx={{
//             position: 'fixed',
//             bottom: 24,
//             right: 24,
//             backgroundColor: styles.secondaryColor,
//             color: styles.primaryColor,
//             '&:hover': {
//               backgroundColor: '#ffb74d',
//             }
//           }}
//           onClick={() => setEditing(true)}
//         >
//           <EditIcon />
//         </Fab>
//       )}

//       {/* Save Confirmation Modal */}
//       <Dialog 
//         open={saveModalOpen} 
//         onClose={() => setSaveModalOpen(false)}
//         PaperProps={{ sx: { borderRadius: 2 } }}
//       >
//         <DialogTitle sx={{ color: styles.primaryColor, fontWeight: 'bold' }}>
//           Save Changes
//         </DialogTitle>
//         <DialogContent>
//           <Typography>
//             {allCompleted && animal?.lifecycle_state === 'Draft' 
//               ? "All sections are complete! You can save changes and submit for approval to activate this animal record."
//               : "Save your changes to this animal record?"}
//           </Typography>
//           {allCompleted && animal?.lifecycle_state === 'Draft' && (
//             <Alert severity="success" sx={{ mt: 2 }}>
//               All required information has been completed. This animal is ready to be activated.
//             </Alert>
//           )}
//         </DialogContent>
//         <DialogActions sx={{ p: 3, gap: 1 }}>
//           <Button 
//             onClick={() => setSaveModalOpen(false)}
//             variant="outlined"
//           >
//             Cancel
//           </Button>
//           <Button 
//             onClick={saveSection}
//             variant="contained"
//             sx={{ 
//               backgroundColor: styles.primaryColor,
//               '&:hover': {
//                 backgroundColor: '#012e39'
//               }
//             }}
//           >
//             Save Only
//           </Button>
//           {allCompleted && animal?.lifecycle_state === 'Draft' && (
//             <Button 
//               onClick={handleSubmitForApproval}
//               variant="contained"
//               sx={{ 
//                 backgroundColor: styles.secondaryColor,
//                 color: styles.primaryColor,
//                 fontWeight: 'bold',
//                 '&:hover': {
//                   backgroundColor: '#ffb74d'
//                 }
//               }}
//             >
//               Save & Activate
//             </Button>
//           )}
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default AnimalDetailPage;




// import React, { useState, useEffect, useCallback, memo } from "react";
// import {
//   Box,
//   Typography,
//   Button,
//   TextField,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Chip,
//   IconButton,
//   Paper,
//   Grid,
//   Card,
//   CardContent,
//   CardHeader,
//   Tabs,
//   Tab,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Stepper,
//   Step,
//   StepLabel,
//   Alert,
//   CircularProgress,
//   Divider,
//   Switch,
//   FormControlLabel,
//   AppBar,
//   Toolbar,
//   Avatar,
//   List,
//   ListItem,
//   ListItemText,
//   ListItemIcon,
//   useTheme,
//   useMediaQuery,
//   Container,
//   Fab,
//   Breadcrumbs,
//   Link,
//   Stack,
// } from "@mui/material";
// import {
//   ArrowBack as ArrowBackIcon,
//   Edit as EditIcon,
//   Save as SaveIcon,
//   Cancel as CancelIcon,
//   Pets as PetsIcon,
//   CheckCircle as CheckCircleIcon,
//   NavigateNext as NavigateNextIcon,
//   Scale as ScaleIcon,
//   Favorite as FavoriteIcon,
//   LocationOn as LocationIcon,
//   AttachMoney as MoneyIcon,
//   Notes as NotesIcon,
//   CalendarToday as CalendarIcon,
//   Female as FemaleIcon,
//   Male as MaleIcon,
//   LocalHospital as HealthIcon,
//   Agriculture as AgricultureIcon,
//   Science as ScienceIcon,
//   AutoAwesome as AutoAwesomeIcon,
// } from "@mui/icons-material";
// import { useParams, useNavigate } from "react-router-dom";
// import swal from "sweetalert";

// // Custom styles - moved outside component to prevent recreation
// const styles = {
//   primaryColor: '#024a59',
//   secondaryColor: '#ffa916',
//   lightBackground: '#f8f9fa',
//   cardShadow: '0 4px 12px rgba(2, 74, 89, 0.1)',
//   sectionSpacing: { xs: 2, md: 3 },
//   compactCard: {
//     height: '100%',
//     boxShadow: '0 2px 8px rgba(2, 74, 89, 0.08)',
//     transition: 'all 0.3s ease',
//     '&:hover': {
//       boxShadow: '0 4px 16px rgba(2, 74, 89, 0.15)',
//       transform: 'translateY(-2px)'
//     }
//   }
// };

// // Initial empty form - moved outside component
// const initialForm = {
//   // Basic identification
//   tag_number: "",
//   name: "",
//   species: "Cattle",
//   breed: "",
//   dob: "",
  
//   // Gender and animal class
//   sex: "Female",
//   animal_class: "",
  
//   // Genetic information
//   sire_id: "",
//   dam_id: "",
//   registration_number: "",
//   genetic_score: "",
//   breed_composition: "",
  
//   // Physical characteristics
//   color: "",
//   birth_weight: "",
//   current_weight: "",
//   height: "",
//   weaning_weight: "",
//   yearling_weight: "",
  
//   // Reproductive status
//   reproductive_status: "",
//   last_calving_date: "",
//   number_of_calves: "",
//   pregnancy_status: "",
//   lactation_number: "",
//   days_bred: "",
  
//   // Male specific
//   semen_status: "",
//   breeding_capacity: "",
  
//   // Milking data
//   milking_status: "",
//   is_milking_cow: false,
//   last_milking_date: "",
//   days_in_milk: "",
//   average_milk_yield: "",
//   total_lifetime_milk: "",
  
//   // Health and management
//   health_status: "Healthy",
//   vaccination_status: "",
//   last_vet_visit: "",
//   next_vet_visit: "",
  
//   // Location and management
//   location: "",
//   pen_group: "",
//   herd_id: "",
  
//   // Lifecycle management
//   lifecycle_state: "Draft",
//   entry_date: "",
//   exit_date: "",
//   exit_reason: "",
  
//   // Economic data
//   purchase_price: "",
//   sale_price: "",
//   estimated_value: "",
  
//   // Purchase specific
//   origin: "",
//   purchase_conditions: "",
  
//   // Additional metadata
//   notes: "",
  
//   // Animal type
//   animal_type: "born"
// };

// // Form steps for completion tracking - moved outside
// const formSteps = [
//   { key: 'basic', label: 'Basic Info', completed: false, icon: <PetsIcon /> },
//   { key: 'physical', label: 'Physical Data', completed: false, icon: <ScaleIcon /> },
//   { key: 'health', label: 'Health & Reproductive', completed: false, icon: <HealthIcon /> },
//   { key: 'location', label: 'Location & Management', completed: false, icon: <LocationIcon /> },
//   { key: 'economic', label: 'Economic & Genetic', completed: false, icon: <MoneyIcon /> },
//   { key: 'notes', label: 'Additional Info', completed: false, icon: <NotesIcon /> },
// ];

// // Compact Info Card Component - memoized
// const CompactInfoCard = memo(({ title, icon, items }) => (
//   <Card sx={styles.compactCard}>
//     <CardHeader
//       title={title}
//       avatar={React.cloneElement(icon, { sx: { color: styles.primaryColor } })}
//       sx={{ 
//         backgroundColor: styles.lightBackground,
//         pb: 1,
//         '& .MuiCardHeader-title': { fontSize: '1rem', fontWeight: 'bold' }
//       }}
//     />
//     <CardContent sx={{ pt: 1, '&:last-child': { pb: 2 } }}>
//       <List dense disablePadding>
//         {items.map((item, index) => (
//           <ListItem key={index} disablePadding sx={{ py: 0.5 }}>
//             <ListItemText 
//               primary={item.primary}
//               secondary={item.secondary}
//               primaryTypographyProps={{ variant: 'body2', fontWeight: 'medium' }}
//               secondaryTypographyProps={{ variant: 'body2', color: 'text.primary' }}
//             />
//           </ListItem>
//         ))}
//       </List>
//     </CardContent>
//   </Card>
// ));

// // Tab Components - memoized to prevent unnecessary re-renders
// const BasicInfoTab = memo(({ form, onFormChange, options }) => {
//   const handleChange = useCallback((e) => {
//     onFormChange(e);
//   }, [onFormChange]);

//   return (
//     <Box>
//       <Grid container spacing={2}>
//         <Grid item xs={12} md={6}>
//           <FormControl fullWidth
//                 sx={{
//                   minWidth: { xs: '100%', sm: 250, md: 300 },
//                 }}>
//             <InputLabel>Animal Type</InputLabel>
//             <Select
//               name="animal_type"
//               value={form.animal_type || ""}
//               onChange={handleChange}
//               label="Animal Type"
//             >
//               <MenuItem value="born">Born on Farm</MenuItem>
//               <MenuItem value="purchased">Purchased</MenuItem>
//             </Select>
//           </FormControl>
//         </Grid>
        
//         <Grid item xs={12} md={6}>
//           <TextField
//             fullWidth
//             label="Tag Number *"
//             name="tag_number"
//             value={form.tag_number || ""}
//             onChange={handleChange}
//             required
//           />
//         </Grid>

//         <Grid item xs={12} md={6}>
//           <TextField
//             fullWidth
//             label="Name"
//             name="name"
//             value={form.name || ""}
//             onChange={handleChange}
//           />
//         </Grid>
        
//         <Grid item xs={12} md={6}>
//           <FormControl fullWidth
//                 sx={{
//                   minWidth: { xs: '100%', sm: 250, md: 300 },
//                 }}>
//             <InputLabel>Species</InputLabel>
//             <Select
//               name="species"
//               value={form.species || ""}
//               onChange={handleChange}
//               label="Species"
//             >
//               {options.species.map(species => (
//                 <MenuItem key={species} value={species}>{species}</MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Grid>

//         <Grid item xs={12} md={6}>
//           <FormControl fullWidth
//                 sx={{
//                   minWidth: { xs: '100%', sm: 250, md: 300 },
//                 }}>
//             <InputLabel>Breed *</InputLabel>
//             <Select
//               name="breed"
//               value={form.breed || ""}
//               onChange={handleChange}
//               label="Breed *"
//               required
//             >
//               <MenuItem value="">Select Breed</MenuItem>
//               {options.breeds[form.species]?.map(breed => (
//                 <MenuItem key={breed} value={breed}>{breed}</MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Grid>
        
//         <Grid item xs={12} md={6}>
//           <TextField
//             fullWidth
//             label="Date of Birth *"
//             name="dob"
//             type="date"
//             value={form.dob || ""}
//             onChange={handleChange}
//             InputLabelProps={{ shrink: true }}
//             required
//           />
//         </Grid>

//         <Grid item xs={12} md={6}>
//           <FormControl fullWidth
//                 sx={{
//                   minWidth: { xs: '100%', sm: 250, md: 300 },
//                 }}>
//             <InputLabel>Gender *</InputLabel>
//             <Select
//               name="sex"
//               value={form.sex || ""}
//               onChange={handleChange}
//               label="Gender *"
//               required
//             >
//               {options.sexes.map(sex => (
//                 <MenuItem key={sex} value={sex}>{sex}</MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Grid>
        
//         <Grid item xs={12} md={6}>
//           <FormControl fullWidth
//                 sx={{
//                   minWidth: { xs: '100%', sm: 250, md: 300 },
//                 }}>
//             <InputLabel>Animal Class</InputLabel>
//             <Select
//               name="animal_class"
//               value={form.animal_class || ""}
//               onChange={handleChange}
//               label="Animal Class"
//             >
//               <MenuItem value="">Select Class</MenuItem>
//               {options.animal_classes[form.species]?.[form.sex]?.map(cls => (
//                 <MenuItem key={cls} value={cls}>{cls}</MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Grid>

//         <Grid item xs={12} md={6}>
//           <TextField
//             fullWidth
//             label="Color"
//             name="color"
//             value={form.color || ""}
//             onChange={handleChange}
//           />
//         </Grid>

//         <Grid item xs={12} md={6}>
//           <FormControl fullWidth
//                 sx={{
//                   minWidth: { xs: '100%', sm: 250, md: 300 },
//                 }}>
//             <InputLabel>Lifecycle State</InputLabel>
//             <Select
//               name="lifecycle_state"
//               value={form.lifecycle_state || ""}
//               onChange={handleChange}
//               label="Lifecycle State"
//             >
//               {options.lifecycle_states.map(state => (
//                 <MenuItem key={state} value={state}>{state}</MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Grid>
//       </Grid>
//     </Box>
//   );
// });

// const PhysicalTab = memo(({ form, onFormChange }) => {
//   const handleChange = useCallback((e) => {
//     onFormChange(e);
//   }, [onFormChange]);

//   return (
//     <Box>
//       <Grid container spacing={2}>
//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Birth Weight (kg)"
//             name="birth_weight"
//             type="number"
//             value={form.birth_weight || ""}
//             onChange={handleChange}
//             InputProps={{ inputProps: { min: 0, step: 0.1 } }}
//           />
//         </Grid>
        
//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Current Weight (kg)"
//             name="current_weight"
//             type="number"
//             value={form.current_weight || ""}
//             onChange={handleChange}
//             InputProps={{ inputProps: { min: 0, step: 0.1 } }}
//           />
//         </Grid>

//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Height (cm)"
//             name="height"
//             type="number"
//             value={form.height || ""}
//             onChange={handleChange}
//             InputProps={{ inputProps: { min: 0, step: 0.1 } }}
//           />
//         </Grid>
        
//         <Grid item xs={12} sm={6} md={4}>
          
//           <TextField
//             fullWidth
//             label="Weaning Weight (kg)"
//             name="weaning_weight"
//             type="number"
//             value={form.weaning_weight || ""}
//             onChange={handleChange}
//             InputProps={{ inputProps: { min: 0, step: 0.1 } }}
//           />
//         </Grid>

//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Yearling Weight (kg)"
//             name="yearling_weight"
//             type="number"
//             value={form.yearling_weight || ""}
//             onChange={handleChange}
//             InputProps={{ inputProps: { min: 0, step: 0.1 } }}
//           />
//         </Grid>
//       </Grid>
//     </Box>
//   );
// });

// const HealthReproductiveTab = memo(({ form, onFormChange, options }) => {
//   const handleChange = useCallback((e) => {
//     onFormChange(e);
//   }, [onFormChange]);

//   return (
//     <Box>
//       <Grid container spacing={2}>
//         <Grid item xs={12} sm={6} md={4}>
//           <FormControl fullWidth
//                 sx={{
//                   minWidth: { xs: '100%', sm: 250, md: 300 },
//                 }}>
//             <InputLabel>Health Status</InputLabel>
//             <Select
//               name="health_status"
//               value={form.health_status || ""}
//               onChange={handleChange}
//               label="Health Status"
//             >
//               {options.health_statuses.map(status => (
//                 <MenuItem key={status} value={status}>{status}</MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Grid>
        
//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Vaccination Status"
//             name="vaccination_status"
//             value={form.vaccination_status || ""}
//             onChange={handleChange}
//           />
//         </Grid>

//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Last Vet Visit"
//             name="last_vet_visit"
//             type="date"
//             value={form.last_vet_visit || ""}
//             onChange={handleChange}
//             InputLabelProps={{ shrink: true }}
//           />
//         </Grid>
        
//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Next Vet Visit"
//             name="next_vet_visit"
//             type="date"
//             value={form.next_vet_visit || ""}
//             onChange={handleChange}
//             InputLabelProps={{ shrink: true }}
//           />
//         </Grid>

//         {form.sex === 'Female' && (
//           <>
//             <Grid item xs={12} sm={6} md={4}>
//               <FormControl fullWidth
//                 sx={{
//                   minWidth: { xs: '100%', sm: 250, md: 300 },
//                 }}>
//                 <InputLabel>Reproductive Status</InputLabel>
//                 <Select
//                   name="reproductive_status"
//                   value={form.reproductive_status || ""}
//                   onChange={handleChange}
//                   label="Reproductive Status"
//                 >
//                   <MenuItem value="">Select Status</MenuItem>
//                   {options.reproductive_statuses.map(status => (
//                     <MenuItem key={status} value={status}>{status}</MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>
            
//             <Grid item xs={12} sm={6} md={4}>
//               <FormControl fullWidth
//                 sx={{
//                   minWidth: { xs: '100%', sm: 250, md: 300 },
//                 }}>
//                 <InputLabel>Pregnancy Status</InputLabel>
//                 <Select
//                   name="pregnancy_status"
//                   value={form.pregnancy_status || ""}
//                   onChange={handleChange}
//                   label="Pregnancy Status"
//                 >
//                   <MenuItem value="">Select Status</MenuItem>
//                   {options.pregnancy_statuses.map(status => (
//                     <MenuItem key={status} value={status}>{status}</MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>

//             <Grid item xs={12} sm={6} md={4}>
//               <TextField
//                 fullWidth
//                 label="Last Calving Date"
//                 name="last_calving_date"
//                 type="date"
//                 value={form.last_calving_date || ""}
//                 onChange={handleChange}
//                 InputLabelProps={{ shrink: true }}
//               />
//             </Grid>
            
//             <Grid item xs={12} sm={6} md={4}>
//               <TextField
//                 fullWidth
//                 label="Number of Calves"
//                 name="number_of_calves"
//                 type="number"
//                 value={form.number_of_calves || ""}
//                 onChange={handleChange}
//                 InputProps={{ inputProps: { min: 0 } }}
//               />
//             </Grid>

//             <Grid item xs={12} sm={6} md={4}>
//               <TextField
//                 fullWidth
//                 label="Lactation Number"
//                 name="lactation_number"
//                 type="number"
//                 value={form.lactation_number || ""}
//                 onChange={handleChange}
//                 InputProps={{ inputProps: { min: 0 } }}
//               />
//             </Grid>
            
//             <Grid item xs={12} sm={6} md={4}>
//               <TextField
//                 fullWidth
//                 label="Days Bred"
//                 name="days_bred"
//                 type="number"
//                 value={form.days_bred || ""}
//                 onChange={handleChange}
//                 InputProps={{ inputProps: { min: 0 } }}
//               />
//             </Grid>

//             <Grid item xs={12} sm={6} md={4}>
//               <FormControl fullWidth
//                 sx={{
//                   minWidth: { xs: '100%', sm: 250, md: 300 },
//                 }}>
//                 <InputLabel>Milking Status</InputLabel>
//                 <Select
//                   name="milking_status"
//                   value={form.milking_status || ""}
//                   onChange={handleChange}
//                   label="Milking Status"
//                 >
//                   <MenuItem value="">Select Status</MenuItem>
//                   {options.milking_statuses.map(status => (
//                     <MenuItem key={status} value={status}>{status}</MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>
            
//             <Grid item xs={12} sm={6} md={4}>
//               <FormControlLabel
//                 control={
//                   <Switch
//                     name="is_milking_cow"
//                     checked={form.is_milking_cow || false}
//                     onChange={handleChange}
//                   />
//                 }
//                 label="Is Milking Cow"
//               />
//             </Grid>

//             <Grid item xs={12} sm={6} md={4}>
//               <TextField
//                 fullWidth
//                 label="Last Milking Date"
//                 name="last_milking_date"
//                 type="date"
//                 value={form.last_milking_date || ""}
//                 onChange={handleChange}
//                 InputLabelProps={{ shrink: true }}
//               />
//             </Grid>
            
//             <Grid item xs={12} sm={6} md={4}>
//               <TextField
//                 fullWidth
//                 label="Days in Milk"
//                 name="days_in_milk"
//                 type="number"
//                 value={form.days_in_milk || ""}
//                 onChange={handleChange}
//                 InputProps={{ inputProps: { min: 0 } }}
//               />
//             </Grid>

//             <Grid item xs={12} sm={6} md={4}>
//               <TextField
//                 fullWidth
//                 label="Avg Milk Yield (L/day)"
//                 name="average_milk_yield"
//                 type="number"
//                 value={form.average_milk_yield || ""}
//                 onChange={handleChange}
//                 InputProps={{ inputProps: { min: 0, step: 0.1 } }}
//               />
//             </Grid>
            
//             <Grid item xs={12} sm={6} md={4}>
//               <TextField
//                 fullWidth
//                 label="Total Lifetime Milk (L)"
//                 name="total_lifetime_milk"
//                 type="number"
//                 value={form.total_lifetime_milk || ""}
//                 onChange={handleChange}
//                 InputProps={{ inputProps: { min: 0, step: 0.1 } }}
//               />
//             </Grid>
//           </>
//         )}

//         {form.sex === 'Male' && (
//           <>
//             <Grid item xs={12} sm={6} md={4}>
//               <FormControl fullWidth
//                 sx={{
//                   minWidth: { xs: '100%', sm: 250, md: 300 },
//                 }}>
//                 <InputLabel>Semen Status</InputLabel>
//                 <Select
//                   name="semen_status"
//                   value={form.semen_status || ""}
//                   onChange={handleChange}
//                   label="Semen Status"
//                 >
//                   <MenuItem value="">Select Status</MenuItem>
//                   {options.semen_statuses.map(status => (
//                     <MenuItem key={status} value={status}>{status}</MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>
            
//             <Grid item xs={12} sm={6} md={4}>
//               <TextField
//                 fullWidth
//                 label="Breeding Capacity"
//                 name="breeding_capacity"
//                 value={form.breeding_capacity || ""}
//                 onChange={handleChange}
//               />
//             </Grid>
//           </>
//         )}
//       </Grid>
//     </Box>
//   );
// });

// const LocationManagementTab = memo(({ form, onFormChange }) => {
//   const handleChange = useCallback((e) => {
//     onFormChange(e);
//   }, [onFormChange]);

//   return (
//     <Box>
//       <Grid container spacing={2}>
//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Location"
//             name="location"
//             value={form.location || ""}
//             onChange={handleChange}
//           />
//         </Grid>
        
//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Pen/Group"
//             name="pen_group"
//             value={form.pen_group || ""}
//             onChange={handleChange}
//           />
//         </Grid>

//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Herd ID"
//             name="herd_id"
//             value={form.herd_id || ""}
//             onChange={handleChange}
//           />
//         </Grid>

//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Entry Date"
//             name="entry_date"
//             type="date"
//             value={form.entry_date || ""}
//             onChange={handleChange}
//             InputLabelProps={{ shrink: true }}
//           />
//         </Grid>
        
//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Exit Date"
//             name="exit_date"
//             type="date"
//             value={form.exit_date || ""}
//             onChange={handleChange}
//             InputLabelProps={{ shrink: true }}
//           />
//         </Grid>

//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Exit Reason"
//             name="exit_reason"
//             value={form.exit_reason || ""}
//             onChange={handleChange}
//           />
//         </Grid>
//       </Grid>
//     </Box>
//   );
// });

// const EconomicGeneticTab = memo(({ form, onFormChange }) => {
//   const handleChange = useCallback((e) => {
//     onFormChange(e);
//   }, [onFormChange]);

//   return (
//     <Box>
//       <Grid container spacing={2}>
//         {form.animal_type === 'purchased' && (
//           <>
//             <Grid item xs={12} sm={6} md={4}>
//               <TextField
//                 fullWidth
//                 label="Purchase Price ($)"
//                 name="purchase_price"
//                 type="number"
//                 value={form.purchase_price || ""}
//                 onChange={handleChange}
//                 InputProps={{ inputProps: { min: 0, step: 0.01 } }}
//               />
//             </Grid>
            
//             <Grid item xs={12} sm={6} md={4}>
//               <TextField
//                 fullWidth
//                 label="Sale Price ($)"
//                 name="sale_price"
//                 type="number"
//                 value={form.sale_price || ""}
//                 onChange={handleChange}
//                 InputProps={{ inputProps: { min: 0, step: 0.01 } }}
//               />
//             </Grid>

//             <Grid item xs={12} sm={6} md={4}>
//               <TextField
//                 fullWidth
//                 label="Estimated Value ($)"
//                 name="estimated_value"
//                 type="number"
//                 value={form.estimated_value || ""}
//                 onChange={handleChange}
//                 InputProps={{ inputProps: { min: 0, step: 0.01 } }}
//               />
//             </Grid>
            
//             <Grid item xs={12} sm={6} md={4}>
//               <TextField
//                 fullWidth
//                 label="Origin"
//                 name="origin"
//                 value={form.origin || ""}
//                 onChange={handleChange}
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <TextField
//                 fullWidth
//                 label="Purchase Conditions"
//                 name="purchase_conditions"
//                 multiline
//                 rows={3}
//                 value={form.purchase_conditions || ""}
//                 onChange={handleChange}
//               />
//             </Grid>
//             <Grid item xs={12}><Divider sx={{ my: 2 }} /></Grid>
//           </>
//         )}

//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Sire ID"
//             name="sire_id"
//             type="number"
//             value={form.sire_id || ""}
//             onChange={handleChange}
//             InputProps={{ inputProps: { min: 0 } }}
//           />
//         </Grid>
        
//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Dam ID"
//             name="dam_id"
//             type="number"
//             value={form.dam_id || ""}
//             onChange={handleChange}
//             InputProps={{ inputProps: { min: 0 } }}
//           />
//         </Grid>

//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Registration Number"
//             name="registration_number"
//             value={form.registration_number || ""}
//             onChange={handleChange}
//           />
//         </Grid>
        
//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Genetic Score"
//             name="genetic_score"
//             type="number"
//             value={form.genetic_score || ""}
//             onChange={handleChange}
//             InputProps={{ inputProps: { min: 0, step: 0.1 } }}
//           />
//         </Grid>

//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Breed Composition"
//             name="breed_composition"
//             value={form.breed_composition || ""}
//             onChange={handleChange}
//           />
//         </Grid>
//       </Grid>
//     </Box>
//   );
// });

// const NotesTab = memo(({ form, onFormChange }) => {
//   const handleChange = useCallback((e) => {
//     onFormChange(e);
//   }, [onFormChange]);

//   return (
//     <Box>
//       <Grid container spacing={2}>
//         <Grid item xs={12}>
//           <TextField
//             fullWidth
//             label="Notes"
//             name="notes"
//             multiline
//             rows={6}
//             value={form.notes || ""}
//             onChange={handleChange}
//             placeholder="Additional notes about the animal..."
//           />
//         </Grid>
//       </Grid>
//     </Box>
//   );
// });

// // View Components - memoized
// const BasicInfoView = memo(({ animal, formatDate, calculateAge }) => (
//   <Grid container spacing={2}>
//     <Grid item xs={12} sm={6} md={3}>
//       <CompactInfoCard
//         title="Identification"
//         icon={<PetsIcon />}
//         items={[
//           { primary: "Tag Number", secondary: animal?.tag_number || 'N/A' },
//           { primary: "Name", secondary: animal?.name || 'N/A' },
//           { primary: "Species", secondary: animal?.species || 'N/A' },
//           { primary: "Breed", secondary: animal?.breed || 'N/A' },
//         ]}
//       />
//     </Grid>

//     <Grid item xs={12} sm={6} md={3}>
//       <CompactInfoCard
//         title="Demographics"
//         icon={<CalendarIcon />}
//         items={[
//           { primary: "Date of Birth", secondary: formatDate(animal?.dob) },
//           { primary: "Age", secondary: calculateAge(animal?.dob) },
//           { primary: "Gender", secondary: animal?.sex || 'N/A' },
//           { primary: "Animal Class", secondary: animal?.animal_class || 'N/A' },
//         ]}
//       />
//     </Grid>

//     <Grid item xs={12} sm={6} md={3}>
//       <CompactInfoCard
//         title="Status & Appearance"
//         icon={<PetsIcon />}
//         items={[
//           { primary: "Color", secondary: animal?.color || 'N/A' },
//           { primary: "Animal Type", secondary: animal?.purchase_price ? "PURCHASED" : "BORN" },
//           { primary: "Lifecycle State", secondary: animal?.lifecycle_state || 'N/A' },
//         ]}
//       />
//     </Grid>

//     <Grid item xs={12} sm={6} md={3}>
//       <CompactInfoCard
//         title="Physical Data"
//         icon={<ScaleIcon />}
//         items={[
//           { primary: "Current Weight", secondary: animal?.current_weight ? `${animal.current_weight} kg` : 'N/A' },
//           { primary: "Height", secondary: animal?.height ? `${animal.height} cm` : 'N/A' },
//           { primary: "Birth Weight", secondary: animal?.birth_weight ? `${animal.birth_weight} kg` : 'N/A' },
//         ]}
//       />
//     </Grid>
//   </Grid>
// ));

// const HealthReproductiveView = memo(({ animal, formatDate }) => (
//   <Grid container spacing={2}>
//     <Grid item xs={12} sm={6} md={4}>
//       <CompactInfoCard
//         title="Health Status"
//         icon={<HealthIcon />}
//         items={[
//           { primary: "Health Status", secondary: animal?.health_status || 'N/A' },
//           { primary: "Vaccination Status", secondary: animal?.vaccination_status || 'N/A' },
//           { primary: "Last Vet Visit", secondary: formatDate(animal?.last_vet_visit) },
//           { primary: "Next Vet Visit", secondary: formatDate(animal?.next_vet_visit) },
//         ]}
//       />
//     </Grid>

//     {animal?.sex === 'Female' && (
//       <Grid item xs={12} sm={6} md={4}>
//         <CompactInfoCard
//           title="Reproductive Health"
//           icon={<FavoriteIcon />}
//           items={[
//             { primary: "Reproductive Status", secondary: animal?.reproductive_status || 'N/A' },
//             { primary: "Pregnancy Status", secondary: animal?.pregnancy_status || 'N/A' },
//             { primary: "Last Calving Date", secondary: formatDate(animal?.last_calving_date) },
//             { primary: "Number of Calves", secondary: animal?.number_of_calves || 'N/A' },
//             ...(animal?.is_milking_cow ? [
//               { primary: "Milking Status", secondary: animal?.milking_status || 'N/A' },
//               { primary: "Avg Milk Yield", secondary: animal?.average_milk_yield ? `${animal.average_milk_yield} L/day` : 'N/A' },
//             ] : [])
//           ]}
//         />
//       </Grid>
//     )}

//     {animal?.sex === 'Male' && (
//       <Grid item xs={12} sm={6} md={4}>
//         <CompactInfoCard
//           title="Breeding Information"
//           icon={<MaleIcon />}
//           items={[
//             { primary: "Semen Status", secondary: animal?.semen_status || 'N/A' },
//             { primary: "Breeding Capacity", secondary: animal?.breeding_capacity || 'N/A' },
//           ]}
//         />
//       </Grid>
//     )}

//     {((animal?.sex === 'Female' && window.innerWidth >= 960) || 
//       (animal?.sex === 'Male' && window.innerWidth >= 960)) && (
//       <Grid item xs={12} sm={6} md={4}>
//         <Card sx={{ ...styles.compactCard, height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//           <CardContent>
//             <Box textAlign="center">
//               <HealthIcon sx={{ fontSize: 48, color: styles.primaryColor, opacity: 0.3, mb: 1 }} />
//               <Typography variant="body2" color="text.secondary">
//                 Additional health metrics and reproductive data will appear here as they are recorded.
//               </Typography>
//             </Box>
//           </CardContent>
//         </Card>
//       </Grid>
//     )}
//   </Grid>
// ));

// const LocationManagementView = memo(({ animal, formatDate, lastSaved, completion }) => (
//   <Grid container spacing={2}>
//     <Grid item xs={12} sm={6} md={4}>
//       <CompactInfoCard
//         title="Location Details"
//         icon={<LocationIcon />}
//         items={[
//           { primary: "Location", secondary: animal?.location || 'N/A' },
//           { primary: "Pen/Group", secondary: animal?.pen_group || 'N/A' },
//           { primary: "Herd ID", secondary: animal?.herd_id || 'N/A' },
//         ]}
//       />
//     </Grid>

//     <Grid item xs={12} sm={6} md={4}>
//       <CompactInfoCard
//         title="Lifecycle Management"
//         icon={<CalendarIcon />}
//         items={[
//           { primary: "Entry Date", secondary: formatDate(animal?.entry_date) },
//           { primary: "Exit Date", secondary: formatDate(animal?.exit_date) },
//           { primary: "Exit Reason", secondary: animal?.exit_reason || 'N/A' },
//         ]}
//       />
//     </Grid>

//     <Grid item xs={12} sm={6} md={4}>
//       <CompactInfoCard
//         title="Quick Actions"
//         icon={<AutoAwesomeIcon />}
//         items={[
//           { primary: "Status", secondary: animal?.lifecycle_state || 'N/A' },
//           { primary: "Last Updated", secondary: lastSaved ? formatDate(lastSaved) : 'N/A' },
//           { primary: "Record Complete", secondary: completion.filter(Boolean).length + '/' + completion.length },
//         ]}
//       />
//     </Grid>
//   </Grid>
// ));

// const EconomicGeneticView = memo(({ animal }) => (
//   <Grid container spacing={2}>
//     {animal?.purchase_price && (
//       <Grid item xs={12} sm={6} md={4}>
//         <CompactInfoCard
//           title="Financial Information"
//           icon={<MoneyIcon />}
//           items={[
//             { primary: "Purchase Price", secondary: animal?.purchase_price ? `$${animal.purchase_price}` : 'N/A' },
//             { primary: "Sale Price", secondary: animal?.sale_price ? `$${animal.sale_price}` : 'N/A' },
//             { primary: "Estimated Value", secondary: animal?.estimated_value ? `$${animal.estimated_value}` : 'N/A' },
//             { primary: "Origin", secondary: animal?.origin || 'N/A' },
//           ]}
//         />
//       </Grid>
//     )}

//     <Grid item xs={12} sm={6} md={4}>
//       <CompactInfoCard
//         title="Genetic Information"
//         icon={<ScienceIcon />}
//         items={[
//           { primary: "Sire ID", secondary: animal?.sire_id || 'N/A' },
//           { primary: "Dam ID", secondary: animal?.dam_id || 'N/A' },
//           { primary: "Registration Number", secondary: animal?.registration_number || 'N/A' },
//           { primary: "Genetic Score", secondary: animal?.genetic_score || 'N/A' },
//           { primary: "Breed Composition", secondary: animal?.breed_composition || 'N/A' },
//         ]}
//       />
//     </Grid>

//     {!animal?.purchase_price && (
//       <Grid item xs={12} sm={6} md={4}>
//         <Card sx={{ ...styles.compactCard, height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//           <CardContent>
//             <Box textAlign="center">
//               <MoneyIcon sx={{ fontSize: 48, color: styles.primaryColor, opacity: 0.3, mb: 1 }} />
//               <Typography variant="body2" color="text.secondary">
//                 Financial information will appear here for purchased animals.
//               </Typography>
//             </Box>
//           </CardContent>
//         </Card>
//       </Grid>
//     )}

//     <Grid item xs={12} sm={6} md={4}>
//       <CompactInfoCard
//         title="Performance Metrics"
//         icon={<ScaleIcon />}
//         items={[
//           { primary: "Weaning Weight", secondary: animal?.weaning_weight ? `${animal.weaning_weight} kg` : 'N/A' },
//           { primary: "Yearling Weight", secondary: animal?.yearling_weight ? `${animal.yearling_weight} kg` : 'N/A' },
//           { primary: "Lactation Number", secondary: animal?.lactation_number || 'N/A' },
//           { primary: "Total Milk Production", secondary: animal?.total_lifetime_milk ? `${animal.total_lifetime_milk} L` : 'N/A' },
//         ]}
//       />
//     </Grid>
//   </Grid>
// ));

// const NotesView = memo(({ animal }) => (
//   <Grid container spacing={2}>
//     <Grid item xs={12}>
//       <Card sx={styles.compactCard}>
//         <CardHeader
//           title="Additional Notes"
//           avatar={<NotesIcon sx={{ color: styles.primaryColor }} />}
//           sx={{ 
//             backgroundColor: styles.lightBackground,
//             '& .MuiCardHeader-title': { fontSize: '1rem', fontWeight: 'bold' }
//           }}
//         />
//         <CardContent>
//           <Typography 
//             variant="body2" 
//             sx={{ 
//               minHeight: 60,
//               p: 2,
//               backgroundColor: styles.lightBackground,
//               borderRadius: 1,
//               lineHeight: 1.6
//             }}
//           >
//             {animal?.notes || 'No additional notes available.'}
//           </Typography>
//         </CardContent>
//       </Card>
//     </Grid>
//   </Grid>
// ));

// // Save Actions Component - memoized
// const SaveActions = memo(({ onSaveSection, onSaveAndNext, saving, autoSaving }) => (
//   <Box sx={{ mt: 3, pt: 2, borderTop: 1, borderColor: 'divider' }}>
//     <Stack direction="row" spacing={2} justifyContent="flex-end">
//       {autoSaving && (
//         <Box sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
//           <CircularProgress size={20} sx={{ mr: 1 }} />
//           <Typography variant="body2" color="text.secondary">
//             Auto-saving...
//           </Typography>
//         </Box>
//       )}
//       <Button
//         variant="outlined"
//         onClick={onSaveSection}
//         disabled={saving}
//       >
//         {saving ? 'Saving...' : 'Save This Section'}
//       </Button>
//       <Button
//         variant="contained"
//         onClick={onSaveAndNext}
//         disabled={saving}
//         sx={{ 
//           backgroundColor: styles.primaryColor,
//           '&:hover': { backgroundColor: '#012e39' }
//         }}
//       >
//         {saving ? 'Saving...' : 'Save & Next'}
//       </Button>
//     </Stack>
//   </Box>
// ));

// // Main Component
// const AnimalDetailPage = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('md'));
//   const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
//   const isNew = !id || id === 'new';

//   const [animal, setAnimal] = useState(null);
//   const [form, setForm] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [saving, setSaving] = useState(false);
//   const [autoSaving, setAutoSaving] = useState(false);
//   const [editing, setEditing] = useState(isNew);
//   const [activeTab, setActiveTab] = useState(0);
//   const [saveModalOpen, setSaveModalOpen] = useState(false);
//   const [lastSaved, setLastSaved] = useState(null);
//   const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

//   const [options, setOptions] = useState({
//     species: [],
//     breeds: {},
//     sexes: [],
//     animal_classes: {},
//     lifecycle_states: [],
//     reproductive_statuses: [],
//     pregnancy_statuses: [],
//     milking_statuses: [],
//     semen_statuses: [],
//     health_statuses: []
//   });

//   const [completion, setCompletion] = useState(formSteps.map(() => false));

//   const API_URL = "https://dairy.server.statify.co.ke/api/animals/";

//   // Calculate age from DOB - useCallback to prevent recreation
//   const calculateAge = useCallback((dob) => {
//     if (!dob) return 'N/A';
//     const birthDate = new Date(dob);
//     const today = new Date();
//     let years = today.getFullYear() - birthDate.getFullYear();
//     let months = today.getMonth() - birthDate.getMonth();
    
//     if (months < 0) {
//       years--;
//       months += 12;
//     }
    
//     if (years === 0) {
//       return `${months} month${months !== 1 ? 's' : ''}`;
//     }
//     return `${years} year${years !== 1 ? 's' : ''} ${months} month${months !== 1 ? 's' : ''}`;
//   }, []);

//   // Format date for display - useCallback to prevent recreation
//   const formatDate = useCallback((dateString) => {
//     if (!dateString) return 'N/A';
//     return new Date(dateString).toLocaleDateString('en-US', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric'
//     });
//   }, []);

//   // Animal avatar based on species and gender - moved to top level
//   const getAnimalAvatar = useCallback(() => {
//     const species = animal?.species?.toLowerCase() || 'cattle';
//     const isFemale = animal?.sex === 'Female';
    
//     if (species.includes('cattle')) {
//       return isFemale ? '🐄' : '🐂';
//     } else if (species.includes('goat')) {
//       return isFemale ? '🐐' : '🐐';
//     } else if (species.includes('sheep')) {
//       return '🐑';
//     } else if (species.includes('pig')) {
//       return '🐖';
//     } else {
//       return '🐾';
//     }
//   }, [animal?.species, animal?.sex]);

//   // Fetch animal data - useCallback to prevent recreation
//   const fetchAnimal = useCallback(async () => {
//     if (isNew) {
//       setForm(initialForm);
//       setAnimal({ ...initialForm, id: 'new' });
//       return;
//     }

//     setLoading(true);
//     try {
//       const res = await fetch(`${API_URL}${id}`);
//       const data = await res.json();
      
//       if (res.ok) {
//         setAnimal(data.animal || data);
//         // Convert null values to empty strings for form
//         const formData = {};
//         Object.keys(initialForm).forEach(key => {
//           let value = data.animal?.[key] || data[key];
//           if (value === null || value === undefined) value = "";
//           if (value && typeof value === 'string' && value.includes('T')) {
//             value = value.split('T')[0];
//           }
//           formData[key] = value;
//         });
//         setForm(formData);
//       } else {
//         swal("Error", "Failed to fetch animal data", "error");
//         navigate('/animals');
//       }
//     } catch (err) {
//       console.error('Error fetching animal:', err);
//       swal("Error", "Failed to fetch animal data", "error");
//       navigate('/animals');
//     } finally {
//       setLoading(false);
//     }
//   }, [id, isNew, navigate]);

//   // Fetch options - useCallback to prevent recreation
//   const fetchOptions = useCallback(async () => {
//     try {
//       const res = await fetch(`${API_URL}options`);
//       const data = await res.json();
//       if (res.ok) {
//         setOptions(data);
//       }
//     } catch (err) {
//       console.error('Error fetching options:', err);
//     }
//   }, []);

//   useEffect(() => {
//     fetchOptions();
//     fetchAnimal();
//   }, [fetchOptions, fetchAnimal]);

//   // Check form completion
//   useEffect(() => {
//     if (!form) return;

//     const newCompletion = formSteps.map((step, index) => {
//       switch (step.key) {
//         case 'basic':
//           return !!(form.tag_number && form.breed && form.dob && form.sex);
//         case 'physical':
//           return !!(form.current_weight || form.height || form.color);
//         case 'health':
//           return !!(form.health_status || form.reproductive_status || form.vaccination_status);
//         case 'location':
//           return !!(form.location || form.herd_id);
//         case 'economic':
//           return !!(form.purchase_price || form.estimated_value || form.sire_id || form.dam_id);
//         case 'notes':
//           return !!(form.notes);
//         default:
//           return false;
//       }
//     });

//     setCompletion(newCompletion);
//   }, [form]);

//   // Form handler - useCallback to prevent recreation
//   const handleFormChange = useCallback((e) => {
//     const { name, value, type, checked } = e.target;
    
//     let processedValue = value;
//     if (type === 'number' && value !== '') {
//       processedValue = Number(value);
//     } else if (type === 'checkbox') {
//       processedValue = checked;
//     } else if (value === '') {
//       processedValue = '';
//     }

//     setForm(prev => ({
//       ...prev,
//       [name]: processedValue
//     }));

//     setHasUnsavedChanges(true);

//     // Update animal class when species or sex changes
//     if ((name === 'species' || name === 'sex') && options.animal_classes) {
//       const speciesClasses = options.animal_classes[form.species] || {};
//       const classes = speciesClasses[form.sex] || [];
//       if (classes.length > 0 && !classes.includes(form.animal_class)) {
//         setForm(prev => ({ ...prev, animal_class: classes[0] }));
//       }
//     }
//   }, [options.animal_classes, form.species, form.sex, form.animal_class]);

//   // Auto-save functionality
//   useEffect(() => {
//     if (!editing || !hasUnsavedChanges) return;

//     const autoSaveTimer = setTimeout(() => {
//       if (hasUnsavedChanges) {
//         handleAutoSave();
//       }
//     }, 10000); // Auto-save after 10 seconds of inactivity

//     return () => clearTimeout(autoSaveTimer);
//   }, [form, hasUnsavedChanges, editing]);

//   // Auto-save function - useCallback to prevent recreation
//   const handleAutoSave = useCallback(async () => {
//     if (!hasUnsavedChanges || saving) return;

//     setAutoSaving(true);
//     try {
//       await saveFormData(false); // Silent save without notifications
//       setLastSaved(new Date());
//       setHasUnsavedChanges(false);
//     } catch (error) {
//       console.error('Auto-save failed:', error);
//     } finally {
//       setAutoSaving(false);
//     }
//   }, [hasUnsavedChanges, saving]);

//   // Save form data (used by both manual and auto-save) - useCallback to prevent recreation
//   const saveFormData = useCallback(async (showNotifications = true) => {
//     const submitData = { ...form };
    
//     // Convert empty strings to null
//     Object.keys(submitData).forEach(key => {
//       if (submitData[key] === '') {
//         submitData[key] = null;
//       }
//     });

//     // Convert numeric fields
//     const numericFields = [
//       'birth_weight', 'current_weight', 'height', 'weaning_weight', 'yearling_weight',
//       'purchase_price', 'sale_price', 'estimated_value', 'genetic_score',
//       'number_of_calves', 'lactation_number', 'days_bred', 'days_in_milk',
//       'average_milk_yield', 'total_lifetime_milk', 'sire_id', 'dam_id'
//     ];
    
//     numericFields.forEach(field => {
//       if (submitData[field] !== null && submitData[field] !== '') {
//         submitData[field] = Number(submitData[field]);
//       }
//     });

//     submitData.is_milking_cow = Boolean(submitData.is_milking_cow);

//     const method = isNew ? "POST" : "PUT";
//     const url = isNew ? API_URL : `${API_URL}${id}`;

//     const res = await fetch(url, {
//       method,
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(submitData),
//     });

//     const data = await res.json();
//     if (res.ok) {
//       if (isNew) {
//         navigate(`/animals/${data.animal?.id || id}`);
//         setEditing(false);
//       }
//       setAnimal(data.animal || data);
//       if (showNotifications) {
//         swal("Success", data.message || "Changes saved successfully", "success");
//       }
//       return true;
//     } else {
//       if (showNotifications) {
//         swal("Error", data.error || "Something went wrong", "error");
//       }
//       return false;
//     }
//   }, [form, isNew, id, navigate]);

//   // Manual save section - useCallback to prevent recreation
//   const saveSection = useCallback(async () => {
//     setSaving(true);
//     try {
//       const success = await saveFormData(true);
//       if (success) {
//         setSaveModalOpen(false);
//         setHasUnsavedChanges(false);
//         setLastSaved(new Date());
//       }
//     } catch (err) {
//       console.error('Save error:', err);
//       swal("Error", "Failed to save changes", "error");
//     } finally {
//       setSaving(false);
//     }
//   }, [saveFormData]);

//   // Save and go to next tab - useCallback to prevent recreation
//   const saveAndNext = useCallback(async () => {
//     setSaving(true);
//     try {
//       const success = await saveFormData(true);
//       if (success) {
//         setHasUnsavedChanges(false);
//         setLastSaved(new Date());
//         if (activeTab < tabComponents.length - 1) {
//           setActiveTab(activeTab + 1);
//         }
//       }
//     } catch (err) {
//       console.error('Save error:', err);
//       swal("Error", "Failed to save changes", "error");
//     } finally {
//       setSaving(false);
//     }
//   }, [saveFormData, activeTab]);

//   // Submit for approval - useCallback to prevent recreation
//   const handleSubmitForApproval = useCallback(async () => {
//     const confirm = await swal({
//       title: "Submit for Approval?",
//       text: "This will change the animal status to Active and make it visible to all users",
//       icon: "warning",
//       buttons: true,
//       dangerMode: true,
//     });

//     if (confirm) {
//       setSaving(true);
//       try {
//         const res = await fetch(`${API_URL}${id}/status`, {
//           method: "PUT",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ lifecycle_state: "Active" }),
//         });

//         const data = await res.json();
//         if (res.ok) {
//           setAnimal(prev => ({ ...prev, lifecycle_state: "Active" }));
//           setForm(prev => ({ ...prev, lifecycle_state: "Active" }));
//           swal("Success", "Animal submitted and activated!", "success");
//         } else {
//           swal("Error", data.error, "error");
//         }
//       } catch (err) {
//         swal("Error", "Something went wrong", "error");
//       } finally {
//         setSaving(false);
//         setSaveModalOpen(false);
//       }
//     }
//   }, [id]);

//   // Tab components for EDIT mode - memoized callbacks
//   const tabComponents = [
//     { 
//       label: 'Basic Info', 
//       component: <BasicInfoTab form={form} onFormChange={handleFormChange} options={options} />
//     },
//     { 
//       label: 'Physical Data', 
//       component: <PhysicalTab form={form} onFormChange={handleFormChange} />
//     },
//     { 
//       label: 'Health & Reproductive', 
//       component: <HealthReproductiveTab form={form} onFormChange={handleFormChange} options={options} />
//     },
//     { 
//       label: 'Location & Management', 
//       component: <LocationManagementTab form={form} onFormChange={handleFormChange} />
//     },
//     { 
//       label: 'Economic & Genetic', 
//       component: <EconomicGeneticTab form={form} onFormChange={handleFormChange} />
//     },
//     { 
//       label: 'Additional Info', 
//       component: <NotesTab form={form} onFormChange={handleFormChange} />
//     },
//   ];

//   // View components for READ mode - memoized callbacks
//   const viewComponents = [
//     { 
//       label: 'Basic Info', 
//       component: <BasicInfoView animal={animal} formatDate={formatDate} calculateAge={calculateAge} />
//     },
//     { 
//       label: 'Health & Reproductive', 
//       component: <HealthReproductiveView animal={animal} formatDate={formatDate} />
//     },
//     { 
//       label: 'Location & Management', 
//       component: <LocationManagementView animal={animal} formatDate={formatDate} lastSaved={lastSaved} completion={completion} />
//     },
//     { 
//       label: 'Economic & Genetic', 
//       component: <EconomicGeneticView animal={animal} />
//     },
//     { 
//       label: 'Additional Info', 
//       component: <NotesView animal={animal} />
//     },
//   ];

//   if (loading) {
//     return (
//       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
//         <CircularProgress size={60} sx={{ color: styles.primaryColor }} />
//       </Box>
//     );
//   }

//   const completedCount = completion.filter(Boolean).length;
//   const totalSteps = formSteps.length;
//   const allCompleted = completedCount === totalSteps;

//   return (
//     <Box sx={{ 
//       flexGrow: 1, 
//       minHeight: '100vh',
//       backgroundColor: styles.lightBackground
//     }}>
//       {/* Header */}
//       <AppBar 
//         position="static" 
//         sx={{ 
//           backgroundColor: styles.primaryColor,
//           background: `linear-gradient(135deg, ${styles.primaryColor} 0%, #012e39 100%)`
//         }}
//       >
//         <Toolbar>
//           <IconButton
//             edge="start"
//             color="inherit"
//             onClick={() => navigate('/animals')}
//             sx={{ mr: 2 }}
//           >
//             <ArrowBackIcon />
//           </IconButton>
          
//           <Avatar
//             sx={{
//               mr: 2,
//               bgcolor: styles.secondaryColor,
//               width: 40,
//               height: 40
//             }}
//           >
//             {getAnimalAvatar()}
//           </Avatar>
          
//           <Box sx={{ flexGrow: 1 }}>
//             <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold', fontSize: { xs: '1.5rem', md: '2rem' } }}>
//               {isNew ? 'New Animal' : animal?.name || `Animal ${animal?.tag_number}`}
//             </Typography>
//             <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} sx={{ color: 'white', mt: 0.5 }}>
//               <Link color="inherit" onClick={() => navigate('/animals')} sx={{ cursor: 'pointer' }}>
//                 Animals
//               </Link>
//               <Typography color="inherit">
//                 {isNew ? 'New Animal' : animal?.tag_number}
//               </Typography>
//             </Breadcrumbs>
//           </Box>
          
//           {/* Auto-save indicator */}
//           {editing && hasUnsavedChanges && (
//             <Chip 
//               icon={<AutoAwesomeIcon />}
//               label="Unsaved Changes"
//               sx={{ 
//                 backgroundColor: '#ffeb3b',
//                 color: '#333',
//                 fontWeight: 'bold',
//                 mr: 2
//               }}
//             />
//           )}
          
//           {!isNew && animal?.lifecycle_state === 'Draft' && (
//             <Chip 
//               label="DRAFT" 
//               sx={{ 
//                 backgroundColor: styles.secondaryColor,
//                 color: styles.primaryColor,
//                 fontWeight: 'bold',
//                 mr: 2
//               }}
//             />
//           )}
          
//           {!isNew && !editing && (
//             <Button
//               variant="contained"
//               startIcon={<EditIcon />}
//               onClick={() => setEditing(true)}
//               sx={{ 
//                 backgroundColor: styles.secondaryColor,
//                 color: styles.primaryColor,
//                 fontWeight: 'bold',
//                 '&:hover': {
//                   backgroundColor: '#ffb74d',
//                 }
//               }}
//             >
//               {isMobile ? 'Edit' : 'Edit Animal'}
//             </Button>
//           )}
          
//           {editing && (
//             <>
//               <Button
//                 variant="outlined"
//                 startIcon={<CancelIcon />}
//                 onClick={() => {
//                   if (isNew) {
//                     navigate('/animals');
//                   } else {
//                     setEditing(false);
//                     setForm(animal);
//                     setHasUnsavedChanges(false);
//                   }
//                 }}
//                 sx={{ 
//                   borderColor: 'white',
//                   color: 'white',
//                   mr: 1,
//                   '&:hover': {
//                     borderColor: 'white',
//                     backgroundColor: 'rgba(255,255,255,0.1)'
//                   }
//                 }}
//               >
//                 {isMobile ? 'Cancel' : 'Cancel'}
//               </Button>
//               <Button
//                 variant="contained"
//                 startIcon={<SaveIcon />}
//                 onClick={() => setSaveModalOpen(true)}
//                 disabled={saving}
//                 sx={{ 
//                   backgroundColor: styles.secondaryColor,
//                   color: styles.primaryColor,
//                   fontWeight: 'bold',
//                   '&:hover': {
//                     backgroundColor: '#ffb74d',
//                   }
//                 }}
//               >
//                 {saving ? 'Saving...' : (isMobile ? 'Save' : 'Save All')}
//               </Button>
//             </>
//           )}
//         </Toolbar>
//       </AppBar>

//       <Container maxWidth="xl" sx={{ py: 3 }}>
//         {/* Progress Stepper - Only show in edit mode */}
//         {editing && (
//           <Paper sx={{ p: 3, mb: 3, boxShadow: styles.cardShadow }}>
//             <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
//               <Typography variant="h5" sx={{ color: styles.primaryColor, fontWeight: 'bold' }}>
//                 Completion Progress
//               </Typography>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//                 {autoSaving && (
//                   <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                     <CircularProgress size={16} sx={{ mr: 1 }} />
//                     <Typography variant="body2" color="text.secondary">
//                       Auto-saving...
//                     </Typography>
//                   </Box>
//                 )}
//                 <Chip 
//                   label={`${completedCount}/${totalSteps} completed`}
//                   color={allCompleted ? "success" : "default"}
//                   icon={allCompleted ? <CheckCircleIcon /> : undefined}
//                   sx={{ fontWeight: 'bold' }}
//                 />
//               </Box>
//             </Box>
//             <Stepper activeStep={-1} alternativeLabel>
//               {formSteps.map((step, index) => (
//                 <Step key={step.key} completed={completion[index]}>
//                   <StepLabel 
//                     StepIconComponent={() => (
//                       <Avatar
//                         sx={{
//                           bgcolor: completion[index] ? styles.secondaryColor : 'grey.300',
//                           color: completion[index] ? styles.primaryColor : 'grey.600',
//                           width: 32,
//                           height: 32
//                         }}
//                       >
//                         {step.icon}
//                       </Avatar>
//                     )}
//                   >
//                     {step.label}
//                   </StepLabel>
//                 </Step>
//               ))}
//             </Stepper>
//           </Paper>
//         )}

//         {/* Main Content */}
//         <Paper sx={{ boxShadow: styles.cardShadow }}>
//           {editing ? (
//             <>
//               <Tabs
//                 value={activeTab}
//                 onChange={(e, newValue) => setActiveTab(newValue)}
//                 indicatorColor="primary"
//                 textColor="primary"
//                 variant={isMobile ? "scrollable" : "standard"}
//                 scrollButtons={isMobile ? "auto" : false}
//                 sx={{ 
//                   borderBottom: 1, 
//                   borderColor: 'divider',
//                   '& .MuiTab-root': {
//                     fontWeight: 'bold',
//                     minWidth: { xs: 120, md: 160 }
//                   }
//                 }}
//               >
//                 {tabComponents.map((tab, index) => (
//                   <Tab 
//                     key={index}
//                     label={
//                       <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                         {tab.label}
//                         {completion[index] && (
//                           <CheckCircleIcon sx={{ fontSize: 16, ml: 1, color: 'success.main' }} />
//                         )}
//                       </Box>
//                     }
//                   />
//                 ))}
//               </Tabs>

//               <Box sx={{ p: { xs: 2, md: 3 } }}>
//                 {tabComponents[activeTab].component}
//                 <SaveActions 
//                   onSaveSection={saveSection}
//                   onSaveAndNext={saveAndNext}
//                   saving={saving}
//                   autoSaving={autoSaving}
//                 />
//               </Box>
//             </>
//           ) : (
//             <Box sx={{ p: { xs: 2, md: 3 } }}>
//               {viewComponents.map((section, index) => (
//                 <Box key={index} sx={{ mb: 4 }}>
//                   <Typography 
//                     variant="h5" 
//                     sx={{ 
//                       color: styles.primaryColor,
//                       fontWeight: 'bold',
//                       mb: 2,
//                       pb: 1,
//                       borderBottom: `2px solid ${styles.secondaryColor}`
//                     }}
//                   >
//                     {section.label}
//                   </Typography>
//                   {section.component}
//                 </Box>
//               ))}
//             </Box>
//           )}
//         </Paper>
//       </Container>

//       {/* Floating Action Button for Mobile */}
//       {!editing && !isNew && (
//         <Fab
//           color="primary"
//           aria-label="edit"
//           sx={{
//             position: 'fixed',
//             bottom: 24,
//             right: 24,
//             display: { xs: 'flex', md: 'none' },
//             backgroundColor: styles.secondaryColor,
//             color: styles.primaryColor,
//             '&:hover': {
//               backgroundColor: '#ffb74d',
//             }
//           }}
//           onClick={() => setEditing(true)}
//         >
//           <EditIcon />
//         </Fab>
//       )}

//       {/* Save Confirmation Modal */}
//       <Dialog 
//         open={saveModalOpen} 
//         onClose={() => setSaveModalOpen(false)}
//         PaperProps={{ sx: { borderRadius: 2 } }}
//       >
//         <DialogTitle sx={{ color: styles.primaryColor, fontWeight: 'bold' }}>
//           Save Changes
//         </DialogTitle>
//         <DialogContent>
//           <Typography>
//             {allCompleted && animal?.lifecycle_state === 'Draft' 
//               ? "All sections are complete! You can save changes and submit for approval to activate this animal record."
//               : "Save your changes to this animal record?"}
//           </Typography>
//           {allCompleted && animal?.lifecycle_state === 'Draft' && (
//             <Alert severity="success" sx={{ mt: 2 }}>
//               All required information has been completed. This animal is ready to be activated.
//             </Alert>
//           )}
//         </DialogContent>
//         <DialogActions sx={{ p: 3, gap: 1 }}>
//           <Button 
//             onClick={() => setSaveModalOpen(false)}
//             variant="outlined"
//           >
//             Cancel
//           </Button>
//           <Button 
//             onClick={saveSection}
//             variant="contained"
//             sx={{ 
//               backgroundColor: styles.primaryColor,
//               '&:hover': {
//                 backgroundColor: '#012e39'
//               }
//             }}
//           >
//             Save Only
//           </Button>
//           {allCompleted && animal?.lifecycle_state === 'Draft' && (
//             <Button 
//               onClick={handleSubmitForApproval}
//               variant="contained"
//               sx={{ 
//                 backgroundColor: styles.secondaryColor,
//                 color: styles.primaryColor,
//                 fontWeight: 'bold',
//                 '&:hover': {
//                   backgroundColor: '#ffb74d'
//                 }
//               }}
//             >
//               Save & Activate
//             </Button>
//           )}
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default AnimalDetailPage;

// exit after save
import React, { useState, useEffect, useCallback, memo } from "react";
import {
  Box,
  Typography,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Chip,
  IconButton,
  Paper,
  Grid,
  Card,
  CardContent,
  CardHeader,
  Tabs,
  Tab,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stepper,
  Step,
  StepLabel,
  Alert,
  CircularProgress,
  Divider,
  Switch,
  FormControlLabel,
  AppBar,
  Toolbar,
  Avatar,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  useTheme,
  useMediaQuery,
  Container,
  Fab,
  Breadcrumbs,
  Link,
  Stack,
} from "@mui/material";
import {
  ArrowBack as ArrowBackIcon,
  Edit as EditIcon,
  Save as SaveIcon,
  Cancel as CancelIcon,
  Pets as PetsIcon,
  CheckCircle as CheckCircleIcon,
  NavigateNext as NavigateNextIcon,
  Scale as ScaleIcon,
  Favorite as FavoriteIcon,
  LocationOn as LocationIcon,
  AttachMoney as MoneyIcon,
  Notes as NotesIcon,
  CalendarToday as CalendarIcon,
  Female as FemaleIcon,
  Male as MaleIcon,
  LocalHospital as HealthIcon,
  Agriculture as AgricultureIcon,
  Science as ScienceIcon,
  AutoAwesome as AutoAwesomeIcon,
} from "@mui/icons-material";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import swal from "sweetalert";

// Custom styles - moved outside component to prevent recreation
const styles = {
  primaryColor: '#024a59',
  secondaryColor: '#ffa916',
  lightBackground: '#f8f9fa',
  cardShadow: '0 4px 12px rgba(2, 74, 89, 0.1)',
  sectionSpacing: { xs: 2, md: 3 },
  compactCard: {
    height: '100%',
    boxShadow: '0 2px 8px rgba(2, 74, 89, 0.08)',
    transition: 'all 0.3s ease',
    '&:hover': {
      boxShadow: '0 4px 16px rgba(2, 74, 89, 0.15)',
      transform: 'translateY(-2px)'
    }
  }
};

// Initial empty form - moved outside component
const initialForm = {
  // Basic identification
  tag_number: "",
  name: "",
  species: "Cattle",
  breed: "",
  dob: "",
  
  // Gender and animal class
  sex: "Female",
  animal_class: "",
  
  // Genetic information
  sire_id: "",
  dam_id: "",
  registration_number: "",
  genetic_score: "",
  breed_composition: "",
  
  // Physical characteristics
  color: "",
  birth_weight: "",
  current_weight: "",
  height: "",
  weaning_weight: "",
  yearling_weight: "",
  
  // Reproductive status
  reproductive_status: "",
  last_calving_date: "",
  number_of_calves: "",
  pregnancy_status: "",
  lactation_number: "",
  days_bred: "",
  
  // Male specific
  semen_status: "",
  breeding_capacity: "",
  
  // Milking data
  milking_status: "",
  is_milking_cow: false,
  last_milking_date: "",
  days_in_milk: "",
  average_milk_yield: "",
  total_lifetime_milk: "",
  
  // Health and management
  health_status: "Healthy",
  vaccination_status: "",
  last_vet_visit: "",
  next_vet_visit: "",
  
  // Location and management
  location: "",
  pen_group: "",
  herd_id: "",
  
  // Lifecycle management
  lifecycle_state: "Draft",
  entry_date: "",
  exit_date: "",
  exit_reason: "",
  
  // Economic data
  purchase_price: "",
  sale_price: "",
  estimated_value: "",
  
  // Purchase specific
  origin: "",
  purchase_conditions: "",
  
  // Additional metadata
  notes: "",
  
  // Animal type
  animal_type: "born"
};

// Form steps for completion tracking - moved outside
const formSteps = [
  { key: 'basic', label: 'Basic Info', completed: false, icon: <PetsIcon /> },
  { key: 'physical', label: 'Physical Data', completed: false, icon: <ScaleIcon /> },
  { key: 'health', label: 'Health & Reproductive', completed: false, icon: <HealthIcon /> },
  { key: 'location', label: 'Location & Management', completed: false, icon: <LocationIcon /> },
  { key: 'economic', label: 'Economic & Genetic', completed: false, icon: <MoneyIcon /> },
  { key: 'notes', label: 'Additional Info', completed: false, icon: <NotesIcon /> },
];

// Compact Info Card Component - memoized
const CompactInfoCard = memo(({ title, icon, items }) => (
  <Card sx={styles.compactCard}>
    <CardHeader
      title={title}
      avatar={React.cloneElement(icon, { sx: { color: styles.primaryColor } })}
      sx={{ 
        backgroundColor: styles.lightBackground,
        pb: 1,
        '& .MuiCardHeader-title': { fontSize: '1rem', fontWeight: 'bold' }
      }}
    />
    <CardContent sx={{ pt: 1, '&:last-child': { pb: 2 } }}>
      <List dense disablePadding>
        {items.map((item, index) => (
          <ListItem key={index} disablePadding sx={{ py: 0.5 }}>
            <ListItemText 
              primary={item.primary}
              secondary={item.secondary}
              primaryTypographyProps={{ variant: 'body2', fontWeight: 'medium' }}
              secondaryTypographyProps={{ variant: 'body2', color: 'text.primary' }}
            />
          </ListItem>
        ))}
      </List>
    </CardContent>
  </Card>
));

// Tab Components - memoized to prevent unnecessary re-renders
const BasicInfoTab = memo(({ form, onFormChange, options }) => {
  const handleChange = useCallback((e) => {
    onFormChange(e);
  }, [onFormChange]);

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <FormControl fullWidth
                sx={{
                  minWidth: { xs: '100%', sm: 250, md: 300 },
                }}>
            <InputLabel>Animal Type</InputLabel>
            <Select
              name="animal_type"
              value={form.animal_type || ""}
              onChange={handleChange}
              label="Animal Type"
            >
              <MenuItem value="born">Born on Farm</MenuItem>
              <MenuItem value="purchased">Purchased</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Tag Number *"
            name="tag_number"
            value={form.tag_number || ""}
            onChange={handleChange}
            required
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Name"
            name="name"
            value={form.name || ""}
            onChange={handleChange}
          />
        </Grid>
        
        <Grid item xs={12} md={6}>
          <FormControl fullWidth
                sx={{
                  minWidth: { xs: '100%', sm: 250, md: 300 },
                }}>
            <InputLabel>Species</InputLabel>
            <Select
              name="species"
              value={form.species || ""}
              onChange={handleChange}
              label="Species"
            >
              {options.species.map(species => (
                <MenuItem key={species} value={species}>{species}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} md={6}>
          <FormControl fullWidth
                sx={{
                  minWidth: { xs: '100%', sm: 250, md: 300 },
                }}>
            <InputLabel>Breed *</InputLabel>
            <Select
              name="breed"
              value={form.breed || ""}
              onChange={handleChange}
              label="Breed *"
              required
            >
              <MenuItem value="">Select Breed</MenuItem>
              {options.breeds[form.species]?.map(breed => (
                <MenuItem key={breed} value={breed}>{breed}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Date of Birth *"
            name="dob"
            type="date"
            value={form.dob || ""}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            required
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormControl fullWidth
                sx={{
                  minWidth: { xs: '100%', sm: 250, md: 300 },
                }}>
            <InputLabel>Gender *</InputLabel>
            <Select
              name="sex"
              value={form.sex || ""}
              onChange={handleChange}
              label="Gender *"
              required
            >
              {options.sexes.map(sex => (
                <MenuItem key={sex} value={sex}>{sex}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        
        <Grid item xs={12} md={6}>
          <FormControl fullWidth
                sx={{
                  minWidth: { xs: '100%', sm: 250, md: 300 },
                }}>
            <InputLabel>Animal Class</InputLabel>
            <Select
              name="animal_class"
              value={form.animal_class || ""}
              onChange={handleChange}
              label="Animal Class"
            >
              <MenuItem value="">Select Class</MenuItem>
              {options.animal_classes[form.species]?.[form.sex]?.map(cls => (
                <MenuItem key={cls} value={cls}>{cls}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Color"
            name="color"
            value={form.color || ""}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormControl fullWidth
                sx={{
                  minWidth: { xs: '100%', sm: 250, md: 300 },
                }}>
            <InputLabel>Lifecycle State</InputLabel>
            <Select
              name="lifecycle_state"
              value={form.lifecycle_state || ""}
              onChange={handleChange}
              label="Lifecycle State"
            >
              {options.lifecycle_states.map(state => (
                <MenuItem key={state} value={state}>{state}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </Box>
  );
});

const PhysicalTab = memo(({ form, onFormChange }) => {
  const handleChange = useCallback((e) => {
    onFormChange(e);
  }, [onFormChange]);

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            label="Birth Weight (kg)"
            name="birth_weight"
            type="number"
            value={form.birth_weight || ""}
            onChange={handleChange}
            InputProps={{ inputProps: { min: 0, step: 0.1 } }}
          />
        </Grid>
        
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            label="Current Weight (kg)"
            name="current_weight"
            type="number"
            value={form.current_weight || ""}
            onChange={handleChange}
            InputProps={{ inputProps: { min: 0, step: 0.1 } }}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            label="Height (cm)"
            name="height"
            type="number"
            value={form.height || ""}
            onChange={handleChange}
            InputProps={{ inputProps: { min: 0, step: 0.1 } }}
          />
        </Grid>
        
        <Grid item xs={12} sm={6} md={4}>
          
          <TextField
            fullWidth
            label="Weaning Weight (kg)"
            name="weaning_weight"
            type="number"
            value={form.weaning_weight || ""}
            onChange={handleChange}
            InputProps={{ inputProps: { min: 0, step: 0.1 } }}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            label="Yearling Weight (kg)"
            name="yearling_weight"
            type="number"
            value={form.yearling_weight || ""}
            onChange={handleChange}
            InputProps={{ inputProps: { min: 0, step: 0.1 } }}
          />
        </Grid>
      </Grid>
    </Box>
  );
});

const HealthReproductiveTab = memo(({ form, onFormChange, options }) => {
  const handleChange = useCallback((e) => {
    onFormChange(e);
  }, [onFormChange]);

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <FormControl fullWidth
                sx={{
                  minWidth: { xs: '100%', sm: 250, md: 300 },
                }}>
            <InputLabel>Health Status</InputLabel>
            <Select
              name="health_status"
              value={form.health_status || ""}
              onChange={handleChange}
              label="Health Status"
            >
              {options.health_statuses.map(status => (
                <MenuItem key={status} value={status}>{status}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            label="Vaccination Status"
            name="vaccination_status"
            value={form.vaccination_status || ""}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            label="Last Vet Visit"
            name="last_vet_visit"
            type="date"
            value={form.last_vet_visit || ""}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            label="Next Vet Visit"
            name="next_vet_visit"
            type="date"
            value={form.next_vet_visit || ""}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>

        {form.sex === 'Female' && (
          <>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth
                sx={{
                  minWidth: { xs: '100%', sm: 250, md: 300 },
                }}>
                <InputLabel>Reproductive Status</InputLabel>
                <Select
                  name="reproductive_status"
                  value={form.reproductive_status || ""}
                  onChange={handleChange}
                  label="Reproductive Status"
                >
                  <MenuItem value="">Select Status</MenuItem>
                  {options.reproductive_statuses.map(status => (
                    <MenuItem key={status} value={status}>{status}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            
            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth
                sx={{
                  minWidth: { xs: '100%', sm: 250, md: 300 },
                }}>
                <InputLabel>Pregnancy Status</InputLabel>
                <Select
                  name="pregnancy_status"
                  value={form.pregnancy_status || ""}
                  onChange={handleChange}
                  label="Pregnancy Status"
                >
                  <MenuItem value="">Select Status</MenuItem>
                  {options.pregnancy_statuses.map(status => (
                    <MenuItem key={status} value={status}>{status}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                label="Last Calving Date"
                name="last_calving_date"
                type="date"
                value={form.last_calving_date || ""}
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                label="Number of Calves"
                name="number_of_calves"
                type="number"
                value={form.number_of_calves || ""}
                onChange={handleChange}
                InputProps={{ inputProps: { min: 0 } }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                label="Lactation Number"
                name="lactation_number"
                type="number"
                value={form.lactation_number || ""}
                onChange={handleChange}
                InputProps={{ inputProps: { min: 0 } }}
              />
            </Grid>
            
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                label="Days Bred"
                name="days_bred"
                type="number"
                value={form.days_bred || ""}
                onChange={handleChange}
                InputProps={{ inputProps: { min: 0 } }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth
                sx={{
                  minWidth: { xs: '100%', sm: 250, md: 300 },
                }}>
                <InputLabel>Milking Status</InputLabel>
                <Select
                  name="milking_status"
                  value={form.milking_status || ""}
                  onChange={handleChange}
                  label="Milking Status"
                >
                  <MenuItem value="">Select Status</MenuItem>
                  {options.milking_statuses.map(status => (
                    <MenuItem key={status} value={status}>{status}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            
            <Grid item xs={12} sm={6} md={4}>
              <FormControlLabel
                control={
                  <Switch
                    name="is_milking_cow"
                    checked={form.is_milking_cow || false}
                    onChange={handleChange}
                  />
                }
                label="Is Milking Cow"
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                label="Last Milking Date"
                name="last_milking_date"
                type="date"
                value={form.last_milking_date || ""}
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                label="Days in Milk"
                name="days_in_milk"
                type="number"
                value={form.days_in_milk || ""}
                onChange={handleChange}
                InputProps={{ inputProps: { min: 0 } }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                label="Avg Milk Yield (L/day)"
                name="average_milk_yield"
                type="number"
                value={form.average_milk_yield || ""}
                onChange={handleChange}
                InputProps={{ inputProps: { min: 0, step: 0.1 } }}
              />
            </Grid>
            
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                label="Total Lifetime Milk (L)"
                name="total_lifetime_milk"
                type="number"
                value={form.total_lifetime_milk || ""}
                onChange={handleChange}
                InputProps={{ inputProps: { min: 0, step: 0.1 } }}
              />
            </Grid>
          </>
        )}

        {form.sex === 'Male' && (
          <>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth
                sx={{
                  minWidth: { xs: '100%', sm: 250, md: 300 },
                }}>
                <InputLabel>Semen Status</InputLabel>
                <Select
                  name="semen_status"
                  value={form.semen_status || ""}
                  onChange={handleChange}
                  label="Semen Status"
                >
                  <MenuItem value="">Select Status</MenuItem>
                  {options.semen_statuses.map(status => (
                    <MenuItem key={status} value={status}>{status}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                label="Breeding Capacity"
                name="breeding_capacity"
                value={form.breeding_capacity || ""}
                onChange={handleChange}
              />
            </Grid>
          </>
        )}
      </Grid>
    </Box>
  );
});

const LocationManagementTab = memo(({ form, onFormChange }) => {
  const handleChange = useCallback((e) => {
    onFormChange(e);
  }, [onFormChange]);

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            label="Location"
            name="location"
            value={form.location || ""}
            onChange={handleChange}
          />
        </Grid>
        
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            label="Pen/Group"
            name="pen_group"
            value={form.pen_group || ""}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            label="Herd ID"
            name="herd_id"
            value={form.herd_id || ""}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            label="Entry Date"
            name="entry_date"
            type="date"
            value={form.entry_date || ""}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            label="Exit Date"
            name="exit_date"
            type="date"
            value={form.exit_date || ""}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            label="Exit Reason"
            name="exit_reason"
            value={form.exit_reason || ""}
            onChange={handleChange}
          />
        </Grid>
      </Grid>
    </Box>
  );
});

const EconomicGeneticTab = memo(({ form, onFormChange }) => {
  const handleChange = useCallback((e) => {
    onFormChange(e);
  }, [onFormChange]);

  return (
    <Box>
      <Grid container spacing={2}>
        {form.animal_type === 'purchased' && (
          <>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                label="Purchase Price ($)"
                name="purchase_price"
                type="number"
                value={form.purchase_price || ""}
                onChange={handleChange}
                InputProps={{ inputProps: { min: 0, step: 0.01 } }}
              />
            </Grid>
            
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                label="Sale Price ($)"
                name="sale_price"
                type="number"
                value={form.sale_price || ""}
                onChange={handleChange}
                InputProps={{ inputProps: { min: 0, step: 0.01 } }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                label="Estimated Value ($)"
                name="estimated_value"
                type="number"
                value={form.estimated_value || ""}
                onChange={handleChange}
                InputProps={{ inputProps: { min: 0, step: 0.01 } }}
              />
            </Grid>
            
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                label="Origin"
                name="origin"
                value={form.origin || ""}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Purchase Conditions"
                name="purchase_conditions"
                multiline
                rows={3}
                value={form.purchase_conditions || ""}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}><Divider sx={{ my: 2 }} /></Grid>
          </>
        )}

        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            label="Sire ID"
            name="sire_id"
            type="number"
            value={form.sire_id || ""}
            onChange={handleChange}
            InputProps={{ inputProps: { min: 0 } }}
          />
        </Grid>
        
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            label="Dam ID"
            name="dam_id"
            type="number"
            value={form.dam_id || ""}
            onChange={handleChange}
            InputProps={{ inputProps: { min: 0 } }}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            label="Registration Number"
            name="registration_number"
            value={form.registration_number || ""}
            onChange={handleChange}
          />
        </Grid>
        
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            label="Genetic Score"
            name="genetic_score"
            type="number"
            value={form.genetic_score || ""}
            onChange={handleChange}
            InputProps={{ inputProps: { min: 0, step: 0.1 } }}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            label="Breed Composition"
            name="breed_composition"
            value={form.breed_composition || ""}
            onChange={handleChange}
          />
        </Grid>
      </Grid>
    </Box>
  );
});

const NotesTab = memo(({ form, onFormChange }) => {
  const handleChange = useCallback((e) => {
    onFormChange(e);
  }, [onFormChange]);

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Notes"
            name="notes"
            multiline
            rows={6}
            value={form.notes || ""}
            onChange={handleChange}
            placeholder="Additional notes about the animal..."
          />
        </Grid>
      </Grid>
    </Box>
  );
});

// View Components - memoized
const BasicInfoView = memo(({ animal, formatDate, calculateAge }) => (
  <Grid container spacing={2}>
    <Grid item xs={12} sm={6} md={3}>
      <CompactInfoCard
        title="Identification"
        icon={<PetsIcon />}
        items={[
          { primary: "Tag Number", secondary: animal?.tag_number || 'N/A' },
          { primary: "Name", secondary: animal?.name || 'N/A' },
          { primary: "Species", secondary: animal?.species || 'N/A' },
          { primary: "Breed", secondary: animal?.breed || 'N/A' },
        ]}
      />
    </Grid>

    <Grid item xs={12} sm={6} md={3}>
      <CompactInfoCard
        title="Demographics"
        icon={<CalendarIcon />}
        items={[
          { primary: "Date of Birth", secondary: formatDate(animal?.dob) },
          { primary: "Age", secondary: calculateAge(animal?.dob) },
          { primary: "Gender", secondary: animal?.sex || 'N/A' },
          { primary: "Animal Class", secondary: animal?.animal_class || 'N/A' },
        ]}
      />
    </Grid>

    <Grid item xs={12} sm={6} md={3}>
      <CompactInfoCard
        title="Status & Appearance"
        icon={<PetsIcon />}
        items={[
          { primary: "Color", secondary: animal?.color || 'N/A' },
          { primary: "Animal Type", secondary: animal?.purchase_price ? "PURCHASED" : "BORN" },
          { primary: "Lifecycle State", secondary: animal?.lifecycle_state || 'N/A' },
        ]}
      />
    </Grid>

    <Grid item xs={12} sm={6} md={3}>
      <CompactInfoCard
        title="Physical Data"
        icon={<ScaleIcon />}
        items={[
          { primary: "Current Weight", secondary: animal?.current_weight ? `${animal.current_weight} kg` : 'N/A' },
          { primary: "Height", secondary: animal?.height ? `${animal.height} cm` : 'N/A' },
          { primary: "Birth Weight", secondary: animal?.birth_weight ? `${animal.birth_weight} kg` : 'N/A' },
        ]}
      />
    </Grid>
  </Grid>
));

const HealthReproductiveView = memo(({ animal, formatDate }) => (
  <Grid container spacing={2}>
    <Grid item xs={12} sm={6} md={4}>
      <CompactInfoCard
        title="Health Status"
        icon={<HealthIcon />}
        items={[
          { primary: "Health Status", secondary: animal?.health_status || 'N/A' },
          { primary: "Vaccination Status", secondary: animal?.vaccination_status || 'N/A' },
          { primary: "Last Vet Visit", secondary: formatDate(animal?.last_vet_visit) },
          { primary: "Next Vet Visit", secondary: formatDate(animal?.next_vet_visit) },
        ]}
      />
    </Grid>

    {animal?.sex === 'Female' && (
      <Grid item xs={12} sm={6} md={4}>
        <CompactInfoCard
          title="Reproductive Health"
          icon={<FavoriteIcon />}
          items={[
            { primary: "Reproductive Status", secondary: animal?.reproductive_status || 'N/A' },
            { primary: "Pregnancy Status", secondary: animal?.pregnancy_status || 'N/A' },
            { primary: "Last Calving Date", secondary: formatDate(animal?.last_calving_date) },
            { primary: "Number of Calves", secondary: animal?.number_of_calves || 'N/A' },
            ...(animal?.is_milking_cow ? [
              { primary: "Milking Status", secondary: animal?.milking_status || 'N/A' },
              { primary: "Avg Milk Yield", secondary: animal?.average_milk_yield ? `${animal.average_milk_yield} L/day` : 'N/A' },
            ] : [])
          ]}
        />
      </Grid>
    )}

    {animal?.sex === 'Male' && (
      <Grid item xs={12} sm={6} md={4}>
        <CompactInfoCard
          title="Breeding Information"
          icon={<MaleIcon />}
          items={[
            { primary: "Semen Status", secondary: animal?.semen_status || 'N/A' },
            { primary: "Breeding Capacity", secondary: animal?.breeding_capacity || 'N/A' },
          ]}
        />
      </Grid>
    )}

    {((animal?.sex === 'Female' && window.innerWidth >= 960) || 
      (animal?.sex === 'Male' && window.innerWidth >= 960)) && (
      <Grid item xs={12} sm={6} md={4}>
        <Card sx={{ ...styles.compactCard, height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <CardContent>
            <Box textAlign="center">
              <HealthIcon sx={{ fontSize: 48, color: styles.primaryColor, opacity: 0.3, mb: 1 }} />
              <Typography variant="body2" color="text.secondary">
                Additional health metrics and reproductive data will appear here as they are recorded.
              </Typography>
            </Box>
          </CardContent>
        </Card>
      </Grid>
    )}
  </Grid>
));

const LocationManagementView = memo(({ animal, formatDate, lastSaved, completion }) => (
  <Grid container spacing={2}>
    <Grid item xs={12} sm={6} md={4}>
      <CompactInfoCard
        title="Location Details"
        icon={<LocationIcon />}
        items={[
          { primary: "Location", secondary: animal?.location || 'N/A' },
          { primary: "Pen/Group", secondary: animal?.pen_group || 'N/A' },
          { primary: "Herd ID", secondary: animal?.herd_id || 'N/A' },
        ]}
      />
    </Grid>

    <Grid item xs={12} sm={6} md={4}>
      <CompactInfoCard
        title="Lifecycle Management"
        icon={<CalendarIcon />}
        items={[
          { primary: "Entry Date", secondary: formatDate(animal?.entry_date) },
          { primary: "Exit Date", secondary: formatDate(animal?.exit_date) },
          { primary: "Exit Reason", secondary: animal?.exit_reason || 'N/A' },
        ]}
      />
    </Grid>

    <Grid item xs={12} sm={6} md={4}>
      <CompactInfoCard
        title="Quick Actions"
        icon={<AutoAwesomeIcon />}
        items={[
          { primary: "Status", secondary: animal?.lifecycle_state || 'N/A' },
          { primary: "Last Updated", secondary: lastSaved ? formatDate(lastSaved) : 'N/A' },
          { primary: "Record Complete", secondary: completion.filter(Boolean).length + '/' + completion.length },
        ]}
      />
    </Grid>
  </Grid>
));

const EconomicGeneticView = memo(({ animal }) => (
  <Grid container spacing={2}>
    {animal?.purchase_price && (
      <Grid item xs={12} sm={6} md={4}>
        <CompactInfoCard
          title="Financial Information"
          icon={<MoneyIcon />}
          items={[
            { primary: "Purchase Price", secondary: animal?.purchase_price ? `$${animal.purchase_price}` : 'N/A' },
            { primary: "Sale Price", secondary: animal?.sale_price ? `$${animal.sale_price}` : 'N/A' },
            { primary: "Estimated Value", secondary: animal?.estimated_value ? `$${animal.estimated_value}` : 'N/A' },
            { primary: "Origin", secondary: animal?.origin || 'N/A' },
          ]}
        />
      </Grid>
    )}

    <Grid item xs={12} sm={6} md={4}>
      <CompactInfoCard
        title="Genetic Information"
        icon={<ScienceIcon />}
        items={[
          { primary: "Sire ID", secondary: animal?.sire_id || 'N/A' },
          { primary: "Dam ID", secondary: animal?.dam_id || 'N/A' },
          { primary: "Registration Number", secondary: animal?.registration_number || 'N/A' },
          { primary: "Genetic Score", secondary: animal?.genetic_score || 'N/A' },
          { primary: "Breed Composition", secondary: animal?.breed_composition || 'N/A' },
        ]}
      />
    </Grid>

    {!animal?.purchase_price && (
      <Grid item xs={12} sm={6} md={4}>
        <Card sx={{ ...styles.compactCard, height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <CardContent>
            <Box textAlign="center">
              <MoneyIcon sx={{ fontSize: 48, color: styles.primaryColor, opacity: 0.3, mb: 1 }} />
              <Typography variant="body2" color="text.secondary">
                Financial information will appear here for purchased animals.
              </Typography>
            </Box>
          </CardContent>
        </Card>
      </Grid>
    )}

    <Grid item xs={12} sm={6} md={4}>
      <CompactInfoCard
        title="Performance Metrics"
        icon={<ScaleIcon />}
        items={[
          { primary: "Weaning Weight", secondary: animal?.weaning_weight ? `${animal.weaning_weight} kg` : 'N/A' },
          { primary: "Yearling Weight", secondary: animal?.yearling_weight ? `${animal.yearling_weight} kg` : 'N/A' },
          { primary: "Lactation Number", secondary: animal?.lactation_number || 'N/A' },
          { primary: "Total Milk Production", secondary: animal?.total_lifetime_milk ? `${animal.total_lifetime_milk} L` : 'N/A' },
        ]}
      />
    </Grid>
  </Grid>
));

const NotesView = memo(({ animal }) => (
  <Grid container spacing={2}>
    <Grid item xs={12}>
      <Card sx={styles.compactCard}>
        <CardHeader
          title="Additional Notes"
          avatar={<NotesIcon sx={{ color: styles.primaryColor }} />}
          sx={{ 
            backgroundColor: styles.lightBackground,
            '& .MuiCardHeader-title': { fontSize: '1rem', fontWeight: 'bold' }
          }}
        />
        <CardContent>
          <Typography 
            variant="body2" 
            sx={{ 
              minHeight: 60,
              p: 2,
              backgroundColor: styles.lightBackground,
              borderRadius: 1,
              lineHeight: 1.6
            }}
          >
            {animal?.notes || 'No additional notes available.'}
          </Typography>
        </CardContent>
      </Card>
    </Grid>
  </Grid>
));

// Save Actions Component - memoized
const SaveActions = memo(({ onSaveSection, onSaveAndNext, saving, autoSaving }) => (
  <Box sx={{ mt: 3, pt: 2, borderTop: 1, borderColor: 'divider' }}>
    <Stack direction="row" spacing={2} justifyContent="flex-end">
      {autoSaving && (
        <Box sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
          <CircularProgress size={20} sx={{ mr: 1 }} />
          <Typography variant="body2" color="text.secondary">
            Auto-saving...
          </Typography>
        </Box>
      )}
      <Button
        variant="outlined"
        onClick={onSaveSection}
        disabled={saving}
      >
        {saving ? 'Saving...' : 'Save This Section'}
      </Button>
      <Button
        variant="contained"
        onClick={onSaveAndNext}
        disabled={saving}
        sx={{ 
          backgroundColor: styles.primaryColor,
          '&:hover': { backgroundColor: '#012e39' }
        }}
      >
        {saving ? 'Saving...' : 'Save & Next'}
      </Button>
    </Stack>
  </Box>
));

// Main Component
const AnimalDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  const isNew = !id || id === 'new';

  const [animal, setAnimal] = useState(null);
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [autoSaving, setAutoSaving] = useState(false);
  const [editing, setEditing] = useState(isNew);
  const [activeTab, setActiveTab] = useState(0);
  const [saveModalOpen, setSaveModalOpen] = useState(false);
  const [lastSaved, setLastSaved] = useState(null);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  const [options, setOptions] = useState({
    species: [],
    breeds: {},
    sexes: [],
    animal_classes: {},
    lifecycle_states: [],
    reproductive_statuses: [],
    pregnancy_statuses: [],
    milking_statuses: [],
    semen_statuses: [],
    health_statuses: []
  });

  const [completion, setCompletion] = useState(formSteps.map(() => false));

  const API_URL = "https://dairy.server.statify.co.ke/api/animals/";

  // Get the return path based on lifecycle state
  const getReturnPath = useCallback((lifecycleState) => {
    switch (lifecycleState) {
      case 'Draft':
        return '/animals/draft';
      case 'Active':
        return '/animals/active';
      case 'Inactive':
        return '/animals/inactive';
      default:
        return '/animals';
    }
  }, []);

  // Calculate age from DOB - useCallback to prevent recreation
  const calculateAge = useCallback((dob) => {
    if (!dob) return 'N/A';
    const birthDate = new Date(dob);
    const today = new Date();
    let years = today.getFullYear() - birthDate.getFullYear();
    let months = today.getMonth() - birthDate.getMonth();
    
    if (months < 0) {
      years--;
      months += 12;
    }
    
    if (years === 0) {
      return `${months} month${months !== 1 ? 's' : ''}`;
    }
    return `${years} year${years !== 1 ? 's' : ''} ${months} month${months !== 1 ? 's' : ''}`;
  }, []);

  // Format date for display - useCallback to prevent recreation
  const formatDate = useCallback((dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  }, []);

  // Animal avatar based on species and gender - moved to top level
  const getAnimalAvatar = useCallback(() => {
    const species = animal?.species?.toLowerCase() || 'cattle';
    const isFemale = animal?.sex === 'Female';
    
    if (species.includes('cattle')) {
      return isFemale ? '🐄' : '🐂';
    } else if (species.includes('goat')) {
      return isFemale ? '🐐' : '🐐';
    } else if (species.includes('sheep')) {
      return '🐑';
    } else if (species.includes('pig')) {
      return '🐖';
    } else {
      return '🐾';
    }
  }, [animal?.species, animal?.sex]);

  // Fetch animal data - useCallback to prevent recreation
  const fetchAnimal = useCallback(async () => {
    if (isNew) {
      setForm(initialForm);
      setAnimal({ ...initialForm, id: 'new' });
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${API_URL}${id}`);
      const data = await res.json();
      
      if (res.ok) {
        setAnimal(data.animal || data);
        // Convert null values to empty strings for form
        const formData = {};
        Object.keys(initialForm).forEach(key => {
          let value = data.animal?.[key] || data[key];
          if (value === null || value === undefined) value = "";
          if (value && typeof value === 'string' && value.includes('T')) {
            value = value.split('T')[0];
          }
          formData[key] = value;
        });
        setForm(formData);
      } else {
        swal("Error", "Failed to fetch animal data", "error");
        navigate('/animals');
      }
    } catch (err) {
      console.error('Error fetching animal:', err);
      swal("Error", "Failed to fetch animal data", "error");
      navigate('/animals');
    } finally {
      setLoading(false);
    }
  }, [id, isNew, navigate]);

  // Fetch options - useCallback to prevent recreation
  const fetchOptions = useCallback(async () => {
    try {
      const res = await fetch(`${API_URL}options`);
      const data = await res.json();
      if (res.ok) {
        setOptions(data);
      }
    } catch (err) {
      console.error('Error fetching options:', err);
    }
  }, []);

  useEffect(() => {
    fetchOptions();
    fetchAnimal();
  }, [fetchOptions, fetchAnimal]);

  // Check form completion
  useEffect(() => {
    if (!form) return;

    const newCompletion = formSteps.map((step, index) => {
      switch (step.key) {
        case 'basic':
          return !!(form.tag_number && form.breed && form.dob && form.sex);
        case 'physical':
          return !!(form.current_weight || form.height || form.color);
        case 'health':
          return !!(form.health_status || form.reproductive_status || form.vaccination_status);
        case 'location':
          return !!(form.location || form.herd_id);
        case 'economic':
          return !!(form.purchase_price || form.estimated_value || form.sire_id || form.dam_id);
        case 'notes':
          return !!(form.notes);
        default:
          return false;
      }
    });

    setCompletion(newCompletion);
  }, [form]);

  // Form handler - useCallback to prevent recreation
  const handleFormChange = useCallback((e) => {
    const { name, value, type, checked } = e.target;
    
    let processedValue = value;
    if (type === 'number' && value !== '') {
      processedValue = Number(value);
    } else if (type === 'checkbox') {
      processedValue = checked;
    } else if (value === '') {
      processedValue = '';
    }

    setForm(prev => ({
      ...prev,
      [name]: processedValue
    }));

    setHasUnsavedChanges(true);

    // Update animal class when species or sex changes
    if ((name === 'species' || name === 'sex') && options.animal_classes) {
      const speciesClasses = options.animal_classes[form.species] || {};
      const classes = speciesClasses[form.sex] || [];
      if (classes.length > 0 && !classes.includes(form.animal_class)) {
        setForm(prev => ({ ...prev, animal_class: classes[0] }));
      }
    }
  }, [options.animal_classes, form.species, form.sex, form.animal_class]);

  // Auto-save functionality
  useEffect(() => {
    if (!editing || !hasUnsavedChanges) return;

    const autoSaveTimer = setTimeout(() => {
      if (hasUnsavedChanges) {
        handleAutoSave();
      }
    }, 10000); // Auto-save after 10 seconds of inactivity

    return () => clearTimeout(autoSaveTimer);
  }, [form, hasUnsavedChanges, editing]);

  // Auto-save function - useCallback to prevent recreation
  const handleAutoSave = useCallback(async () => {
    if (!hasUnsavedChanges || saving) return;

    setAutoSaving(true);
    try {
      await saveFormData(false); // Silent save without notifications
      setLastSaved(new Date());
      setHasUnsavedChanges(false);
    } catch (error) {
      console.error('Auto-save failed:', error);
    } finally {
      setAutoSaving(false);
    }
  }, [hasUnsavedChanges, saving]);

  // Save form data (used by both manual and auto-save) - useCallback to prevent recreation
  const saveFormData = useCallback(async (showNotifications = true) => {
    const submitData = { ...form };
    
    // Convert empty strings to null
    Object.keys(submitData).forEach(key => {
      if (submitData[key] === '') {
        submitData[key] = null;
      }
    });

    // Convert numeric fields
    const numericFields = [
      'birth_weight', 'current_weight', 'height', 'weaning_weight', 'yearling_weight',
      'purchase_price', 'sale_price', 'estimated_value', 'genetic_score',
      'number_of_calves', 'lactation_number', 'days_bred', 'days_in_milk',
      'average_milk_yield', 'total_lifetime_milk', 'sire_id', 'dam_id'
    ];
    
    numericFields.forEach(field => {
      if (submitData[field] !== null && submitData[field] !== '') {
        submitData[field] = Number(submitData[field]);
      }
    });

    submitData.is_milking_cow = Boolean(submitData.is_milking_cow);

    const method = isNew ? "POST" : "PUT";
    const url = isNew ? API_URL : `${API_URL}${id}`;

    const res = await fetch(url, {
      method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(submitData),
    });

    const data = await res.json();
    if (res.ok) {
      if (isNew) {
        // For new animals, navigate back to appropriate list after successful creation
        const returnPath = getReturnPath(data.animal?.lifecycle_state || data.lifecycle_state);
        if (showNotifications) {
          swal("Success", data.message || "Animal created successfully", "success")
            .then(() => {
              navigate(returnPath);
            });
        } else {
          navigate(returnPath);
        }
      } else {
        setAnimal(data.animal || data);
        if (showNotifications) {
          swal("Success", data.message || "Changes saved successfully", "success");
        }
      }
      return true;
    } else {
      if (showNotifications) {
        swal("Error", data.error || "Something went wrong", "error");
      }
      return false;
    }
  }, [form, isNew, id, navigate, getReturnPath]);

  // Manual save section - useCallback to prevent recreation
  const saveSection = useCallback(async () => {
    setSaving(true);
    try {
      const success = await saveFormData(true);
      if (success) {
        setSaveModalOpen(false);
        setHasUnsavedChanges(false);
        setLastSaved(new Date());
        
        // For existing animals, exit edit mode after save and determine where to navigate
        if (!isNew) {
          const returnPath = getReturnPath(animal?.lifecycle_state);
          setEditing(false);
          // Optionally navigate back to the list after save
          // navigate(returnPath);
        }
      }
    } catch (err) {
      console.error('Save error:', err);
      swal("Error", "Failed to save changes", "error");
    } finally {
      setSaving(false);
    }
  }, [saveFormData, isNew, animal?.lifecycle_state, getReturnPath]);

  // Save and exit function - navigates back to appropriate list
  const saveAndExit = useCallback(async () => {
    setSaving(true);
    try {
      const success = await saveFormData(true);
      if (success) {
        setSaveModalOpen(false);
        setHasUnsavedChanges(false);
        setLastSaved(new Date());
        
        // Navigate back to appropriate list based on lifecycle state
        if (isNew) {
          // For new animals, the navigation is already handled in saveFormData
        } else {
          const returnPath = getReturnPath(animal?.lifecycle_state);
          navigate(returnPath);
        }
      }
    } catch (err) {
      console.error('Save error:', err);
      swal("Error", "Failed to save changes", "error");
    } finally {
      setSaving(false);
    }
  }, [saveFormData, isNew, animal?.lifecycle_state, getReturnPath, navigate]);

  // Save and go to next tab - useCallback to prevent recreation
  const saveAndNext = useCallback(async () => {
    setSaving(true);
    try {
      const success = await saveFormData(true);
      if (success) {
        setHasUnsavedChanges(false);
        setLastSaved(new Date());
        
        // For existing animals, move to next tab
        if (!isNew && activeTab < tabComponents.length - 1) {
          setActiveTab(activeTab + 1);
        }
      }
    } catch (err) {
      console.error('Save error:', err);
      swal("Error", "Failed to save changes", "error");
    } finally {
      setSaving(false);
    }
  }, [saveFormData, activeTab, isNew]);

  // Submit for approval - useCallback to prevent recreation
  const handleSubmitForApproval = useCallback(async () => {
    const confirm = await swal({
      title: "Submit for Approval?",
      text: "This will change the animal status to Active and make it visible to all users",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (confirm) {
      setSaving(true);
      try {
        const res = await fetch(`${API_URL}${id}/status`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ lifecycle_state: "Active" }),
        });

        const data = await res.json();
        if (res.ok) {
          setAnimal(prev => ({ ...prev, lifecycle_state: "Active" }));
          setForm(prev => ({ ...prev, lifecycle_state: "Active" }));
          swal("Success", "Animal submitted and activated!", "success")
            .then(() => {
              navigate('/animals/active'); // Navigate to active animals list
            });
        } else {
          swal("Error", data.error, "error");
        }
      } catch (err) {
        swal("Error", "Something went wrong", "error");
      } finally {
        setSaving(false);
        setSaveModalOpen(false);
      }
    }
  }, [id, navigate]);

  // Tab components for EDIT mode - memoized callbacks
  const tabComponents = [
    { 
      label: 'Basic Info', 
      component: <BasicInfoTab form={form} onFormChange={handleFormChange} options={options} />
    },
    { 
      label: 'Physical Data', 
      component: <PhysicalTab form={form} onFormChange={handleFormChange} />
    },
    { 
      label: 'Health & Reproductive', 
      component: <HealthReproductiveTab form={form} onFormChange={handleFormChange} options={options} />
    },
    { 
      label: 'Location & Management', 
      component: <LocationManagementTab form={form} onFormChange={handleFormChange} />
    },
    { 
      label: 'Economic & Genetic', 
      component: <EconomicGeneticTab form={form} onFormChange={handleFormChange} />
    },
    { 
      label: 'Additional Info', 
      component: <NotesTab form={form} onFormChange={handleFormChange} />
    },
  ];

  // View components for READ mode - memoized callbacks
  const viewComponents = [
    { 
      label: 'Basic Info', 
      component: <BasicInfoView animal={animal} formatDate={formatDate} calculateAge={calculateAge} />
    },
    { 
      label: 'Health & Reproductive', 
      component: <HealthReproductiveView animal={animal} formatDate={formatDate} />
    },
    { 
      label: 'Location & Management', 
      component: <LocationManagementView animal={animal} formatDate={formatDate} lastSaved={lastSaved} completion={completion} />
    },
    { 
      label: 'Economic & Genetic', 
      component: <EconomicGeneticView animal={animal} />
    },
    { 
      label: 'Additional Info', 
      component: <NotesView animal={animal} />
    },
  ];

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress size={60} sx={{ color: styles.primaryColor }} />
      </Box>
    );
  }

  const completedCount = completion.filter(Boolean).length;
  const totalSteps = formSteps.length;
  const allCompleted = completedCount === totalSteps;

  return (
    <Box sx={{ 
      flexGrow: 1, 
      minHeight: '100vh',
      backgroundColor: styles.lightBackground
    }}>
      {/* Header */}
      <AppBar 
        position="static" 
        sx={{ 
          backgroundColor: styles.primaryColor,
          background: `linear-gradient(135deg, ${styles.primaryColor} 0%, #012e39 100%)`
        }}
      >
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={() => {
              // Navigate back to appropriate list based on current animal state
              const returnPath = getReturnPath(animal?.lifecycle_state);
              navigate(returnPath);
            }}
            sx={{ mr: 2 }}
          >
            <ArrowBackIcon />
          </IconButton>
          
          <Avatar
            sx={{
              mr: 2,
              bgcolor: styles.secondaryColor,
              width: 40,
              height: 40
            }}
          >
            {getAnimalAvatar()}
          </Avatar>
          
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold', fontSize: { xs: '1.5rem', md: '2rem' } }}>
              {isNew ? 'New Animal' : animal?.name || `Animal ${animal?.tag_number}`}
            </Typography>
            <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} sx={{ color: 'white', mt: 0.5 }}>
              <Link 
                color="inherit" 
                onClick={() => {
                  const returnPath = getReturnPath(animal?.lifecycle_state);
                  navigate(returnPath);
                }} 
                sx={{ cursor: 'pointer' }}
              >
                Animals
              </Link>
              <Typography color="inherit">
                {isNew ? 'New Animal' : animal?.tag_number}
              </Typography>
            </Breadcrumbs>
          </Box>
          
          {/* Auto-save indicator */}
          {editing && hasUnsavedChanges && (
            <Chip 
              icon={<AutoAwesomeIcon />}
              label="Unsaved Changes"
              sx={{ 
                backgroundColor: '#ffeb3b',
                color: '#333',
                fontWeight: 'bold',
                mr: 2
              }}
            />
          )}
          
          {!isNew && animal?.lifecycle_state === 'Draft' && (
            <Chip 
              label="DRAFT" 
              sx={{ 
                backgroundColor: styles.secondaryColor,
                color: styles.primaryColor,
                fontWeight: 'bold',
                mr: 2
              }}
            />
          )}
          
          {!isNew && !editing && (
            <Button
              variant="contained"
              startIcon={<EditIcon />}
              onClick={() => setEditing(true)}
              sx={{ 
                backgroundColor: styles.secondaryColor,
                color: styles.primaryColor,
                fontWeight: 'bold',
                '&:hover': {
                  backgroundColor: '#ffb74d',
                }
              }}
            >
              {isMobile ? 'Edit' : 'Edit Animal'}
            </Button>
          )}
          
          {editing && (
            <>
              <Button
                variant="outlined"
                startIcon={<CancelIcon />}
                onClick={() => {
                  if (isNew) {
                    const returnPath = getReturnPath(form.lifecycle_state);
                    navigate(returnPath);
                  } else {
                    setEditing(false);
                    setForm(animal);
                    setHasUnsavedChanges(false);
                  }
                }}
                sx={{ 
                  borderColor: 'white',
                  color: 'white',
                  mr: 1,
                  '&:hover': {
                    borderColor: 'white',
                    backgroundColor: 'rgba(255,255,255,0.1)'
                  }
                }}
              >
                {isMobile ? 'Cancel' : 'Cancel'}
              </Button>
              <Button
                variant="contained"
                startIcon={<SaveIcon />}
                onClick={() => setSaveModalOpen(true)}
                disabled={saving}
                sx={{ 
                  backgroundColor: styles.secondaryColor,
                  color: styles.primaryColor,
                  fontWeight: 'bold',
                  '&:hover': {
                    backgroundColor: '#ffb74d',
                  }
                }}
              >
                {saving ? 'Saving...' : (isMobile ? 'Save' : 'Save All')}
              </Button>
            </>
          )}
        </Toolbar>
      </AppBar>

      <Container maxWidth="xl" sx={{ py: 3 }}>
        {/* Progress Stepper - Only show in edit mode */}
        {editing && (
          <Paper sx={{ p: 3, mb: 3, boxShadow: styles.cardShadow }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
              <Typography variant="h5" sx={{ color: styles.primaryColor, fontWeight: 'bold' }}>
                Completion Progress
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                {autoSaving && (
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <CircularProgress size={16} sx={{ mr: 1 }} />
                    <Typography variant="body2" color="text.secondary">
                      Auto-saving...
                    </Typography>
                  </Box>
                )}
                <Chip 
                  label={`${completedCount}/${totalSteps} completed`}
                  color={allCompleted ? "success" : "default"}
                  icon={allCompleted ? <CheckCircleIcon /> : undefined}
                  sx={{ fontWeight: 'bold' }}
                />
              </Box>
            </Box>
            <Stepper activeStep={-1} alternativeLabel>
              {formSteps.map((step, index) => (
                <Step key={step.key} completed={completion[index]}>
                  <StepLabel 
                    StepIconComponent={() => (
                      <Avatar
                        sx={{
                          bgcolor: completion[index] ? styles.secondaryColor : 'grey.300',
                          color: completion[index] ? styles.primaryColor : 'grey.600',
                          width: 32,
                          height: 32
                        }}
                      >
                        {step.icon}
                      </Avatar>
                    )}
                  >
                    {step.label}
                  </StepLabel>
                </Step>
              ))}
            </Stepper>
          </Paper>
        )}

        {/* Main Content */}
        <Paper sx={{ boxShadow: styles.cardShadow }}>
          {editing ? (
            <>
              <Tabs
                value={activeTab}
                onChange={(e, newValue) => setActiveTab(newValue)}
                indicatorColor="primary"
                textColor="primary"
                variant={isMobile ? "scrollable" : "standard"}
                scrollButtons={isMobile ? "auto" : false}
                sx={{ 
                  borderBottom: 1, 
                  borderColor: 'divider',
                  '& .MuiTab-root': {
                    fontWeight: 'bold',
                    minWidth: { xs: 120, md: 160 }
                  }
                }}
              >
                {tabComponents.map((tab, index) => (
                  <Tab 
                    key={index}
                    label={
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        {tab.label}
                        {completion[index] && (
                          <CheckCircleIcon sx={{ fontSize: 16, ml: 1, color: 'success.main' }} />
                        )}
                      </Box>
                    }
                  />
                ))}
              </Tabs>

              <Box sx={{ p: { xs: 2, md: 3 } }}>
                {tabComponents[activeTab].component}
                <SaveActions 
                  onSaveSection={saveSection}
                  onSaveAndNext={saveAndNext}
                  saving={saving}
                  autoSaving={autoSaving}
                />
              </Box>
            </>
          ) : (
            <Box sx={{ p: { xs: 2, md: 3 } }}>
              {viewComponents.map((section, index) => (
                <Box key={index} sx={{ mb: 4 }}>
                  <Typography 
                    variant="h5" 
                    sx={{ 
                      color: styles.primaryColor,
                      fontWeight: 'bold',
                      mb: 2,
                      pb: 1,
                      borderBottom: `2px solid ${styles.secondaryColor}`
                    }}
                  >
                    {section.label}
                  </Typography>
                  {section.component}
                </Box>
              ))}
            </Box>
          )}
        </Paper>
      </Container>

      {/* Floating Action Button for Mobile */}
      {!editing && !isNew && (
        <Fab
          color="primary"
          aria-label="edit"
          sx={{
            position: 'fixed',
            bottom: 24,
            right: 24,
            display: { xs: 'flex', md: 'none' },
            backgroundColor: styles.secondaryColor,
            color: styles.primaryColor,
            '&:hover': {
              backgroundColor: '#ffb74d',
            }
          }}
          onClick={() => setEditing(true)}
        >
          <EditIcon />
        </Fab>
      )}

      {/* Save Confirmation Modal */}
      <Dialog 
        open={saveModalOpen} 
        onClose={() => setSaveModalOpen(false)}
        PaperProps={{ sx: { borderRadius: 2 } }}
      >
        <DialogTitle sx={{ color: styles.primaryColor, fontWeight: 'bold' }}>
          Save Changes
        </DialogTitle>
        <DialogContent>
          <Typography>
            {allCompleted && animal?.lifecycle_state === 'Draft' 
              ? "All sections are complete! You can save changes and submit for approval to activate this animal record."
              : "Save your changes to this animal record?"}
          </Typography>
          {allCompleted && animal?.lifecycle_state === 'Draft' && (
            <Alert severity="success" sx={{ mt: 2 }}>
              All required information has been completed. This animal is ready to be activated.
            </Alert>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 3, gap: 1 }}>
          <Button 
            onClick={() => setSaveModalOpen(false)}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button 
            onClick={saveAndExit}
            variant="contained"
            sx={{ 
              backgroundColor: styles.primaryColor,
              '&:hover': {
                backgroundColor: '#012e39'
              }
            }}
          >
            {isNew ? 'Save & Exit' : 'Save & Return to List'}
          </Button>
          {allCompleted && animal?.lifecycle_state === 'Draft' && (
            <Button 
              onClick={handleSubmitForApproval}
              variant="contained"
              sx={{ 
                backgroundColor: styles.secondaryColor,
                color: styles.primaryColor,
                fontWeight: 'bold',
                '&:hover': {
                  backgroundColor: '#ffb74d'
                }
              }}
            >
              Save & Activate
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AnimalDetailPage;

// import React, { useState, useEffect, useCallback, memo } from "react";
// import {
//   Box,
//   Typography,
//   Button,
//   TextField,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Chip,
//   IconButton,
//   Paper,
//   Grid,
//   Card,
//   CardContent,
//   CardHeader,
//   Tabs,
//   Tab,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Stepper,
//   Step,
//   StepLabel,
//   Alert,
//   CircularProgress,
//   Divider,
//   Switch,
//   FormControlLabel,
//   AppBar,
//   Toolbar,
//   Avatar,
//   List,
//   ListItem,
//   ListItemText,
//   ListItemIcon,
//   useTheme,
//   useMediaQuery,
//   Container,
//   Fab,
//   Breadcrumbs,
//   Link,
//   Stack,
// } from "@mui/material";
// import {
//   ArrowBack as ArrowBackIcon,
//   Edit as EditIcon,
//   Save as SaveIcon,
//   Cancel as CancelIcon,
//   Pets as PetsIcon,
//   CheckCircle as CheckCircleIcon,
//   NavigateNext as NavigateNextIcon,
//   Scale as ScaleIcon,
//   Favorite as FavoriteIcon,
//   LocationOn as LocationIcon,
//   AttachMoney as MoneyIcon,
//   Notes as NotesIcon,
//   CalendarToday as CalendarIcon,
//   Female as FemaleIcon,
//   Male as MaleIcon,
//   LocalHospital as HealthIcon,
//   Agriculture as AgricultureIcon,
//   Science as ScienceIcon,
//   AutoAwesome as AutoAwesomeIcon,
// } from "@mui/icons-material";
// import { useParams, useNavigate } from "react-router-dom";
// import swal from "sweetalert";

// // Enhanced custom styles
// const styles = {
//   primaryColor: '#024a59',
//   secondaryColor: '#ffa916',
//   accentColor: '#2e7d8f',
//   lightBackground: '#f8f9fa',
//   cardGradient: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
//   sectionGradient: 'linear-gradient(135deg, #024a59 0%, #2e7d8f 100%)',
//   cardShadow: '0 4px 12px rgba(2, 74, 89, 0.1)',
//   cardHoverShadow: '0 8px 24px rgba(2, 74, 89, 0.15)',
//   sectionSpacing: { xs: 2, md: 3 },
//   compactCard: {
//     height: '100%',
//     background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
//     boxShadow: '0 2px 8px rgba(2, 74, 89, 0.08)',
//     borderRadius: 2,
//     transition: 'all 0.3s ease',
//     border: '1px solid rgba(2, 74, 89, 0.05)',
//     '&:hover': {
//       boxShadow: '0 8px 24px rgba(2, 74, 89, 0.15)',
//       transform: 'translateY(-2px)'
//     }
//   },
//   sectionCard: {
//     background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
//     boxShadow: '0 4px 12px rgba(2, 74, 89, 0.1)',
//     borderRadius: 2,
//     border: '1px solid rgba(2, 74, 89, 0.08)',
//     overflow: 'hidden'
//   },
//   statusIndicator: {
//     width: 8,
//     height: 8,
//     borderRadius: '50%',
//     display: 'inline-block',
//     marginRight: 1
//   }
// };

// // Initial empty form - moved outside component
// const initialForm = {
//   // Basic identification
//   tag_number: "",
//   name: "",
//   species: "Cattle",
//   breed: "",
//   dob: "",
  
//   // Gender and animal class
//   sex: "Female",
//   animal_class: "",
  
//   // Genetic information
//   sire_id: "",
//   dam_id: "",
//   registration_number: "",
//   genetic_score: "",
//   breed_composition: "",
  
//   // Physical characteristics
//   color: "",
//   birth_weight: "",
//   current_weight: "",
//   height: "",
//   weaning_weight: "",
//   yearling_weight: "",
  
//   // Reproductive status
//   reproductive_status: "",
//   last_calving_date: "",
//   number_of_calves: "",
//   pregnancy_status: "",
//   lactation_number: "",
//   days_bred: "",
  
//   // Male specific
//   semen_status: "",
//   breeding_capacity: "",
  
//   // Milking data
//   milking_status: "",
//   is_milking_cow: false,
//   last_milking_date: "",
//   days_in_milk: "",
//   average_milk_yield: "",
//   total_lifetime_milk: "",
  
//   // Health and management
//   health_status: "Healthy",
//   vaccination_status: "",
//   last_vet_visit: "",
//   next_vet_visit: "",
  
//   // Location and management
//   location: "",
//   pen_group: "",
//   herd_id: "",
  
//   // Lifecycle management
//   lifecycle_state: "Draft",
//   entry_date: "",
//   exit_date: "",
//   exit_reason: "",
  
//   // Economic data
//   purchase_price: "",
//   sale_price: "",
//   estimated_value: "",
  
//   // Purchase specific
//   origin: "",
//   purchase_conditions: "",
  
//   // Additional metadata
//   notes: "",
  
//   // Animal type
//   animal_type: "born"
// };

// // Form steps for completion tracking - moved outside
// const formSteps = [
//   { key: 'basic', label: 'Basic Info', completed: false, icon: <PetsIcon /> },
//   { key: 'physical', label: 'Physical Data', completed: false, icon: <ScaleIcon /> },
//   { key: 'health', label: 'Health & Reproductive', completed: false, icon: <HealthIcon /> },
//   { key: 'location', label: 'Location & Management', completed: false, icon: <LocationIcon /> },
//   { key: 'economic', label: 'Economic & Genetic', completed: false, icon: <MoneyIcon /> },
//   { key: 'notes', label: 'Additional Info', completed: false, icon: <NotesIcon /> },
// ];

// // Enhanced Compact Info Card Component - memoized
// const CompactInfoCard = memo(({ title, icon, items, status, gradient }) => (
//   <Card sx={{
//     ...styles.compactCard,
//     background: gradient || styles.cardGradient,
//     position: 'relative',
//     overflow: 'visible'
//   }}>
//     {/* Status indicator dot */}
//     {status && (
//       <Box
//         sx={{
//           ...styles.statusIndicator,
//           backgroundColor: status === 'healthy' ? '#4caf50' : 
//                          status === 'warning' ? '#ff9800' : 
//                          status === 'critical' ? '#f44336' : styles.accentColor,
//           position: 'absolute',
//           top: 12,
//           right: 12
//         }}
//       />
//     )}
    
//     <CardHeader
//       title={title}
//       avatar={React.cloneElement(icon, { 
//         sx: { 
//           color: styles.primaryColor,
//           backgroundColor: 'rgba(2, 74, 89, 0.08)',
//           padding: 1,
//           borderRadius: 1
//         } 
//       })}
//       sx={{ 
//         backgroundColor: 'transparent',
//         pb: 1,
//         '& .MuiCardHeader-title': { 
//           fontSize: '1rem', 
//           fontWeight: 'bold',
//           color: styles.primaryColor
//         }
//       }}
//     />
//     <CardContent sx={{ pt: 0, '&:last-child': { pb: 2 } }}>
//       <List dense disablePadding>
//         {items.map((item, index) => (
//           <ListItem 
//             key={index} 
//             disablePadding 
//             sx={{ 
//               py: 1,
//               borderBottom: index < items.length - 1 ? '1px solid rgba(2, 74, 89, 0.06)' : 'none'
//             }}
//           >
//             <ListItemText 
//               primary={item.primary}
//               secondary={item.secondary}
//               primaryTypographyProps={{ 
//                 variant: 'body2', 
//                 fontWeight: 'medium',
//                 color: 'text.secondary',
//                 fontSize: '0.875rem'
//               }}
//               secondaryTypographyProps={{ 
//                 variant: 'body1', 
//                 color: 'text.primary',
//                 fontWeight: 600,
//                 fontSize: '0.95rem'
//               }}
//             />
//           </ListItem>
//         ))}
//       </List>
//     </CardContent>
//   </Card>
// ));

// // Tab Components - memoized to prevent unnecessary re-renders
// const BasicInfoTab = memo(({ form, onFormChange, options }) => {
//   const handleChange = useCallback((e) => {
//     onFormChange(e);
//   }, [onFormChange]);

//   return (
//     <Box>
//       <Grid container spacing={2}>
//         <Grid item xs={12} md={6}>
//           <FormControl fullWidth>
//             <InputLabel>Animal Type</InputLabel>
//             <Select
//               name="animal_type"
//               value={form.animal_type || ""}
//               onChange={handleChange}
//               label="Animal Type"
//             >
//               <MenuItem value="born">Born on Farm</MenuItem>
//               <MenuItem value="purchased">Purchased</MenuItem>
//             </Select>
//           </FormControl>
//         </Grid>
        
//         <Grid item xs={12} md={6}>
//           <TextField
//             fullWidth
//             label="Tag Number *"
//             name="tag_number"
//             value={form.tag_number || ""}
//             onChange={handleChange}
//             required
//           />
//         </Grid>

//         <Grid item xs={12} md={6}>
//           <TextField
//             fullWidth
//             label="Name"
//             name="name"
//             value={form.name || ""}
//             onChange={handleChange}
//           />
//         </Grid>
        
//         <Grid item xs={12} md={6}>
//           <FormControl fullWidth>
//             <InputLabel>Species</InputLabel>
//             <Select
//               name="species"
//               value={form.species || ""}
//               onChange={handleChange}
//               label="Species"
//             >
//               {options.species.map(species => (
//                 <MenuItem key={species} value={species}>{species}</MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Grid>

//         <Grid item xs={12} md={6}>
//           <FormControl fullWidth>
//             <InputLabel>Breed *</InputLabel>
//             <Select
//               name="breed"
//               value={form.breed || ""}
//               onChange={handleChange}
//               label="Breed *"
//               required
//             >
//               <MenuItem value="">Select Breed</MenuItem>
//               {options.breeds[form.species]?.map(breed => (
//                 <MenuItem key={breed} value={breed}>{breed}</MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Grid>
        
//         <Grid item xs={12} md={6}>
//           <TextField
//             fullWidth
//             label="Date of Birth *"
//             name="dob"
//             type="date"
//             value={form.dob || ""}
//             onChange={handleChange}
//             InputLabelProps={{ shrink: true }}
//             required
//           />
//         </Grid>

//         <Grid item xs={12} md={6}>
//           <FormControl fullWidth>
//             <InputLabel>Gender *</InputLabel>
//             <Select
//               name="sex"
//               value={form.sex || ""}
//               onChange={handleChange}
//               label="Gender *"
//               required
//             >
//               {options.sexes.map(sex => (
//                 <MenuItem key={sex} value={sex}>{sex}</MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Grid>
        
//         <Grid item xs={12} md={6}>
//           <FormControl fullWidth>
//             <InputLabel>Animal Class</InputLabel>
//             <Select
//               name="animal_class"
//               value={form.animal_class || ""}
//               onChange={handleChange}
//               label="Animal Class"
//             >
//               <MenuItem value="">Select Class</MenuItem>
//               {options.animal_classes[form.species]?.[form.sex]?.map(cls => (
//                 <MenuItem key={cls} value={cls}>{cls}</MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Grid>

//         <Grid item xs={12} md={6}>
//           <TextField
//             fullWidth
//             label="Color"
//             name="color"
//             value={form.color || ""}
//             onChange={handleChange}
//           />
//         </Grid>

//         <Grid item xs={12} md={6}>
//           <FormControl fullWidth>
//             <InputLabel>Lifecycle State</InputLabel>
//             <Select
//               name="lifecycle_state"
//               value={form.lifecycle_state || ""}
//               onChange={handleChange}
//               label="Lifecycle State"
//             >
//               {options.lifecycle_states.map(state => (
//                 <MenuItem key={state} value={state}>{state}</MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Grid>
//       </Grid>
//     </Box>
//   );
// });

// const PhysicalTab = memo(({ form, onFormChange }) => {
//   const handleChange = useCallback((e) => {
//     onFormChange(e);
//   }, [onFormChange]);

//   return (
//     <Box>
//       <Grid container spacing={2}>
//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Birth Weight (kg)"
//             name="birth_weight"
//             type="number"
//             value={form.birth_weight || ""}
//             onChange={handleChange}
//             InputProps={{ inputProps: { min: 0, step: 0.1 } }}
//           />
//         </Grid>
        
//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Current Weight (kg)"
//             name="current_weight"
//             type="number"
//             value={form.current_weight || ""}
//             onChange={handleChange}
//             InputProps={{ inputProps: { min: 0, step: 0.1 } }}
//           />
//         </Grid>

//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Height (cm)"
//             name="height"
//             type="number"
//             value={form.height || ""}
//             onChange={handleChange}
//             InputProps={{ inputProps: { min: 0, step: 0.1 } }}
//           />
//         </Grid>
        
//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Weaning Weight (kg)"
//             name="weaning_weight"
//             type="number"
//             value={form.weaning_weight || ""}
//             onChange={handleChange}
//             InputProps={{ inputProps: { min: 0, step: 0.1 } }}
//           />
//         </Grid>

//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Yearling Weight (kg)"
//             name="yearling_weight"
//             type="number"
//             value={form.yearling_weight || ""}
//             onChange={handleChange}
//             InputProps={{ inputProps: { min: 0, step: 0.1 } }}
//           />
//         </Grid>
//       </Grid>
//     </Box>
//   );
// });

// const HealthReproductiveTab = memo(({ form, onFormChange, options }) => {
//   const handleChange = useCallback((e) => {
//     onFormChange(e);
//   }, [onFormChange]);

//   return (
//     <Box>
//       <Grid container spacing={2}>
//         <Grid item xs={12} sm={6} md={4}>
//           <FormControl fullWidth>
//             <InputLabel>Health Status</InputLabel>
//             <Select
//               name="health_status"
//               value={form.health_status || ""}
//               onChange={handleChange}
//               label="Health Status"
//             >
//               {options.health_statuses.map(status => (
//                 <MenuItem key={status} value={status}>{status}</MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Grid>
        
//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Vaccination Status"
//             name="vaccination_status"
//             value={form.vaccination_status || ""}
//             onChange={handleChange}
//           />
//         </Grid>

//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Last Vet Visit"
//             name="last_vet_visit"
//             type="date"
//             value={form.last_vet_visit || ""}
//             onChange={handleChange}
//             InputLabelProps={{ shrink: true }}
//           />
//         </Grid>
        
//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Next Vet Visit"
//             name="next_vet_visit"
//             type="date"
//             value={form.next_vet_visit || ""}
//             onChange={handleChange}
//             InputLabelProps={{ shrink: true }}
//           />
//         </Grid>

//         {form.sex === 'Female' && (
//           <>
//             <Grid item xs={12} sm={6} md={4}>
//               <FormControl fullWidth>
//                 <InputLabel>Reproductive Status</InputLabel>
//                 <Select
//                   name="reproductive_status"
//                   value={form.reproductive_status || ""}
//                   onChange={handleChange}
//                   label="Reproductive Status"
//                 >
//                   <MenuItem value="">Select Status</MenuItem>
//                   {options.reproductive_statuses.map(status => (
//                     <MenuItem key={status} value={status}>{status}</MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>
            
//             <Grid item xs={12} sm={6} md={4}>
//               <FormControl fullWidth>
//                 <InputLabel>Pregnancy Status</InputLabel>
//                 <Select
//                   name="pregnancy_status"
//                   value={form.pregnancy_status || ""}
//                   onChange={handleChange}
//                   label="Pregnancy Status"
//                 >
//                   <MenuItem value="">Select Status</MenuItem>
//                   {options.pregnancy_statuses.map(status => (
//                     <MenuItem key={status} value={status}>{status}</MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>

//             <Grid item xs={12} sm={6} md={4}>
//               <TextField
//                 fullWidth
//                 label="Last Calving Date"
//                 name="last_calving_date"
//                 type="date"
//                 value={form.last_calving_date || ""}
//                 onChange={handleChange}
//                 InputLabelProps={{ shrink: true }}
//               />
//             </Grid>
            
//             <Grid item xs={12} sm={6} md={4}>
//               <TextField
//                 fullWidth
//                 label="Number of Calves"
//                 name="number_of_calves"
//                 type="number"
//                 value={form.number_of_calves || ""}
//                 onChange={handleChange}
//                 InputProps={{ inputProps: { min: 0 } }}
//               />
//             </Grid>

//             <Grid item xs={12} sm={6} md={4}>
//               <TextField
//                 fullWidth
//                 label="Lactation Number"
//                 name="lactation_number"
//                 type="number"
//                 value={form.lactation_number || ""}
//                 onChange={handleChange}
//                 InputProps={{ inputProps: { min: 0 } }}
//               />
//             </Grid>
            
//             <Grid item xs={12} sm={6} md={4}>
//               <TextField
//                 fullWidth
//                 label="Days Bred"
//                 name="days_bred"
//                 type="number"
//                 value={form.days_bred || ""}
//                 onChange={handleChange}
//                 InputProps={{ inputProps: { min: 0 } }}
//               />
//             </Grid>

//             <Grid item xs={12} sm={6} md={4}>
//               <FormControl fullWidth>
//                 <InputLabel>Milking Status</InputLabel>
//                 <Select
//                   name="milking_status"
//                   value={form.milking_status || ""}
//                   onChange={handleChange}
//                   label="Milking Status"
//                 >
//                   <MenuItem value="">Select Status</MenuItem>
//                   {options.milking_statuses.map(status => (
//                     <MenuItem key={status} value={status}>{status}</MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>
            
//             <Grid item xs={12} sm={6} md={4}>
//               <FormControlLabel
//                 control={
//                   <Switch
//                     name="is_milking_cow"
//                     checked={form.is_milking_cow || false}
//                     onChange={handleChange}
//                   />
//                 }
//                 label="Is Milking Cow"
//               />
//             </Grid>

//             <Grid item xs={12} sm={6} md={4}>
//               <TextField
//                 fullWidth
//                 label="Last Milking Date"
//                 name="last_milking_date"
//                 type="date"
//                 value={form.last_milking_date || ""}
//                 onChange={handleChange}
//                 InputLabelProps={{ shrink: true }}
//               />
//             </Grid>
            
//             <Grid item xs={12} sm={6} md={4}>
//               <TextField
//                 fullWidth
//                 label="Days in Milk"
//                 name="days_in_milk"
//                 type="number"
//                 value={form.days_in_milk || ""}
//                 onChange={handleChange}
//                 InputProps={{ inputProps: { min: 0 } }}
//               />
//             </Grid>

//             <Grid item xs={12} sm={6} md={4}>
//               <TextField
//                 fullWidth
//                 label="Avg Milk Yield (L/day)"
//                 name="average_milk_yield"
//                 type="number"
//                 value={form.average_milk_yield || ""}
//                 onChange={handleChange}
//                 InputProps={{ inputProps: { min: 0, step: 0.1 } }}
//               />
//             </Grid>
            
//             <Grid item xs={12} sm={6} md={4}>
//               <TextField
//                 fullWidth
//                 label="Total Lifetime Milk (L)"
//                 name="total_lifetime_milk"
//                 type="number"
//                 value={form.total_lifetime_milk || ""}
//                 onChange={handleChange}
//                 InputProps={{ inputProps: { min: 0, step: 0.1 } }}
//               />
//             </Grid>
//           </>
//         )}

//         {form.sex === 'Male' && (
//           <>
//             <Grid item xs={12} sm={6} md={4}>
//               <FormControl fullWidth>
//                 <InputLabel>Semen Status</InputLabel>
//                 <Select
//                   name="semen_status"
//                   value={form.semen_status || ""}
//                   onChange={handleChange}
//                   label="Semen Status"
//                 >
//                   <MenuItem value="">Select Status</MenuItem>
//                   {options.semen_statuses.map(status => (
//                     <MenuItem key={status} value={status}>{status}</MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>
            
//             <Grid item xs={12} sm={6} md={4}>
//               <TextField
//                 fullWidth
//                 label="Breeding Capacity"
//                 name="breeding_capacity"
//                 value={form.breeding_capacity || ""}
//                 onChange={handleChange}
//               />
//             </Grid>
//           </>
//         )}
//       </Grid>
//     </Box>
//   );
// });

// const LocationManagementTab = memo(({ form, onFormChange }) => {
//   const handleChange = useCallback((e) => {
//     onFormChange(e);
//   }, [onFormChange]);

//   return (
//     <Box>
//       <Grid container spacing={2}>
//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Location"
//             name="location"
//             value={form.location || ""}
//             onChange={handleChange}
//           />
//         </Grid>
        
//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Pen/Group"
//             name="pen_group"
//             value={form.pen_group || ""}
//             onChange={handleChange}
//           />
//         </Grid>

//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Herd ID"
//             name="herd_id"
//             value={form.herd_id || ""}
//             onChange={handleChange}
//           />
//         </Grid>

//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Entry Date"
//             name="entry_date"
//             type="date"
//             value={form.entry_date || ""}
//             onChange={handleChange}
//             InputLabelProps={{ shrink: true }}
//           />
//         </Grid>
        
//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Exit Date"
//             name="exit_date"
//             type="date"
//             value={form.exit_date || ""}
//             onChange={handleChange}
//             InputLabelProps={{ shrink: true }}
//           />
//         </Grid>

//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Exit Reason"
//             name="exit_reason"
//             value={form.exit_reason || ""}
//             onChange={handleChange}
//           />
//         </Grid>
//       </Grid>
//     </Box>
//   );
// });

// const EconomicGeneticTab = memo(({ form, onFormChange }) => {
//   const handleChange = useCallback((e) => {
//     onFormChange(e);
//   }, [onFormChange]);

//   return (
//     <Box>
//       <Grid container spacing={2}>
//         {form.animal_type === 'purchased' && (
//           <>
//             <Grid item xs={12} sm={6} md={4}>
//               <TextField
//                 fullWidth
//                 label="Purchase Price ($)"
//                 name="purchase_price"
//                 type="number"
//                 value={form.purchase_price || ""}
//                 onChange={handleChange}
//                 InputProps={{ inputProps: { min: 0, step: 0.01 } }}
//               />
//             </Grid>
            
//             <Grid item xs={12} sm={6} md={4}>
//               <TextField
//                 fullWidth
//                 label="Sale Price ($)"
//                 name="sale_price"
//                 type="number"
//                 value={form.sale_price || ""}
//                 onChange={handleChange}
//                 InputProps={{ inputProps: { min: 0, step: 0.01 } }}
//               />
//             </Grid>

//             <Grid item xs={12} sm={6} md={4}>
//               <TextField
//                 fullWidth
//                 label="Estimated Value ($)"
//                 name="estimated_value"
//                 type="number"
//                 value={form.estimated_value || ""}
//                 onChange={handleChange}
//                 InputProps={{ inputProps: { min: 0, step: 0.01 } }}
//               />
//             </Grid>
            
//             <Grid item xs={12} sm={6} md={4}>
//               <TextField
//                 fullWidth
//                 label="Origin"
//                 name="origin"
//                 value={form.origin || ""}
//                 onChange={handleChange}
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <TextField
//                 fullWidth
//                 label="Purchase Conditions"
//                 name="purchase_conditions"
//                 multiline
//                 rows={3}
//                 value={form.purchase_conditions || ""}
//                 onChange={handleChange}
//               />
//             </Grid>
//             <Grid item xs={12}><Divider sx={{ my: 2 }} /></Grid>
//           </>
//         )}

//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Sire ID"
//             name="sire_id"
//             type="number"
//             value={form.sire_id || ""}
//             onChange={handleChange}
//             InputProps={{ inputProps: { min: 0 } }}
//           />
//         </Grid>
        
//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Dam ID"
//             name="dam_id"
//             type="number"
//             value={form.dam_id || ""}
//             onChange={handleChange}
//             InputProps={{ inputProps: { min: 0 } }}
//           />
//         </Grid>

//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Registration Number"
//             name="registration_number"
//             value={form.registration_number || ""}
//             onChange={handleChange}
//           />
//         </Grid>
        
//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Genetic Score"
//             name="genetic_score"
//             type="number"
//             value={form.genetic_score || ""}
//             onChange={handleChange}
//             InputProps={{ inputProps: { min: 0, step: 0.1 } }}
//           />
//         </Grid>

//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Breed Composition"
//             name="breed_composition"
//             value={form.breed_composition || ""}
//             onChange={handleChange}
//           />
//         </Grid>
//       </Grid>
//     </Box>
//   );
// });

// const NotesTab = memo(({ form, onFormChange }) => {
//   const handleChange = useCallback((e) => {
//     onFormChange(e);
//   }, [onFormChange]);

//   return (
//     <Box>
//       <Grid container spacing={2}>
//         <Grid item xs={12}>
//           <TextField
//             fullWidth
//             label="Notes"
//             name="notes"
//             multiline
//             rows={6}
//             value={form.notes || ""}
//             onChange={handleChange}
//             placeholder="Additional notes about the animal..."
//           />
//         </Grid>
//       </Grid>
//     </Box>
//   );
// });

// // Enhanced View Components - memoized with 3-column layout
// const BasicInfoView = memo(({ animal, formatDate, calculateAge }) => (
//   <Grid container spacing={3}>
//     {/* Identification */}
//     <Grid item xs={12} md={4}>
//       <CompactInfoCard
//         title="Identification"
//         icon={<PetsIcon />}
//         status="healthy"
//         items={[
//           { primary: "Tag Number", secondary: animal?.tag_number || 'N/A' },
//           { primary: "Name", secondary: animal?.name || 'N/A' },
//           { primary: "Species", secondary: animal?.species || 'N/A' },
//           { primary: "Breed", secondary: animal?.breed || 'N/A' },
//           { primary: "Registration Number", secondary: animal?.registration_number || 'N/A' },
//         ]}
//       />
//     </Grid>

//     {/* Demographics & Physical */}
//     <Grid item xs={12} md={4}>
//       <CompactInfoCard
//         title="Demographics & Physical"
//         icon={<CalendarIcon />}
//         status="healthy"
//         items={[
//           { primary: "Date of Birth", secondary: formatDate(animal?.dob) },
//           { primary: "Age", secondary: calculateAge(animal?.dob) },
//           { primary: "Gender", secondary: animal?.sex || 'N/A' },
//           { primary: "Animal Class", secondary: animal?.animal_class || 'N/A' },
//           { primary: "Current Weight", secondary: animal?.current_weight ? `${animal.current_weight} kg` : 'N/A' },
//           { primary: "Height", secondary: animal?.height ? `${animal.height} cm` : 'N/A' },
//           { primary: "Birth Weight", secondary: animal?.birth_weight ? `${animal.birth_weight} kg` : 'N/A' },
//         ]}
//       />
//     </Grid>

//     {/* Status & Appearance */}
//     <Grid item xs={12} md={4}>
//       <CompactInfoCard
//         title="Status & Appearance"
//         icon={<AutoAwesomeIcon />}
//         status="healthy"
//         items={[
//           { primary: "Color", secondary: animal?.color || 'N/A' },
//           { primary: "Animal Type", secondary: animal?.purchase_price ? "PURCHASED" : "BORN" },
//           { primary: "Lifecycle State", secondary: animal?.lifecycle_state || 'N/A' },
//           { primary: "Health Status", secondary: animal?.health_status || 'N/A' },
//           { primary: "Weaning Weight", secondary: animal?.weaning_weight ? `${animal.weaning_weight} kg` : 'N/A' },
//           { primary: "Yearling Weight", secondary: animal?.yearling_weight ? `${animal.yearling_weight} kg` : 'N/A' },
//         ]}
//       />
//     </Grid>
//   </Grid>
// ));

// const HealthReproductiveView = memo(({ animal, formatDate }) => {
//   const getHealthStatus = () => {
//     if (animal?.health_status === 'Healthy') return 'healthy';
//     if (animal?.health_status === 'Sick') return 'critical';
//     return 'warning';
//   };

//   return (
//     <Grid container spacing={3}>
//       {/* Health Status */}
//       <Grid item xs={12} md={4}>
//         <CompactInfoCard
//           title="Health Status"
//           icon={<HealthIcon />}
//           status={getHealthStatus()}
//           items={[
//             { primary: "Health Status", secondary: animal?.health_status || 'N/A' },
//             { primary: "Vaccination Status", secondary: animal?.vaccination_status || 'N/A' },
//             { primary: "Last Vet Visit", secondary: formatDate(animal?.last_vet_visit) },
//             { primary: "Next Vet Visit", secondary: formatDate(animal?.next_vet_visit) },
//           ]}
//         />
//       </Grid>

//       {/* Reproductive Health */}
//       {animal?.sex === 'Female' && (
//         <Grid item xs={12} md={4}>
//           <CompactInfoCard
//             title="Reproductive Health"
//             icon={<FavoriteIcon />}
//             status="healthy"
//             items={[
//               { primary: "Reproductive Status", secondary: animal?.reproductive_status || 'N/A' },
//               { primary: "Pregnancy Status", secondary: animal?.pregnancy_status || 'N/A' },
//               { primary: "Last Calving Date", secondary: formatDate(animal?.last_calving_date) },
//               { primary: "Number of Calves", secondary: animal?.number_of_calves || 'N/A' },
//               { primary: "Lactation Number", secondary: animal?.lactation_number || 'N/A' },
//               { primary: "Days Bred", secondary: animal?.days_bred || 'N/A' },
//             ]}
//           />
//         </Grid>
//       )}

//       {/* Breeding Information */}
//       {animal?.sex === 'Male' && (
//         <Grid item xs={12} md={4}>
//           <CompactInfoCard
//             title="Breeding Information"
//             icon={<MaleIcon />}
//             status="healthy"
//             items={[
//               { primary: "Semen Status", secondary: animal?.semen_status || 'N/A' },
//               { primary: "Breeding Capacity", secondary: animal?.breeding_capacity || 'N/A' },
//             ]}
//           />
//         </Grid>
//       )}

//       {/* Milking Information */}
//       {animal?.sex === 'Female' && animal?.is_milking_cow && (
//         <Grid item xs={12} md={4}>
//           <CompactInfoCard
//             title="Milking Information"
//             icon={<AgricultureIcon />}
//             status="healthy"
//             items={[
//               { primary: "Milking Status", secondary: animal?.milking_status || 'N/A' },
//               { primary: "Last Milking Date", secondary: formatDate(animal?.last_milking_date) },
//               { primary: "Days in Milk", secondary: animal?.days_in_milk || 'N/A' },
//               { primary: "Avg Milk Yield", secondary: animal?.average_milk_yield ? `${animal.average_milk_yield} L/day` : 'N/A' },
//               { primary: "Total Lifetime Milk", secondary: animal?.total_lifetime_milk ? `${animal.total_lifetime_milk} L` : 'N/A' },
//             ]}
//           />
//         </Grid>
//       )}

//       {/* Additional Health Info */}
//       <Grid item xs={12} md={4}>
//         <Card sx={{ 
//           ...styles.compactCard, 
//           height: '100%', 
//           display: 'flex', 
//           alignItems: 'center', 
//           justifyContent: 'center',
//           background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)'
//         }}>
//           <CardContent>
//             <Box textAlign="center">
//               <HealthIcon sx={{ fontSize: 48, color: styles.accentColor, opacity: 0.7, mb: 2 }} />
//               <Typography variant="h6" color={styles.primaryColor} gutterBottom>
//                 Health Metrics
//               </Typography>
//               <Typography variant="body2" color="text.secondary">
//                 Additional health metrics and reproductive data will appear here as they are recorded.
//               </Typography>
//             </Box>
//           </CardContent>
//         </Card>
//       </Grid>
//     </Grid>
//   );
// });

// const LocationManagementView = memo(({ animal, formatDate, lastSaved, completion }) => (
//   <Grid container spacing={3}>
//     {/* Location Details */}
//     <Grid item xs={12} md={4}>
//       <CompactInfoCard
//         title="Location Details"
//         icon={<LocationIcon />}
//         status="healthy"
//         items={[
//           { primary: "Location", secondary: animal?.location || 'N/A' },
//           { primary: "Pen/Group", secondary: animal?.pen_group || 'N/A' },
//           { primary: "Herd ID", secondary: animal?.herd_id || 'N/A' },
//         ]}
//       />
//     </Grid>

//     {/* Lifecycle Management */}
//     <Grid item xs={12} md={4}>
//       <CompactInfoCard
//         title="Lifecycle Management"
//         icon={<CalendarIcon />}
//         status="healthy"
//         items={[
//           { primary: "Entry Date", secondary: formatDate(animal?.entry_date) },
//           { primary: "Exit Date", secondary: formatDate(animal?.exit_date) },
//           { primary: "Exit Reason", secondary: animal?.exit_reason || 'N/A' },
//         ]}
//       />
//     </Grid>

//     {/* Quick Actions */}
//     <Grid item xs={12} md={4}>
//       <CompactInfoCard
//         title="Quick Actions"
//         icon={<AutoAwesomeIcon />}
//         status="healthy"
//         items={[
//           { primary: "Status", secondary: animal?.lifecycle_state || 'N/A' },
//           { primary: "Last Updated", secondary: lastSaved ? formatDate(lastSaved) : 'N/A' },
//           { primary: "Record Complete", secondary: `${completion.filter(Boolean).length}/${completion.length} sections` },
//         ]}
//       />
//     </Grid>
//   </Grid>
// ));

// const EconomicGeneticView = memo(({ animal }) => (
//   <Grid container spacing={3}>
//     {/* Financial Information */}
//     {animal?.purchase_price && (
//       <Grid item xs={12} md={4}>
//         <CompactInfoCard
//           title="Financial Information"
//           icon={<MoneyIcon />}
//           status="healthy"
//           items={[
//             { primary: "Purchase Price", secondary: animal?.purchase_price ? `$${animal.purchase_price}` : 'N/A' },
//             { primary: "Sale Price", secondary: animal?.sale_price ? `$${animal.sale_price}` : 'N/A' },
//             { primary: "Estimated Value", secondary: animal?.estimated_value ? `$${animal.estimated_value}` : 'N/A' },
//             { primary: "Origin", secondary: animal?.origin || 'N/A' },
//           ]}
//         />
//       </Grid>
//     )}

//     {/* Genetic Information */}
//     <Grid item xs={12} md={4}>
//       <CompactInfoCard
//         title="Genetic Information"
//         icon={<ScienceIcon />}
//         status="healthy"
//         items={[
//           { primary: "Sire ID", secondary: animal?.sire_id || 'N/A' },
//           { primary: "Dam ID", secondary: animal?.dam_id || 'N/A' },
//           { primary: "Registration Number", secondary: animal?.registration_number || 'N/A' },
//           { primary: "Genetic Score", secondary: animal?.genetic_score || 'N/A' },
//           { primary: "Breed Composition", secondary: animal?.breed_composition || 'N/A' },
//         ]}
//       />
//     </Grid>

//     {/* Performance Metrics */}
//     <Grid item xs={12} md={4}>
//       <CompactInfoCard
//         title="Performance Metrics"
//         icon={<ScaleIcon />}
//         status="healthy"
//         items={[
//           { primary: "Weaning Weight", secondary: animal?.weaning_weight ? `${animal.weaning_weight} kg` : 'N/A' },
//           { primary: "Yearling Weight", secondary: animal?.yearling_weight ? `${animal.yearling_weight} kg` : 'N/A' },
//           { primary: "Lactation Number", secondary: animal?.lactation_number || 'N/A' },
//           { primary: "Total Milk Production", secondary: animal?.total_lifetime_milk ? `${animal.total_lifetime_milk} L` : 'N/A' },
//         ]}
//       />
//     </Grid>

//     {/* Placeholder for non-purchased animals */}
//     {!animal?.purchase_price && (
//       <Grid item xs={12} md={4}>
//         <Card sx={{ 
//           ...styles.compactCard, 
//           height: '100%', 
//           display: 'flex', 
//           alignItems: 'center', 
//           justifyContent: 'center',
//           background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)'
//         }}>
//           <CardContent>
//             <Box textAlign="center">
//               <MoneyIcon sx={{ fontSize: 48, color: styles.accentColor, opacity: 0.7, mb: 2 }} />
//               <Typography variant="h6" color={styles.primaryColor} gutterBottom>
//                 Financial Info
//               </Typography>
//               <Typography variant="body2" color="text.secondary">
//                 Financial information will appear here for purchased animals.
//               </Typography>
//             </Box>
//           </CardContent>
//         </Card>
//       </Grid>
//     )}
//   </Grid>
// ));

// const NotesView = memo(({ animal }) => (
//   <Grid container spacing={3}>
//     <Grid item xs={12}>
//       <Card sx={{
//         ...styles.sectionCard,
//         background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)'
//       }}>

//         <CardContent>
//           <Typography 
//             variant="body1" 
//             sx={{ 
//               minHeight: 100,
//               p: 3,
//               backgroundColor: 'rgba(2, 74, 89, 0.02)',
//               borderRadius: 1,
//               lineHeight: 1.6,
//               border: '1px solid rgba(2, 74, 89, 0.08)'
//             }}
//           >
//             {animal?.notes || 'No additional notes available for this animal.'}
//           </Typography>
//         </CardContent>
//       </Card>
//     </Grid>
//   </Grid>
// ));

// // Save Actions Component - memoized
// const SaveActions = memo(({ onSaveSection, onSaveAndNext, saving, autoSaving }) => (
//   <Box sx={{ mt: 3, pt: 2, borderTop: 1, borderColor: 'divider' }}>
//     <Stack direction="row" spacing={2} justifyContent="flex-end">
//       {autoSaving && (
//         <Box sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
//           <CircularProgress size={20} sx={{ mr: 1 }} />
//           <Typography variant="body2" color="text.secondary">
//             Auto-saving...
//           </Typography>
//         </Box>
//       )}
//       <Button
//         variant="outlined"
//         onClick={onSaveSection}
//         disabled={saving}
//       >
//         {saving ? 'Saving...' : 'Save This Section'}
//       </Button>
//       <Button
//         variant="contained"
//         onClick={onSaveAndNext}
//         disabled={saving}
//         sx={{ 
//           backgroundColor: styles.primaryColor,
//           '&:hover': { backgroundColor: '#012e39' }
//         }}
//       >
//         {saving ? 'Saving...' : 'Save & Next'}
//       </Button>
//     </Stack>
//   </Box>
// ));

// // Main Component
// const AnimalDetailPage = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('md'));
//   const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
//   const isNew = !id || id === 'new';

//   const [animal, setAnimal] = useState(null);
//   const [form, setForm] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [saving, setSaving] = useState(false);
//   const [autoSaving, setAutoSaving] = useState(false);
//   const [editing, setEditing] = useState(isNew);
//   const [activeTab, setActiveTab] = useState(0);
//   const [saveModalOpen, setSaveModalOpen] = useState(false);
//   const [lastSaved, setLastSaved] = useState(null);
//   const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

//   const [options, setOptions] = useState({
//     species: [],
//     breeds: {},
//     sexes: [],
//     animal_classes: {},
//     lifecycle_states: [],
//     reproductive_statuses: [],
//     pregnancy_statuses: [],
//     milking_statuses: [],
//     semen_statuses: [],
//     health_statuses: []
//   });

//   const [completion, setCompletion] = useState(formSteps.map(() => false));

//   const API_URL = "http://127.0.0.1:5055/api/animals/";

//   // Calculate age from DOB - useCallback to prevent recreation
//   const calculateAge = useCallback((dob) => {
//     if (!dob) return 'N/A';
//     const birthDate = new Date(dob);
//     const today = new Date();
//     let years = today.getFullYear() - birthDate.getFullYear();
//     let months = today.getMonth() - birthDate.getMonth();
    
//     if (months < 0) {
//       years--;
//       months += 12;
//     }
    
//     if (years === 0) {
//       return `${months} month${months !== 1 ? 's' : ''}`;
//     }
//     return `${years} year${years !== 1 ? 's' : ''} ${months} month${months !== 1 ? 's' : ''}`;
//   }, []);

//   // Format date for display - useCallback to prevent recreation
//   const formatDate = useCallback((dateString) => {
//     if (!dateString) return 'N/A';
//     return new Date(dateString).toLocaleDateString('en-US', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric'
//     });
//   }, []);

//   // Animal avatar based on species and gender - moved to top level
//   const getAnimalAvatar = useCallback(() => {
//     const species = animal?.species?.toLowerCase() || 'cattle';
//     const isFemale = animal?.sex === 'Female';
    
//     if (species.includes('cattle')) {
//       return isFemale ? '🐄' : '🐂';
//     } else if (species.includes('goat')) {
//       return isFemale ? '🐐' : '🐐';
//     } else if (species.includes('sheep')) {
//       return '🐑';
//     } else if (species.includes('pig')) {
//       return '🐖';
//     } else {
//       return '🐾';
//     }
//   }, [animal?.species, animal?.sex]);

//   // Fetch animal data - useCallback to prevent recreation
//   const fetchAnimal = useCallback(async () => {
//     if (isNew) {
//       setForm(initialForm);
//       setAnimal({ ...initialForm, id: 'new' });
//       return;
//     }

//     setLoading(true);
//     try {
//       const res = await fetch(`${API_URL}${id}`);
//       const data = await res.json();
      
//       if (res.ok) {
//         setAnimal(data.animal || data);
//         // Convert null values to empty strings for form
//         const formData = {};
//         Object.keys(initialForm).forEach(key => {
//           let value = data.animal?.[key] || data[key];
//           if (value === null || value === undefined) value = "";
//           if (value && typeof value === 'string' && value.includes('T')) {
//             value = value.split('T')[0];
//           }
//           formData[key] = value;
//         });
//         setForm(formData);
//       } else {
//         swal("Error", "Failed to fetch animal data", "error");
//         navigate('/animals');
//       }
//     } catch (err) {
//       console.error('Error fetching animal:', err);
//       swal("Error", "Failed to fetch animal data", "error");
//       navigate('/animals');
//     } finally {
//       setLoading(false);
//     }
//   }, [id, isNew, navigate]);

//   // Fetch options - useCallback to prevent recreation
//   const fetchOptions = useCallback(async () => {
//     try {
//       const res = await fetch(`${API_URL}options`);
//       const data = await res.json();
//       if (res.ok) {
//         setOptions(data);
//       }
//     } catch (err) {
//       console.error('Error fetching options:', err);
//     }
//   }, []);

//   useEffect(() => {
//     fetchOptions();
//     fetchAnimal();
//   }, [fetchOptions, fetchAnimal]);

//   // Check form completion
//   useEffect(() => {
//     if (!form) return;

//     const newCompletion = formSteps.map((step, index) => {
//       switch (step.key) {
//         case 'basic':
//           return !!(form.tag_number && form.breed && form.dob && form.sex);
//         case 'physical':
//           return !!(form.current_weight || form.height || form.color);
//         case 'health':
//           return !!(form.health_status || form.reproductive_status || form.vaccination_status);
//         case 'location':
//           return !!(form.location || form.herd_id);
//         case 'economic':
//           return !!(form.purchase_price || form.estimated_value || form.sire_id || form.dam_id);
//         case 'notes':
//           return !!(form.notes);
//         default:
//           return false;
//       }
//     });

//     setCompletion(newCompletion);
//   }, [form]);

//   // Form handler - useCallback to prevent recreation
//   const handleFormChange = useCallback((e) => {
//     const { name, value, type, checked } = e.target;
    
//     let processedValue = value;
//     if (type === 'number' && value !== '') {
//       processedValue = Number(value);
//     } else if (type === 'checkbox') {
//       processedValue = checked;
//     } else if (value === '') {
//       processedValue = '';
//     }

//     setForm(prev => ({
//       ...prev,
//       [name]: processedValue
//     }));

//     setHasUnsavedChanges(true);

//     // Update animal class when species or sex changes
//     if ((name === 'species' || name === 'sex') && options.animal_classes) {
//       const speciesClasses = options.animal_classes[form.species] || {};
//       const classes = speciesClasses[form.sex] || [];
//       if (classes.length > 0 && !classes.includes(form.animal_class)) {
//         setForm(prev => ({ ...prev, animal_class: classes[0] }));
//       }
//     }
//   }, [options.animal_classes, form.species, form.sex, form.animal_class]);

//   // Auto-save functionality
//   useEffect(() => {
//     if (!editing || !hasUnsavedChanges) return;

//     const autoSaveTimer = setTimeout(() => {
//       if (hasUnsavedChanges) {
//         handleAutoSave();
//       }
//     }, 10000); // Auto-save after 10 seconds of inactivity

//     return () => clearTimeout(autoSaveTimer);
//   }, [form, hasUnsavedChanges, editing]);

//   // Auto-save function - useCallback to prevent recreation
//   const handleAutoSave = useCallback(async () => {
//     if (!hasUnsavedChanges || saving) return;

//     setAutoSaving(true);
//     try {
//       await saveFormData(false); // Silent save without notifications
//       setLastSaved(new Date());
//       setHasUnsavedChanges(false);
//     } catch (error) {
//       console.error('Auto-save failed:', error);
//     } finally {
//       setAutoSaving(false);
//     }
//   }, [hasUnsavedChanges, saving]);

//   // Save form data (used by both manual and auto-save) - useCallback to prevent recreation
//   const saveFormData = useCallback(async (showNotifications = true) => {
//     const submitData = { ...form };
    
//     // Convert empty strings to null
//     Object.keys(submitData).forEach(key => {
//       if (submitData[key] === '') {
//         submitData[key] = null;
//       }
//     });

//     // Convert numeric fields
//     const numericFields = [
//       'birth_weight', 'current_weight', 'height', 'weaning_weight', 'yearling_weight',
//       'purchase_price', 'sale_price', 'estimated_value', 'genetic_score',
//       'number_of_calves', 'lactation_number', 'days_bred', 'days_in_milk',
//       'average_milk_yield', 'total_lifetime_milk', 'sire_id', 'dam_id'
//     ];
    
//     numericFields.forEach(field => {
//       if (submitData[field] !== null && submitData[field] !== '') {
//         submitData[field] = Number(submitData[field]);
//       }
//     });

//     submitData.is_milking_cow = Boolean(submitData.is_milking_cow);

//     const method = isNew ? "POST" : "PUT";
//     const url = isNew ? API_URL : `${API_URL}${id}`;

//     const res = await fetch(url, {
//       method,
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(submitData),
//     });

//     const data = await res.json();
//     if (res.ok) {
//       if (isNew) {
//         navigate(`/animals/${data.animal?.id || id}`);
//         setEditing(false);
//       }
//       setAnimal(data.animal || data);
//       if (showNotifications) {
//         swal("Success", data.message || "Changes saved successfully", "success");
//       }
//       return true;
//     } else {
//       if (showNotifications) {
//         swal("Error", data.error || "Something went wrong", "error");
//       }
//       return false;
//     }
//   }, [form, isNew, id, navigate]);

//   // Manual save section - useCallback to prevent recreation
//   const saveSection = useCallback(async () => {
//     setSaving(true);
//     try {
//       const success = await saveFormData(true);
//       if (success) {
//         setSaveModalOpen(false);
//         setHasUnsavedChanges(false);
//         setLastSaved(new Date());
//       }
//     } catch (err) {
//       console.error('Save error:', err);
//       swal("Error", "Failed to save changes", "error");
//     } finally {
//       setSaving(false);
//     }
//   }, [saveFormData]);

//   // Save and go to next tab - useCallback to prevent recreation
//   const saveAndNext = useCallback(async () => {
//     setSaving(true);
//     try {
//       const success = await saveFormData(true);
//       if (success) {
//         setHasUnsavedChanges(false);
//         setLastSaved(new Date());
//         if (activeTab < tabComponents.length - 1) {
//           setActiveTab(activeTab + 1);
//         }
//       }
//     } catch (err) {
//       console.error('Save error:', err);
//       swal("Error", "Failed to save changes", "error");
//     } finally {
//       setSaving(false);
//     }
//   }, [saveFormData, activeTab]);

//   // Submit for approval - useCallback to prevent recreation
//   const handleSubmitForApproval = useCallback(async () => {
//     const confirm = await swal({
//       title: "Submit for Approval?",
//       text: "This will change the animal status to Active and make it visible to all users",
//       icon: "warning",
//       buttons: true,
//       dangerMode: true,
//     });

//     if (confirm) {
//       setSaving(true);
//       try {
//         const res = await fetch(`${API_URL}${id}/status`, {
//           method: "PUT",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ lifecycle_state: "Active" }),
//         });

//         const data = await res.json();
//         if (res.ok) {
//           setAnimal(prev => ({ ...prev, lifecycle_state: "Active" }));
//           setForm(prev => ({ ...prev, lifecycle_state: "Active" }));
//           swal("Success", "Animal submitted and activated!", "success");
//         } else {
//           swal("Error", data.error, "error");
//         }
//       } catch (err) {
//         swal("Error", "Something went wrong", "error");
//       } finally {
//         setSaving(false);
//         setSaveModalOpen(false);
//       }
//     }
//   }, [id]);

//   // Tab components for EDIT mode - memoized callbacks
//   const tabComponents = [
//     { 
//       label: 'Basic Info', 
//       component: <BasicInfoTab form={form} onFormChange={handleFormChange} options={options} />
//     },
//     { 
//       label: 'Physical Data', 
//       component: <PhysicalTab form={form} onFormChange={handleFormChange} />
//     },
//     { 
//       label: 'Health & Reproductive', 
//       component: <HealthReproductiveTab form={form} onFormChange={handleFormChange} options={options} />
//     },
//     { 
//       label: 'Location & Management', 
//       component: <LocationManagementTab form={form} onFormChange={handleFormChange} />
//     },
//     { 
//       label: 'Economic & Genetic', 
//       component: <EconomicGeneticTab form={form} onFormChange={handleFormChange} />
//     },
//     { 
//       label: 'Additional Info', 
//       component: <NotesTab form={form} onFormChange={handleFormChange} />
//     },
//   ];

//   // View components for READ mode - memoized callbacks
//   const viewComponents = [
//     { 
//       label: 'Basic Info', 
//       component: <BasicInfoView animal={animal} formatDate={formatDate} calculateAge={calculateAge} />
//     },
//     { 
//       label: 'Health & Reproductive', 
//       component: <HealthReproductiveView animal={animal} formatDate={formatDate} />
//     },
//     { 
//       label: 'Location & Management', 
//       component: <LocationManagementView animal={animal} formatDate={formatDate} lastSaved={lastSaved} completion={completion} />
//     },
//     { 
//       label: 'Economic & Genetic', 
//       component: <EconomicGeneticView animal={animal} />
//     },
//     { 
//       label: 'Additional Info', 
//       component: <NotesView animal={animal} />
//     },
//   ];

//   if (loading) {
//     return (
//       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
//         <CircularProgress size={60} sx={{ color: styles.primaryColor }} />
//       </Box>
//     );
//   }

//   const completedCount = completion.filter(Boolean).length;
//   const totalSteps = formSteps.length;
//   const allCompleted = completedCount === totalSteps;

//   return (
//     <Box sx={{ 
//       flexGrow: 1, 
//       minHeight: '100vh',
//       backgroundColor: styles.lightBackground
//     }}>
//       {/* Header */}
//       <AppBar 
//         position="static" 
//         sx={{ 
//           background: styles.sectionGradient,
//           boxShadow: '0 4px 12px rgba(2, 74, 89, 0.15)'
//         }}
//       >
//         <Toolbar>
//           <IconButton
//             edge="start"
//             color="inherit"
//             onClick={() => navigate('/animals')}
//             sx={{ mr: 2 }}
//           >
//             <ArrowBackIcon />
//           </IconButton>
          
//           <Avatar
//             sx={{
//               mr: 2,
//               bgcolor: styles.secondaryColor,
//               width: 44,
//               height: 44,
//               boxShadow: '0 2px 8px rgba(255, 169, 22, 0.3)'
//             }}
//           >
//             {getAnimalAvatar()}
//           </Avatar>
          
//           <Box sx={{ flexGrow: 1 }}>
//             <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold', fontSize: { xs: '1.5rem', md: '2rem' } }}>
//               {isNew ? 'New Animal' : animal?.name || `Animal ${animal?.tag_number}`}
//             </Typography>
//             <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} sx={{ color: 'rgba(255,255,255,0.8)', mt: 0.5 }}>
//               <Link color="inherit" onClick={() => navigate('/animals')} sx={{ cursor: 'pointer', '&:hover': { color: 'white' } }}>
//                 Animals
//               </Link>
//               <Typography color="inherit">
//                 {isNew ? 'New Animal' : animal?.tag_number}
//               </Typography>
//             </Breadcrumbs>
//           </Box>
          
//           {/* Auto-save indicator */}
//           {editing && hasUnsavedChanges && (
//             <Chip 
//               icon={<AutoAwesomeIcon />}
//               label="Unsaved Changes"
//               sx={{ 
//                 backgroundColor: '#ffeb3b',
//                 color: '#333',
//                 fontWeight: 'bold',
//                 mr: 2
//               }}
//             />
//           )}
          
//           {!isNew && animal?.lifecycle_state === 'Draft' && (
//             <Chip 
//               label="DRAFT" 
//               sx={{ 
//                 backgroundColor: styles.secondaryColor,
//                 color: styles.primaryColor,
//                 fontWeight: 'bold',
//                 mr: 2,
//                 boxShadow: '0 2px 4px rgba(255, 169, 22, 0.3)'
//               }}
//             />
//           )}
          
//           {!isNew && !editing && (
//             <Button
//               variant="contained"
//               startIcon={<EditIcon />}
//               onClick={() => setEditing(true)}
//               sx={{ 
//                 backgroundColor: styles.secondaryColor,
//                 color: styles.primaryColor,
//                 fontWeight: 'bold',
//                 boxShadow: '0 2px 8px rgba(255, 169, 22, 0.3)',
//                 '&:hover': {
//                   backgroundColor: '#ffb74d',
//                   boxShadow: '0 4px 12px rgba(255, 169, 22, 0.4)',
//                 }
//               }}
//             >
//               {isMobile ? 'Edit' : 'Edit Animal'}
//             </Button>
//           )}
          
//           {editing && (
//             <>
//               <Button
//                 variant="outlined"
//                 startIcon={<CancelIcon />}
//                 onClick={() => {
//                   if (isNew) {
//                     navigate('/animals');
//                   } else {
//                     setEditing(false);
//                     setForm(animal);
//                     setHasUnsavedChanges(false);
//                   }
//                 }}
//                 sx={{ 
//                   borderColor: 'rgba(255,255,255,0.5)',
//                   color: 'white',
//                   mr: 1,
//                   '&:hover': {
//                     borderColor: 'white',
//                     backgroundColor: 'rgba(255,255,255,0.1)'
//                   }
//                 }}
//               >
//                 {isMobile ? 'Cancel' : 'Cancel'}
//               </Button>
//               <Button
//                 variant="contained"
//                 startIcon={<SaveIcon />}
//                 onClick={() => setSaveModalOpen(true)}
//                 disabled={saving}
//                 sx={{ 
//                   backgroundColor: styles.secondaryColor,
//                   color: styles.primaryColor,
//                   fontWeight: 'bold',
//                   boxShadow: '0 2px 8px rgba(255, 169, 22, 0.3)',
//                   '&:hover': {
//                     backgroundColor: '#ffb74d',
//                     boxShadow: '0 4px 12px rgba(255, 169, 22, 0.4)',
//                   }
//                 }}
//               >
//                 {saving ? 'Saving...' : (isMobile ? 'Save' : 'Save All')}
//               </Button>
//             </>
//           )}
//         </Toolbar>
//       </AppBar>

//       <Container maxWidth="xl" sx={{ py: 3, px: { xs: 2, sm: 3, md: 4 } }}>
//         {/* Progress Stepper - Only show in edit mode */}
//         {editing && (
//           <Paper sx={{ 
//             p: 3, 
//             mb: 3, 
//             boxShadow: styles.cardShadow,
//             background: styles.cardGradient
//           }}>
//             <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
//               <Typography variant="h5" sx={{ color: styles.primaryColor, fontWeight: 'bold' }}>
//                 Completion Progress
//               </Typography>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//                 {autoSaving && (
//                   <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                     <CircularProgress size={16} sx={{ mr: 1 }} />
//                     <Typography variant="body2" color="text.secondary">
//                       Auto-saving...
//                     </Typography>
//                   </Box>
//                 )}
//                 <Chip 
//                   label={`${completedCount}/${totalSteps} completed`}
//                   color={allCompleted ? "success" : "default"}
//                   icon={allCompleted ? <CheckCircleIcon /> : undefined}
//                   sx={{ fontWeight: 'bold' }}
//                 />
//               </Box>
//             </Box>
//             <Stepper activeStep={-1} alternativeLabel>
//               {formSteps.map((step, index) => (
//                 <Step key={step.key} completed={completion[index]}>
//                   <StepLabel 
//                     StepIconComponent={() => (
//                       <Avatar
//                         sx={{
//                           bgcolor: completion[index] ? styles.secondaryColor : 'grey.300',
//                           color: completion[index] ? styles.primaryColor : 'grey.600',
//                           width: 32,
//                           height: 32,
//                           boxShadow: completion[index] ? '0 2px 4px rgba(255, 169, 22, 0.3)' : 'none'
//                         }}
//                       >
//                         {step.icon}
//                       </Avatar>
//                     )}
//                   >
//                     {step.label}
//                   </StepLabel>
//                 </Step>
//               ))}
//             </Stepper>
//           </Paper>
//         )}

//         {/* Main Content */}
//         <Paper sx={{ 
//           boxShadow: styles.cardShadow,
//           background: 'transparent'
//         }}>
//           {editing ? (
//             <>
//               <Tabs
//                 value={activeTab}
//                 onChange={(e, newValue) => setActiveTab(newValue)}
//                 indicatorColor="primary"
//                 textColor="primary"
//                 variant={isMobile ? "scrollable" : "standard"}
//                 scrollButtons={isMobile ? "auto" : false}
//                 sx={{ 
//                   borderBottom: 1, 
//                   borderColor: 'divider',
//                   background: 'white',
//                   '& .MuiTab-root': {
//                     fontWeight: 'bold',
//                     minWidth: { xs: 120, md: 160 }
//                   }
//                 }}
//               >
//                 {tabComponents.map((tab, index) => (
//                   <Tab 
//                     key={index}
//                     label={
//                       <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                         {tab.label}
//                         {completion[index] && (
//                           <CheckCircleIcon sx={{ fontSize: 16, ml: 1, color: 'success.main' }} />
//                         )}
//                       </Box>
//                     }
//                   />
//                 ))}
//               </Tabs>

//               <Box sx={{ 
//                 p: { xs: 2, md: 3 },
//                 background: 'white'
//               }}>
//                 {tabComponents[activeTab].component}
//                 <SaveActions 
//                   onSaveSection={saveSection}
//                   onSaveAndNext={saveAndNext}
//                   saving={saving}
//                   autoSaving={autoSaving}
//                 />
//               </Box>
//             </>
//           ) : (
//             <Box sx={{ p: { xs: 2, md: 3 } }}>
//               {viewComponents.map((section, index) => (
//                 <Box key={index} sx={{ mb: 4 }}>
//                   <Typography 
//                     variant="h5" 
//                     sx={{ 
//                       color: styles.primaryColor,
//                       fontWeight: 'bold',
//                       mb: 3,
//                       pb: 2,
//                       borderBottom: `2px solid ${styles.secondaryColor}`,
//                       background: 'transparent'
//                     }}
//                   >
//                     {section.label}
//                   </Typography>
//                   {section.component}
//                 </Box>
//               ))}
//             </Box>
//           )}
//         </Paper>
//       </Container>

//       {/* Floating Action Button for Mobile */}
//       {!editing && !isNew && (
//         <Fab
//           color="primary"
//           aria-label="edit"
//           sx={{
//             position: 'fixed',
//             bottom: 24,
//             right: 24,
//             display: { xs: 'flex', md: 'none' },
//             backgroundColor: styles.secondaryColor,
//             color: styles.primaryColor,
//             boxShadow: '0 4px 12px rgba(255, 169, 22, 0.3)',
//             '&:hover': {
//               backgroundColor: '#ffb74d',
//               boxShadow: '0 6px 16px rgba(255, 169, 22, 0.4)',
//             }
//           }}
//           onClick={() => setEditing(true)}
//         >
//           <EditIcon />
//         </Fab>
//       )}

//       {/* Save Confirmation Modal */}
//       <Dialog 
//         open={saveModalOpen} 
//         onClose={() => setSaveModalOpen(false)}
//         PaperProps={{ 
//           sx: { 
//             borderRadius: 2,
//             background: styles.cardGradient
//           } 
//         }}
//       >
//         <DialogTitle sx={{ color: styles.primaryColor, fontWeight: 'bold' }}>
//           Save Changes
//         </DialogTitle>
//         <DialogContent>
//           <Typography>
//             {allCompleted && animal?.lifecycle_state === 'Draft' 
//               ? "All sections are complete! You can save changes and submit for approval to activate this animal record."
//               : "Save your changes to this animal record?"}
//           </Typography>
//           {allCompleted && animal?.lifecycle_state === 'Draft' && (
//             <Alert severity="success" sx={{ mt: 2 }}>
//               All required information has been completed. This animal is ready to be activated.
//             </Alert>
//           )}
//         </DialogContent>
//         <DialogActions sx={{ p: 3, gap: 1 }}>
//           <Button 
//             onClick={() => setSaveModalOpen(false)}
//             variant="outlined"
//           >
//             Cancel
//           </Button>
//           <Button 
//             onClick={saveSection}
//             variant="contained"
//             sx={{ 
//               backgroundColor: styles.primaryColor,
//               '&:hover': {
//                 backgroundColor: '#012e39'
//               }
//             }}
//           >
//             Save Only
//           </Button>
//           {allCompleted && animal?.lifecycle_state === 'Draft' && (
//             <Button 
//               onClick={handleSubmitForApproval}
//               variant="contained"
//               sx={{ 
//                 backgroundColor: styles.secondaryColor,
//                 color: styles.primaryColor,
//                 fontWeight: 'bold',
//                 '&:hover': {
//                   backgroundColor: '#ffb74d'
//                 }
//               }}
//             >
//               Save & Activate
//             </Button>
//           )}
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default AnimalDetailPage;